const translations = {
	imports: {
		history: {
			title: "Importações anteriores",
			helper: "Acompanhe os arquivos enviados e os registros criados.",
			loading: "Carregando importações…",
			loadError: "Não foi possível carregar as importações.",
			retry: "Tentar novamente",
			loadMore: "Mostrar importações anteriores",
			empty: "Nenhuma importação anterior nesta área.",
			unnamed: "Arquivo sem nome",
			progress: "Leitura: {{done}} de {{total}} partes concluídas",
			importedCount: "{{count}} registros importados",
			viewRecords: "Ver registros criados",
			animalRecordsUnavailable:
				"As importações antigas guardam o total confirmado, mas não a ligação com cada animal criado.",
			continue: "Abrir importação",
			cancel: "Descartar importação",
			cancelError: "Não foi possível descartar a importação. Tente novamente.",
			cancelTitle: "Descartar esta importação?",
			cancelDescription:
				"O arquivo fica no histórico como cancelado. Os valores ainda não confirmados serão perdidos.",
			keep: "Manter",
			confirmCancel: "Descartar",
			failures: {
				MEDIA_CONTENT_MISMATCH:
					"O conteúdo enviado não corresponde a esta análise. Envie o arquivo correto.",
				TOO_MANY_ROWS:
					"Este arquivo tem mais linhas do que conseguimos ler de uma vez. Divida em arquivos menores ou envie a lista em planilha.",
				UPLOAD_EXPIRED:
					"O envio do arquivo não foi concluído. Tente novamente.",
				NO_DATA:
					"Nenhum dado compatível foi encontrado. O arquivo pode estar ilegível ou não corresponder a este tipo de importação.",
			},
			status: {
				PROCESSING: "Em andamento",
				READY_FOR_REVIEW: "Pronto para revisar",
				FAILED: "Falha na leitura",
				IMPORTED: "Importado",
				CANCELLED: "Cancelado",
			},
		},
		open: {
			title_one:
				"Conclua ou descarte a importação em aberto para enviar um novo arquivo",
			title_other:
				"{{count}} importações em aberto estão bloqueando um novo envio",
			helper_one:
				"Só pode haver uma importação em aberto por vez. Conclua a revisão ou descarte-a se não precisar mais dela. A área de envio aparece logo em seguida.",
			helper_other:
				"Só pode haver uma importação em aberto por vez. Continue a que você precisa e descarte as demais. A área de envio aparece assim que não houver nenhuma em aberto.",
			uploadedAt: "Enviado em {{date}}",
			continueReview: "Continuar revisão",
			viewProgress: "Ver andamento",
			discard: "Descartar",
			discarded: "Importação descartada",
		},
	},
	pwa: {
		updateAvailable: "Nova versão disponível",
		update: "Atualizar",
		updatePendingWork: "Atualizaremos assim que seu trabalho for sincronizado.",
		offlineReady: "Aplicativo pronto para uso offline",
		loading: "Carregando…",
		sessionExpired: "Sessão expirada",
		sessionExpiredDescription:
			"Sua sessão offline expirou. Reconecte-se para continuar.",
		firstUseOffline: "Conecte-se uma vez para começar",
		firstUseOfflineDescription:
			"Entre enquanto estiver conectado para configurar o acesso offline neste dispositivo.",
		installTitle: "Instalar RuralOps",
		installDescription: "Adicione à tela inicial para acesso offline rápido.",
		install: "Instalar",
		offlineAuthSession: "Offline — conectado como {{name}}",
		pendingChanges:
			"Conexão restabelecida — alterações aguardando sincronização: {{count}}.",
	},
	time: {
		now: "agora",
		minutesShort: "{{count}}min",
		hoursShort: "{{count}}h",
		daysShort: "{{count}}d",
	},
	offline: {
		action: {
			unavailable: "Não disponível offline",
			checking: "Verificando a conexão…",
			restored: "Conexão restabelecida — toque novamente para continuar.",
		},
		banner: {
			message: "Você está offline — algumas ações estão desativadas.",
		},
		status: {
			offline: "Offline",
			queued: "Pendentes: {{count}}",
			syncing: "Sincronizando…",
		},
		mutations: {
			queued: "Salvo offline — será sincronizado ao reconectar.",
			willBeLost:
				"Você está offline. Esta alteração não é suportada offline e será perdida se você fechar o aplicativo.",
			enqueueFailed: "Falha ao salvar offline. Reconecte-se e tente novamente.",
		},
		queue: {
			title: "Alterações pendentes",
			syncAll: "Sincronizar tudo",
			syncOne: "Sincronizar",
			discard: "Descartar",
			empty: "Nenhuma alteração pendente.",
			retries: "Tentativas: {{count}}",
			stuck: "Travado",
			kinds: {
				animalsCreate: "Cadastro de animal",
				measurement: "Pesagem",
				operation: "Manejo",
				paddockNote: "Anotação de pasto",
				breakdown: "Aviso de quebra",
				taskDone: "Tarefa concluída",
				manualEntry: "Entrada ou gasto",
				unknown: "Alteração pendente",
			},
		},
		logout: {
			blockedByQueue:
				"Há alterações pendentes ({{count}}). Sincronize ou descarte antes de sair.",
		},
		center: {
			appVersion: { title: "Versão do Aplicativo" },
			connectivity: {
				offline: "Offline",
				online: "Online",
				title: "Conectividade",
			},
			datasets: {
				animals: "Animais",
				herds: "Rebanhos",
				paddocks: "Piquetes",
				equipment: "Equipamentos",
				parts: "Peças",
				tasks: "Tarefas",
				financialCategories: "Categorias financeiras",
				vendors: "Fornecedores",
				vaccinationRules: "Calendário sanitário",
				count: "{{count}} animais",
				estimatedSize: "~{{size}} MB",
				lastSynced: "Sincronizado {{time}}",
				neverSynced: "Nunca sincronizado",
				overCap: "Muitos registros (>10.000) — reduza o tamanho da fazenda",
				availableOffline: "Disponível offline",
				notYetAvailable: "Ainda não disponível offline: {{names}}",
				prepare: "Preparar",
				refresh: "Atualizar",
				title: "Dados Offline",
				scope: {
					allFarms: "Todas as Fazendas",
				},
				unavailable: {
					description:
						"Prepare estes dados na Central Offline enquanto estiver conectado.",
					title: "Não disponível offline",
				},
			},
			prepareAllPartial:
				"{{failed}} de {{total}} fazendas não puderam ser preparadas: {{names}}",
			queue: { title: "Alterações Pendentes" },
			storage: {
				title: "Armazenamento",
				usage: "{{used}} de {{quota}} usados",
			},
			title: "Central Offline",
		},
		datasets: {
			unavailable: {
				description:
					"Conecte-se à internet e prepare os dados offline na Central Offline.",
				title: "Dados não disponíveis offline",
			},
		},
		detail: {
			offlineNote:
				"Exibindo dados offline — o histórico completo fica disponível quando conectado.",
		},
		screen: {
			unavailable: {
				description: "Reconecte-se à internet para continuar.",
				title: "Este recurso requer conexão com a internet",
			},
		},
	},
	auth: {
		signIn: {
			title: "Entrar no RuralOps",
			subtitle: "Acesse sua conta para acompanhar a rotina da fazenda.",
		},
		scene: {
			titleFirst: "Uma plataforma para",
			titleSecond: "operações rurais.",
			description:
				"Rebanho, pastagem, tarefas, máquinas e custos reunidos para você acompanhar a fazenda e decidir com as informações em mãos.",
			photoAlt: "Pasto aberto ao entardecer com um lote de nelore ao fundo",
		},
	},
	footer: {
		copyright: "© {{year}} RuralOps. Todos os direitos reservados.",
		privacyPolicy: "Política de Privacidade",
		termsOfService: "Termos de Serviço",
	},
	pricing: {
		badge: "Preços",
		title: "Escolha o melhor plano para sua fazenda",
		subtitle:
			"Planos que acompanham o crescimento do seu negócio. Comece grátis e mude de plano quando precisar.",
		getStarted: "Começar",
		startFree: "Começar grátis",
		subscribeNow: "Assinar agora",
		perMonth: "/mês",
		perYear: "/ano",
		billedAnnually: "cobrado anualmente",
		billedMonthly: "cobrado mensalmente",
		monthly: "Mensal",
		annual: "Anual",
		save20: "Economize 20%",
		mostPopular: "Mais escolhido",
		benefitsTitle: "Por que escolher o RuralOps?",
		benefits: [
			"Gestão completa da propriedade",
			"Acompanhamento e relatórios em tempo real",
			"Acesso pelo celular onde você estiver",
			"Suporte dedicado",
			"Atualizações regulares e novos recursos",
		],
		contactTitle: "Dúvidas?",
		contactDescription:
			"Nossa equipe está pronta para ajudá-lo a encontrar a melhor solução para sua propriedade.",
		emailSales: "Enviar e-mail",
		whatsappSales: "WhatsApp",
		responseTime: "Geralmente respondemos em até 24 horas",
		faqTitle: "Perguntas frequentes",
		faqDescription:
			"Não encontrou o que procura? Entre em contato com nossa equipe de suporte.",
		contactUs: "Fale Conosco",
		plans: {
			starter: {
				name: "Essencial",
				bestFor: "Pequenas propriedades e quem está começando",
				description: "O básico para organizar a gestão da fazenda",
			},
			professional: {
				name: "Profissional",
				bestFor: "Propriedades em crescimento",
				description: "Gestão completa com apoio da IA",
			},
			enterprise: {
				name: "Empresarial",
				bestFor: "Grandes propriedades e grupos rurais",
				description: "Escala ilimitada com suporte prioritário",
			},
		},
		features: {
			oneEstablishment: "1 fazenda",
			oneUser: "1 usuário",
			upTo50Animals: "Até 50 animais",
			upTo3Establishments: "Até 3 fazendas",
			upTo3Users: "Até 3 usuários",
			upTo200Animals: "Até 200 animais",
			aiPoweredInsights: "Análises com IA",
			emailSupport: "Suporte por e-mail",
			upTo10Users: "Até 10 usuários",
			upTo500Animals: "Até 500 animais",
			prioritySupport: "Suporte prioritário",
		},
		addons: {
			title: "Recursos adicionais",
			subtitle: "Melhore seu plano com recursos adicionais",
			aiOptimizer: {
				name: "Otimizador com IA",
				description:
					"Use a IA para encontrar oportunidades de melhoria na fazenda",
				perMonth: "/mês",
				note: "Disponível para planos Profissional ou Empresarial",
			},
			overage: {
				title: "Amplie seu plano quando precisar",
				animals: {
					title: "Animais Adicionais",
					description: "+{{price}} por {{step}} animais ativos adicionais/mês",
				},
				farms: {
					title: "Fazendas Adicionais",
					description: "+{{price}} por fazenda adicional/mês",
				},
				aiCredits: {
					title: "Ações de IA Extras",
					description:
						"Adicione créditos de IA quando quiser — {{min}} a {{max}}",
				},
			},
		},
		trialAvailable: "{{days}} dias de teste grátis",
		current: "Plano atual",
	},
	browserCompatibility: {
		title: "Navegador Desatualizado Detectado",
		message:
			"Seu navegador pode não suportar todos os recursos desta aplicação. Por favor, atualize seu navegador para uma melhor experiência.",
	},
	selectOrganization: {
		title: "Suas organizações",
		subtitle: "Escolha uma organização para abrir, ou crie uma nova.",
		ownedTitle: "Você é proprietário",
		invitedTitle: "Você foi convidado",
		emptyOwned: "Você ainda não é proprietário de nenhuma organização.",
		emptyInvited:
			"Quando outro proprietário te convidar para a organização dele, ela aparece aqui.",
		selectButton: "Abrir",
		deleteButton: "Excluir organização",
		countLabel_one: "{{count}} organização",
		countLabel_other: "{{count}} organizações",
		explainer: {
			title: "O que é uma organização?",
			definition:
				"Pense na organização como o seu negócio dentro do RuralOps. Ela reúne tudo que faz parte dele: fazendas, rebanho, equipe e financeiro.",
			rule: "Se você tem uma ou várias fazendas no mesmo negócio, todas devem ficar na mesma organização e usar o mesmo plano pago.",
			newOrg:
				"Crie uma nova organização apenas quando forem negócios diferentes, com equipes, contas e pagamentos separados.",
			hide: "Esconder",
			show: "Entenda o que é uma organização",
		},
		status: {
			checking: "Verificando acesso…",
			active: "Ativa",
			trialing: "Teste grátis",
			trialingWithDays_one: "Teste · {{count}} dia restante",
			trialingWithDays_other: "Teste · {{count}} dias restantes",
			setupRequired: "Configuração pendente",
			paymentRequired: "Pagamento pendente",
			pastDue: "Cobrança em atraso",
			inactive: "Inativa",
			awaitingOwner: "Aguardando o proprietário",
			unknown: "Status indisponível",
		},
		action: {
			open: "Abrir",
			choosePlan: "Escolher plano",
			updatePayment: "Atualizar pagamento",
			reactivate: "Reativar",
			awaitingOwner: "Aguarde o proprietário",
		},
		plan: {
			free: "Plano gratuito",
			starter: "Plano Essencial",
			professional: "Plano Profissional",
			enterprise: "Plano Empresarial",
		},
		invitedInfo:
			"A cobrança é responsabilidade do proprietário. Se o acesso ficar bloqueado, peça para ele renovar a assinatura.",
		invitation: {
			pendingBadge: "Convite",
			invitedBy: "Convidado por {{inviterName}}",
			accept: "Aceitar",
			decline: "Recusar",
			accepting: "Aceitando convite…",
			acceptSuccess: "Convite aceito",
			declining: "Recusando convite…",
			declineSuccess: "Convite recusado",
		},
		deleteDialog: {
			title: "Excluir Organização",
			description:
				"Tem certeza que deseja excluir a organização '{{organizationName}}'?",
			irreversibleWarning: "Esta ação é irreversível!",
			dataLossWarning:
				"Todos os dados associados a esta organização serão excluídos permanentemente, incluindo fazendas, rebanho, pastagens, registros financeiros, equipamentos, tarefas, equipe e todos os outros registros.",
			confirmLabel: "Digite '{{organizationName}}' para confirmar:",
			deleting: "Excluindo...",
			confirmButton: "Excluir Organização",
		},
	},
	country: {
		BR: "Brasil",
		PY: "Paraguai",
		UY: "Uruguai",
		AR: "Argentina",
		CL: "Chile",
		BO: "Bolívia",
		CO: "Colômbia",
		US: "Estados Unidos",
	},
	organization: {
		createNew: "Criar organização",
		createDescription:
			"Crie um novo negócio rural no RuralOps — com equipe, registros e assinatura próprios.",
		createExplainer: {
			title: "Antes de continuar",
			definition: "Pense na organização como o seu negócio dentro do RuralOps.",
			contents:
				"É nela que ficam reunidas todas as informações desse negócio: fazendas, rebanho, equipe e financeiro.",
			rule: "Não importa se você tem uma ou dez fazendas. Se todas fazem parte do mesmo negócio, elas devem ficar dentro da mesma organização.",
			billing:
				"Cada organização tem sua própria assinatura, ou seja, o pagamento do plano é feito separadamente para cada uma delas.",
			newOrgWhen:
				"Por isso, crie uma nova organização apenas se você tiver negócios diferentes, com equipes e contas separadas.",
			newOrgWhenNot:
				"Se você está apenas adicionando mais uma fazenda ao negócio que já existe, cadastre essa fazenda na organização atual.",
		},
		name: "Nome da organização",
		nameHelp: "Como o negócio vai aparecer no RuralOps.",
		namePlaceholder: "ex.: Fazenda São Bento",
		description: "Descrição",
		descriptionHelp:
			"Opcional. Uma nota curta para ajudar você a diferenciar organizações.",
		descriptionPlaceholder: "ex.: Pecuária de corte no Mato Grosso",
		country: {
			label: "País",
			placeholder: "Selecione um país",
			help: "Define o país do calendário sanitário da organização. Alterá-lo depois não substitui as regras de vacinação já cadastradas.",
		},
		currency: {
			label: "Moeda financeira",
			placeholder: "Selecione uma moeda",
			brl: "Real Brasileiro (R$)",
			usd: "Dólar Americano ($)",
			warning:
				"Usada apenas nos registros financeiros desta organização (receitas, custos, relatórios). Não pode ser alterada depois, e é diferente de como você paga a assinatura do RuralOps.",
		},
		noOrganizations: "Você ainda não faz parte de nenhuma organização",
		noOrganizationsDescription:
			"Crie sua primeira organização para começar a gerenciar sua operação, ou peça a outro proprietário para te convidar para a dele.",
		createFirst: "Crie sua primeira organização",
		basicInformation: "Informações Básicas",
		current: "Atual",
		noDescription: "Sem descrição",
		leave: "Sair",
		leaveOrganization: "Sair da Organização",
		leaveConfirmation:
			"Tem certeza que deseja sair da organização '{{name}}'? Você perderá acesso a todos os dados.",
		ownerLeaveWarning:
			"Como proprietário, você não pode sair da organização. Transfira a propriedade ou exclua a organização.",
		confirmNameToLeave: "Digite o nome da organização para confirmar",
		typeOrgNameToConfirm:
			"Digite o nome da organização exatamente como mostrado acima",
	},
	orgSettings: {
		title: "Configurações da Organização",
		profile: {
			nameLabel: "Nome da organização",
			namePlaceholder: "Nome da organização",
			nameHelp: "Exibido em todo o aplicativo e no seletor de organizações.",
		},
		validation: {
			nameRequired: "O nome da organização é obrigatório",
			nameTooLong: "O nome da organização deve ter no máximo 100 caracteres",
			descriptionTooLong:
				"A descrição da organização deve ter no máximo 500 caracteres",
		},
		language: {
			selectLanguage: "Selecione um idioma",
		},
		currency: {
			title: "Moeda financeira",
			immutableNote:
				"Usada na gestão financeira da sua fazenda. Definida na criação da organização e não pode ser alterada. Não está relacionada à sua assinatura ou cobrança.",
		},
	},
	notifications: {
		dailyDigest: {
			title: "Resumo diário por e-mail",
			label: "Receber o resumo diário",
			description:
				"Todas as manhãs enviamos um e-mail com o que precisa de atenção na sua fazenda: pesagens e vacinações atrasadas, lotes há muito tempo no mesmo piquete, partos previstos e tarefas vencidas. Se não houver nada pendente, nenhum e-mail é enviado.",
			updateError:
				"Não foi possível atualizar sua preferência. Tente novamente.",
		},
	},
	userSettings: {
		title: "Configurações do Usuário",
		profile: "Perfil",
		profileDescription: "Gerencie suas informações pessoais e preferências",
		organizations: "Organizações",
		organizationsDescription: "Gerencie suas organizações e participações",
		validation: {
			firstNameRequired: "O primeiro nome é obrigatório",
			lastNameRequired: "O sobrenome é obrigatório",
		},
	},
	roles: {
		org_owner: "Proprietário",
		org_administrator: "Administrador",
		org_manager: "Gerente",
		org_medical_professional: "Profissional Médico",
		org_accountant: "Contador",
		org_viewer: "Visualizador",
		descriptions: {
			org_owner: "Dono da Organização",
			org_administrator: "Administrador da Organização",
			org_manager: "Gerente da Organização",
			org_medical_professional: "Profissional Médico",
			org_accountant: "Contador",
			org_viewer: "Visualizador",
		},
	},
	permissions: {
		categories: {
			organization: "Organização",
			staff: "Equipe",
			establishments: "Estabelecimentos",
			customers: "Clientes",
			customerPlans: "Planos",
			medical: "Médico",
			finance: "Financeiro",
			reports: "Relatórios",
			schedules: "Agendas",
			enrollments: "Matrículas",
			attendance: "Presença",
			other: "Outros",
		},
		actions: {
			VIEW_SETTINGS: "Ver configurações",
			MANAGE_SETTINGS: "Gerenciar configurações",
			DELETE_ORGANIZATION: "Excluir organização",
			VIEW_STAFF: "Ver equipe",
			MANAGE_STAFF: "Gerenciar equipe",
			INVITE_STAFF: "Convidar equipe",
			VIEW_PLATFORM_PLAN: "Ver plano da plataforma",
			MANAGE_PLATFORM_PLAN: "Gerenciar plano da plataforma",
			VIEW_ESTABLISHMENTS: "Ver estabelecimentos",
			MANAGE_ESTABLISHMENTS: "Gerenciar estabelecimentos",
			VIEW_ANALYTICS: "Ver análises",
			VIEW_FARMS: "Ver fazendas",
			MANAGE_FARMS: "Gerenciar fazendas",
			VIEW_PADDOCKS: "Ver piquetes",
			MANAGE_PADDOCKS: "Gerenciar piquetes",
			VIEW_CULTIVARS: "Ver cultivares",
			MANAGE_CULTIVARS: "Gerenciar cultivares",
			VIEW_OPERATIONS: "Ver operações",
			CREATE_OPERATIONS: "Criar operações",
			MANAGE_OPERATIONS: "Gerenciar operações",
			VIEW_MEASUREMENTS: "Ver medições",
			CREATE_MEASUREMENTS: "Criar medições",
			MANAGE_MEASUREMENTS: "Gerenciar medições",
			VIEW_PLANS: "Ver planos",
			MANAGE_PLANS: "Gerenciar planos",
			APPROVE_WORK_ORDERS: "Aprovar ordens de serviço",
			VIEW_FORECASTS: "Ver previsões",
			VIEW_RECOMMENDATIONS: "Ver recomendações",
			APPROVE_RECOMMENDATIONS: "Aprovar recomendações",
			VIEW_EQUIPMENT: "Ver equipamentos",
			MANAGE_EQUIPMENT: "Gerenciar equipamentos",
			VIEW_PARTS_INVENTORY: "Ver estoque de peças",
			MANAGE_PARTS_INVENTORY: "Gerenciar estoque de peças",
			PERFORM_INSPECTIONS: "Realizar inspeções",
			REPORT_BREAKDOWNS: "Reportar falhas",
			VIEW_LIVESTOCK: "Ver rebanho",
			VIEW_LIVESTOCK_RECORDS: "Ver registros do rebanho",
			VIEW_LIVESTOCK_MOVEMENTS: "Ver movimentações do rebanho",
			MANAGE_LIVESTOCK: "Gerenciar rebanho",
			VIEW_FEASIBILITY: "Ver viabilidade",
			MANAGE_FEASIBILITY: "Gerenciar viabilidade",
			USE_AI_ASSISTANT: "Usar assistente de IA",
		},
	},
	invitations: {
		emailMismatchTitle: "Email Diferente",
		emailMismatchDescription:
			"Você está logado como {{currentEmail}}, mas este convite foi enviado para {{expectedEmail}}.",
		emailMismatchInstructions:
			"Entre com o e-mail que recebeu o convite para poder aceitá-lo.",
		switchAccount: "Trocar Conta",
		invitationInvalid: "Convite Inválido",
		alreadyAccepted: "Este convite já foi aceito.",
		tokenExpired: "Este convite expirou.",
		tokenRevoked: "Este convite foi revogado.",
		declined: "Você recusou este convite.",
		alreadyMember: "Você já é membro desta organização.",
		invitationNotFound: "Convite não encontrado.",
		goToDashboard: "Ir para o Painel",
		processingInvitation: "Processando Convite",
		pleaseWait: "Por favor, aguarde enquanto processamos seu convite...",
		invitationAccepted: "Convite Aceito!",
		invitationError: "Erro ao Processar Convite",
		invitationDetails: "Detalhes do Convite",
		invitationIntro: "Você foi convidado para participar de uma organização:",
		email: "Email",
		organization: "Conta",
		invitedBy: "Convidado por",
		role: "Função",
		acceptInvitation: "Aceitar Convite",
	},
	onboarding: {
		stepOf: "Passo {{current}} de {{total}}",
	},
	setupGuide: {
		ariaLabel: "Guia de primeiros passos",
		// A página de preparo: uma tela inteira, uma pergunta por vez. Só o que
		// não existe em outro lugar do app mora aqui — título, corpo e ações dos
		// passos continuam vindo de `farmStep`/`recordStep`/`establishments`.
		page: {
			goHome: "Ir para o início",
			eyebrow: "Passo {{current}} de {{total}} · {{status}}",
			farmIntro:
				"Sua organização já foi criada. Nela, você pode cadastrar mais de uma fazenda, por exemplo, se tiver fazendas em cidades diferentes.",
			farmFormBody:
				"Use o nome que você fala no dia a dia. O resto pode ficar para depois.",
			farmSavedTitle: "{{name}} está pronta",
			farmSavedBody:
				"Se você tiver outra fazenda, cadastre agora. Todas ficam reunidas nesta organização.",
			addAnotherFarm: "Cadastrar outra fazenda",
			continueAfterFarms: "Continuar",
		},
		progress_one: "{{count}} de {{total}} passos pronto",
		progress_other: "{{count}} de {{total}} passos prontos",
		later: "Fazer depois",
		steps: {
			ORG_READY: "Conta pronta",
			FARM_CREATED: "Cadastre sua fazenda",
			FIRST_RECORD: "Vamos começar",
			// Quem não pode criar registros lê o mesmo passo sem receber uma
			// ordem impossível: o registro é da fazenda, não dessa pessoa.
			FIRST_RECORD_READ_ONLY: "Primeiro registro da fazenda",
		},
		status: {
			done: "Pronto",
			now: "Agora",
			later: "Depois",
			attention: "Precisa de atenção",
		},
		farmStep: {
			title: "Vamos preparar sua fazenda",
			body: "São poucos passos. Você pode parar e voltar depois.",
			action: "Cadastrar fazenda",
			saved: "Fazenda salva no RuralOps",
			saveFailed:
				"Não foi possível salvar. Confira a internet e tente de novo.",
			planLimitReached:
				"Seu plano atual não permite cadastrar outra fazenda agora. Você pode fazer upgrade a qualquer momento.",
			nextStep: "Próxima etapa",
			noPermission: "Peça a quem cuida da conta para cadastrar a fazenda.",
		},
		// Volta depois de três dias com a fazenda pronta e nenhum registro (§7.7).
		// Tom diferente do mesmo guia: não repete as boas-vindas, não diz que a
		// pessoa está atrasada e não recomeça os três passos.
		returning: {
			title: "Quer continuar de onde parou?",
			body: "Sua fazenda já está cadastrada. Agora escolha o que quer anotar.",
		},
		// Primeira tela de quem entrou por convite (§17, fase 6). Diz o nome do
		// lugar, quem convidou e o que a pessoa pode fazer — sempre em palavras
		// do dia a dia, nunca com o nome interno de um cargo ou permissão (§8).
		invited: {
			title: "Você entrou em {{name}}",
			titleGeneric: "Você entrou nesta conta",
			invitedBy: "{{name}} convidou você.",
			scopeTitle: "Aqui você pode:",
			scope: {
				LIVESTOCK: "Cadastrar animais",
				FINANCE: "Anotar entradas e gastos",
				PLANNING: "Criar tarefas",
				PASTURE: "Cadastrar piquetes",
				EQUIPMENT: "Cadastrar máquinas",
			},
			scopeReadOnly: "Ver os dados da fazenda.",
			moreOptions: "Ver outras opções",
		},
		helpStep: {
			title: "A ajuda está sempre por perto",
			body: "Depois desta configuração, use o botão Ajuda destacado no canto superior direito sempre que precisar de orientação ou quiser falar conosco.",
			guidesTitle: "Encontre respostas",
			guidesBody: "Consulte guias práticos que mostram como usar o RuralOps.",
			feedbackTitle: "Envie sua opinião",
			feedbackBody:
				"Em Ajuda, acesse Suporte para enviar uma sugestão, solicitação ou reclamação como chamado e acompanhar a resposta.",
			feedbackCommitment:
				"Sua opinião é muito importante para nós. Analisamos sugestões e reclamações e as consideramos ao melhorar o RuralOps.",
			continue: "Vamos começar",
		},
		homeTour: {
			progress: "{{current}} de {{total}}",
			skip: "Pular tour",
			next: "Próximo",
			done: "Começar a explorar",
			steps: {
				farmSelector: {
					title: "Seletor de fazenda",
					body: "Use este seletor para escolher em qual fazenda você está trabalhando. Selecione uma fazenda para filtrar painéis e registros ou Todas as fazendas para ver toda a organização.",
				},
				paddocks: {
					title: "Piquetes",
					body: "Planeje e mapeie piquetes, registre medições de forragem e acompanhe as rotações de pastejo. Use esta área para organizar as condições do pasto e os trabalhos de campo ao longo do tempo.",
				},
				livestock: {
					title: "Rebanho",
					body: "Gerencie animais e lotes, incluindo pesagens, manejos sanitários, movimentações e vendas. Cada registro forma um histórico confiável para acompanhar o desempenho e tomar decisões no dia a dia.",
				},
				planning: {
					title: "Planejamento",
					body: "Transforme os objetivos da fazenda em tarefas práticas, defina prazos e distribua o trabalho para a equipe. Acompanhe o progresso para manter visíveis as atividades próximas e atrasadas.",
				},
				financial: {
					title: "Financeiro",
					body: "Registre receitas e despesas, gerencie contas a pagar e receber, folha e categorias e analise os resultados da fazenda. As telas compatíveis seguem a fazenda selecionada acima.",
				},
				settings: {
					title: "Configurações",
					body: "Configure fazendas, gerencie a equipe, ajuste preferências do rebanho e conecte integrações. Aqui você também mantém os dados da organização e as regras de acesso.",
				},
				help: {
					title: "Ajuda",
					body: "Abra a Ajuda para consultar guias passo a passo sobre os recursos do RuralOps. Use o Suporte para tirar dúvidas, relatar problemas ou enviar sugestões e acompanhar a resposta.",
				},
			},
		},
		recordStep: {
			title: "O que você quer fazer primeiro?",
			body: "Escolha uma opção. Você pode fazer outra coisa depois.",
			// Quem não pode criar registros nunca lê uma pergunta que não tem
			// resposta possível: o passo vira leitura, e o guia ainda termina
			// quando um colega anota algo (§7.3, fase 6).
			readOnly: {
				title: "Veja os dados da sua fazenda",
				body: "Quando alguém da equipe anotar algo, aparece aqui.",
			},
			actions: {
				LIVESTOCK: {
					label: "Cadastrar um animal",
					help: "Comece com um animal da fazenda.",
				},
				FINANCE: {
					label: "Anotar entrada ou gasto",
					help: "Guarde um valor que entrou ou saiu.",
				},
				PLANNING: {
					label: "Criar uma tarefa",
					help: "Anote um serviço que precisa ser feito.",
				},
				PASTURE: {
					label: "Cadastrar um piquete",
					help: "Comece a organizar a área de pasto.",
				},
				EQUIPMENT: {
					label: "Cadastrar uma máquina",
					help: "Adicione uma máquina da fazenda.",
				},
				import: "Já tenho uma lista pronta",
				readOnly: {
					body: "Você ainda não pode criar registros nesta fazenda.",
					action: "Ver os dados da fazenda",
				},
			},
			// Someone who has no list to import still has a first record to
			// make: this hands step 3 back to the other options, it never leaves
			// the guide.
			importPrompt: {
				title: "Você já tem uma lista de animais?",
				body: "Você pode importar uma planilha .xlsx ou .csv, um PDF ou uma foto (JPEG, PNG ou WebP). Antes de salvar, você poderá conferir tudo.",
				importNow: "Importar uma lista agora",
				notNow: "Agora não",
			},
			importSkipLater:
				"Você pode importar depois em Rebanho › Importar animais.",
			farmPicker: {
				title: "Em qual fazenda?",
				body: "Escolha a fazenda deste registro.",
				cancel: "Voltar",
			},
		},
		minimized: {
			title: "Configuração pausada",
			reopen: "Voltar à configuração",
			dismiss: "Esconder guia",
		},
		recap: {
			title: "Primeiros passos concluídos",
			body: "Você já cadastrou a fazenda e salvou o primeiro registro.",
			hide: "Esconder guia",
		},
		success: {
			title: "Primeiro registro salvo",
			body: "Agora o RuralOps já tem dados reais da sua fazenda.",
			close: "Fechar guia",
			notConfirmedYet:
				"Ainda estamos confirmando o registro. Tente de novo em instantes.",
			closeFailed: "Não foi possível fechar agora. Tente de novo.",
			proof: {
				LIVESTOCK: "Os animais já aparecem no cadastro.",
				FINANCE: "A entrada ou o gasto já aparece no financeiro.",
				PLANNING: "A tarefa já aparece no planejamento.",
				PASTURE: "O piquete já aparece na área de pasto.",
				EQUIPMENT: "A máquina já aparece na frota.",
			},
			view: {
				LIVESTOCK: "Ver animais",
				FINANCE: "Ver financeiro",
				PLANNING: "Ver planejamento",
				PASTURE: "Ver pastos",
				EQUIPMENT: "Ver máquinas",
			},
		},
	},
	errors: {
		generic_Title:
			"Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.",
		generic_Message:
			"Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.",
		no_subscription_title: "Nenhuma assinatura ativa encontrada",
		no_subscription_message:
			"Você precisa de uma assinatura ativa para acessar o aplicativo. Por favor, renove sua assinatura ou entre em contato com o suporte.",
		subscription_inactive_title: "A assinatura não está ativa",
		subscription_inactive_description:
			"Sua assinatura não está ativa. Por favor, renove sua assinatura ou entre em contato com o suporte.",
		notFound_Title: "Página não encontrada",
		notFound_Message:
			"Desculpe, a página que você está procurando não foi encontrada.",
		forbidden_Title: "Acesso negado",
		forbidden_Message: "Você não tem permissão para acessar esta página.",
		serverError_Title: "Erro do Servidor",
		serverError_Message:
			"Ocorreu um erro no servidor. Por favor, tente novamente mais tarde.",
		networkError_Title: "Erro de Rede",
		networkError_Message:
			"Ocorreu um erro de rede. Por favor, verifique sua conexão e tente novamente.",
		api: {
			UNAUTHORIZED: "Seu acesso não está autorizado. Entre novamente.",
			VALIDATION_ERROR: "Os dados enviados são inválidos.",
			PARSE_ERROR:
				"Não foi possível ler a requisição. Por favor, tente novamente.",
			PERMISSION_DENIED: "Você não tem permissão para esta ação.",
			LIMIT_EXCEEDED:
				"Você atingiu o limite do seu plano. Escolha um plano com mais capacidade.",
			LLM_QUOTA_BLOCKED:
				"Você atingiu o limite de análises por IA. Envie sem analisar ou escolha um plano com mais capacidade.",
			NOT_FOUND: "O recurso solicitado não foi encontrado.",
			CONFLICT: "Esta ação conflita com dados existentes.",
			DUPLICATE: "Este registro já existe.",
			INACTIVE_HERD:
				"Este lote está inativo e não recebe novos animais ou registros. Escolha um lote ativo ou deixe o lote em branco.",
			MARKETPLACE_ANIMAL_ALREADY_LISTED:
				"Um ou mais destes animais já estão em outra oferta ativa. Cancele essa oferta ou retire os animais e tente novamente.",
			INTERNAL_ERROR: "Algo deu errado. Por favor, tente novamente mais tarde.",
			NO_SUBSCRIPTION:
				"Você precisa de uma assinatura ativa para realizar esta ação.",
			SUBSCRIPTION_INACTIVE:
				"Sua assinatura não está ativa. Por favor, renove-a.",
			TRIAL_EXPIRED:
				"Seu período de teste terminou. Escolha um plano para continuar.",
			PLAN_TIER_INSUFFICIENT:
				"Este recurso não está incluído no seu plano atual. Escolha outro plano para usá-lo.",
			FEATURE_NOT_ENABLED: "Este recurso não está habilitado para o seu plano.",
			// Códigos de propostas do assistente: aparecem tanto no slot
			// `root.server` do formulário (edição de um item) quanto no aviso de
			// conflito do cartão, então os dois dizem o mesmo sobre o mesmo código.
			PROPOSAL_EXPIRED: "Esta proposta expirou e não pode mais ser alterada.",
			PROPOSAL_INVALID_PAYLOAD:
				"Estes valores não correspondem ao que este tipo de alteração aceita.",
			PROPOSAL_EXECUTION_FAILED:
				"Uma alteração não pôde ser aplicada, então nada foi gravado.",
			PROPOSAL_TARGET_CHANGED:
				"O registro que esta alteração edita foi modificado por outra pessoa.",
			PROPOSAL_ACTION_DISABLED:
				"Este tipo de alteração está desativado no momento.",
			PROPOSAL_GROUP_INDIVISIBLE:
				"Estas alterações são aplicadas juntas — descarte o grupo inteiro.",
			PROPOSAL_LAST_ITEM:
				"Esta é a única alteração restante. Rejeite o cartão em vez de descartá-la.",
			PROPOSAL_LIMIT_EXCEEDED:
				"Este cartão ultrapassaria o limite do seu plano.",
			// Salvamento BYOK: os dados estavam corretos, quem recusou foi o
			// provedor. Diz quem recusou e o que resolve — nunca repete o texto do
			// provedor nem a chave.
			PROVIDER_REJECTED_KEY:
				"O provedor recusou esta chave de API. Verifique se ela está vigente, não foi revogada e tem as permissões que esta organização precisa.",
		},
		offlineReplay: {
			networkError: "Ainda offline — será sincronizado quando conectar.",
			versionMismatch:
				"Esta alteração está desatualizada e não pode ser sincronizada. Descarte-a e tente novamente.",
			unknownKey:
				"Esta alteração não pode ser sincronizada. Descarte-a e tente novamente.",
		},
	},
	pagination: {
		itemsPerPage: "Itens por página",
		pageOfTotal: "Página {{page}} de {{total}}",
		noItems: "Nenhum item",
		showingItems: "Exibindo {{start}} a {{end}} de {{total}} itens",
	},
	settings: {
		aiKeys: {
			tabLabel: "Chaves de IA",
			title: "Chaves de Provedores de IA",
			description:
				"Conecte sua própria chave de API do provedor (BYOK). O uso na sua chave é cobrado diretamente pelo provedor e não conta no orçamento de IA do seu plano. As chaves são criptografadas e nunca exibidas novamente — apenas os 4 últimos dígitos.",
			providers: {
				openai: "OpenAI",
			},
			keyOnFile: "Chave cadastrada",
			noKey: "Nenhuma chave definida — usando a chave da plataforma.",
			// A chave está salva mas o provedor a rejeitou em execução, então a
			// cobrança voltou para a chave da plataforma. Sem isto o cartão mostra
			// "chave cadastrada" em verde e o dono nunca descobre.
			keyRejected: "Chave rejeitada pelo provedor",
			keyRejectedBody:
				"O provedor recusou esta chave ao atender uma requisição, então ela não está mais em uso e o consumo de IA está sendo cobrado do orçamento do seu plano.",
			keyRejectedSince: "Rejeitada em {{date}}",
			remediation: {
				RESAVE_KEY:
					"Cole uma chave válida abaixo e salve — isso a restabelece imediatamente.",
			},
			addLabel: "Chave de API",
			replaceLabel: "Substituir chave de API",
			test: "Testar",
			testing: "Testando chave…",
			testValid: "A chave de API é válida.",
			testInvalid: "A chave de API é inválida ou inacessível.",
			saveSuccess: "Chave de API salva.",
			deleteSuccess: "Chave de API removida.",
			securityNote:
				"Sua chave é criptografada e armazenada com segurança. Ela nunca é registrada em logs nem exibida novamente.",
		},
	},
	forms: {
		validation: {
			required: "Campo obrigatório",
			invalidNumber: "Informe um número válido",
			wholeNumber: "Informe um número inteiro",
			invalidEmail: "Informe um e-mail válido",
			exceedsOutstanding: "O valor excede o saldo em aberto",
			mustBePositive: "Informe um valor maior que 0",
			mustBeNonNegative: "Informe um valor igual ou maior que 0",
			percentRange: "Informe um valor entre 0 e 100",
			dayOfMonthRange: "Informe um dia entre 1 e 31",
			daysWorkedRange: "Informe entre 0 e 31 dias",
			invalidDate: "Informe uma data válida",
			dateInFuture: "A data não pode ser futura",
			minItems: "Adicione ao menos a quantidade exigida de itens",
			maxItems: "Itens demais",
			serverError: "Não foi possível salvar. Tente novamente.",
		},
		draft: {
			restoreTitle: "Rascunho encontrado",
			restoreDescription:
				"Você tem alterações não salvas neste formulário. Deseja restaurá-las?",
			restore: "Restaurar",
			discard: "Descartar",
		},
		confirmDestructive: {
			typeToConfirm: "Digite {{name}} para confirmar",
		},
	},
	common: {
		brStates: {
			AC: "Acre",
			AL: "Alagoas",
			AP: "Amapá",
			AM: "Amazonas",
			BA: "Bahia",
			CE: "Ceará",
			DF: "Distrito Federal",
			ES: "Espírito Santo",
			GO: "Goiás",
			MA: "Maranhão",
			MT: "Mato Grosso",
			MS: "Mato Grosso do Sul",
			MG: "Minas Gerais",
			PA: "Pará",
			PB: "Paraíba",
			PR: "Paraná",
			PE: "Pernambuco",
			PI: "Piauí",
			RJ: "Rio de Janeiro",
			RN: "Rio Grande do Norte",
			RS: "Rio Grande do Sul",
			RO: "Rondônia",
			RR: "Roraima",
			SC: "Santa Catarina",
			SP: "São Paulo",
			SE: "Sergipe",
			TO: "Tocantins",
		},
		appName: "RuralOps",
		loading: "Carregando...",
		notApplicable: "N/D",
		noData: "Nenhum dado disponível",
		error: "Ocorreu um erro",
		save: "Salvar",
		status: "Status",
		createdAt: "Criado em",
		updatedAt: "Atualizado em",
		saving: "Salvando...",
		saveSuccess: "Salvo com sucesso!",
		saveChanges: "Salvar Alterações",
		cancel: "Cancelar",
		delete: "Excluir",
		confirmDeleteWord: "excluir",
		deleteSuccess: "Excluído com sucesso!",
		deleteError: "Falha ao excluir. Por favor, tente novamente.",
		home: "Início",
		about: "Sobre",
		sectionInfo: "Sobre esta seção",
		pricing: "Preços",
		accessApp: "Acessar App",
		settings: "Configurações",
		theme: "Tema",
		edit: "Editar",
		expand: "Expandir",
		collapse: "Recolher",
		modules: "Módulos",
		account: "Conta",
		manageAccount: "Gerenciar conta",
		preferences: "Preferências",
		editObjective: "Editar Objetivo",
		yearCannotBeChanged: "O ano não pode ser alterado após a criação",
		dashboard: "Painel",
		establishments: "Fazendas",
		organizationId: "ID da organização",
		copyId: "Copiar ID",
		idCopied: "ID copiado",
		idCopyFailed: "Não foi possível copiar o ID",
		staff: "Equipe",
		inviteNew: "Convidar Novo",
		role: "Função",
		calendarView: "Visualização de Calendário",
		listView: "Visualização de Lista",
		kanbanView: "Visualização Kanban",
		draft: "Rascunho",
		approved: "Aprovado",
		in_progress: "Em Progresso",
		completed: "Concluído",
		scheduled: "Agendado",
		cancelled: "Cancelado",
		member: "Membro",
		active: "Ativo",
		inactive: "Inativo",
		pending: "Pendente",
		joinedAt: "Juntou-se em",
		create: "Criar",
		sendInvite: "Enviar Convite",
		switch: "Trocar",
		switchOrganization: "Trocar Organização",
		manageSubscription: "Gerenciar Assinatura",
		contactSupport: "Contato com o Suporte",
		startDate: "Data de Início",
		endDate: "Data de Término",
		currentPlan: "Plano Atual",
		currentPeriod: "Período Atual",
		renewsOn: "Renova em",
		daysRemaining: "Dias Restantes",
		endsOn: "Termina em",
		willCancelOn: "Cancelará em {{date}}",
		days: "dias",
		unlimited: "Ilimitado",
		used: "Usado",
		availablePlans: "Planos Disponíveis",
		permissions: "Permissões",
		organizationRole: "Função na Organização",
		organizationRoleDescription: "A função que você tem na organização",
		months: "meses",
		year: "Ano",
		years: "anos",
		viewBoard: "Quadro",
		viewList: "Lista",
		viewCalendar: "Calendário",
		viewObjectives: "Objetivos",
		noItems: "Nenhum item",
		noTasksThisMonth: "Nenhuma tarefa neste mês",
		monthly: "Mensal",
		yearly: "Anual",
		yearlyDiscount: "{{percent}}% de desconto",
		renewSubscription_title: "Gerenciamento de Assinatura",
		general: "Geral",
		subscription: "Assinatura",
		choosePlanDescription:
			"Escolha um plano para desbloquear todas as funcionalidades e gerenciar sua fazenda.",
		enterprise: "Empresarial",
		professional: "Profissional",
		starter: "Essencial",
		free: "Gratuito",
		partner_basic: "Parceiro Básico",
		createSuccess: "Criado com sucesso!",
		createError: "Falha ao criar. Por favor, tente novamente.",
		creating: "Criando...",
		update: "Atualizar",
		updateSuccess: "Atualizado com sucesso!",
		updateError: "Falha ao atualizar. Por favor, tente novamente.",
		updating: "Atualizando...",
		editTask: "Editar Tarefa",
		priority: "Prioridade",
		adding: "Adicionando...",
		assigning: "Atribuindo...",
		search: "Buscar",
		clear: "Limpar",
		searchPageOnly:
			"A busca filtra apenas a página carregada — use a paginação para ver mais.",
		noResults: "Nenhum resultado encontrado",
		defaultLanguage: "Idioma Padrão",
		emailLanguageNote:
			"O idioma selecionado aqui será usado nas comunicações por e-mail.",
		language: "Idioma",
		minutes: "minutos",
		month: "mês",
		actions: "Ações",
		open: "Aberto",
		closed: "Fechado",
		close: "Fechar",
		on: "LIGADO",
		off: "DESLIGADO",
		view: "Visualizar",
		previous: "Anterior",
		next: "Próximo",
		showing: "Exibindo",
		of: "de",
		entries: "entradas",
		page: "Página",
		noSearchResults: "Nenhum resultado encontrado para sua busca",
		deleting: "Excluindo...",
		back: "Voltar",
		pullToRefresh: "Puxe para atualizar",
		releaseToRefresh: "Solte para atualizar",
		refreshing: "Atualizando...",
		typeToConfirm: "Digite '{{word}}' para confirmar:",
		typeWord: "Digite '{{word}}'",
		plan: "Plano",
		filter: "Filtrar",
		show: "Mostrar",
		add: "Adicionar",
		hide: "Ocultar",
		continue: "Continuar",
		goHome: "Ir para Início",
		filters: "Filtros",
		apply: "Aplicar",
		reset: "Redefinir",
		signIn: "Entrar",
		signOut: "Sair da Conta",
		signUp: "Criar Conta",
		dontHaveAccount: "Não tem uma conta?",
		alreadyHaveAccount: "Já tem uma conta?",
		total: "Total",
		signInRequired: "Você precisa estar logado para visualizar esta página",
		signInRequiredDescription: "Entre para continuar",
		learnMore: "Saiba mais",
		comingSoon: "Em breve",
		viewAll: "Ver Tudo",
		underDevelopment: "Em Desenvolvimento",
		underDevelopmentDescription:
			"Esta funcionalidade está sendo desenvolvida. Volte em breve!",
		contact: "Contato",
		date: "Data",
		notes: "Notas",
		noDescription: "Sem descrição",
		name: "Nome",
		firstName: "Primeiro Nome",
		lastName: "Sobrenome",
		description: "Descrição",
		address: "Endereço",
		phone: "Telefone",
		email: "Email",
		success: "Sucesso",
		removing: "Removendo...",
		sending: "Enviando...",
		leaving: "Saindo...",
		leaveSuccess: "Saiu com sucesso!",
		leaveError: "Falha ao sair. Por favor, tente novamente.",
		revoking: "Revogando...",
		retry: "Tentar novamente",
		loadFailed: "Não foi possível carregar",
		loadFailedDescription: "Verifique sua conexão e tente novamente.",
		refresh: "Atualizar",
		refreshFailedShowingSaved:
			"Não foi possível atualizar — exibindo dados salvos",
		tabNavigation: "Navegação por abas",
		pleaseSpecify: "Por favor, especifique...",
		profileInformation: "Informações do Perfil",
		accountInformation: "Informações da Conta",
		viewYourAccountDetails: "Visualize suas informações de conta",
		updateYourPersonalInformation: "Atualize suas informações pessoais",
		userId: "ID do Usuário",
		memberSince: "Membro desde",
		lastSignIn: "Último login",
		never: "Nunca",
		select: "Selecionar",
		required: "Obrigatório",
		optional: "Opcional",
		yes: "Sim",
		no: "Não",
		emailCannotBeChanged: "O email não pode ser alterado",
		all: "Todos",
		dismiss: "Dispensar",
		selectAll: "Selecionar Todos",
		selectedCount: "Selecionados: {{count}}",
		deselectAll: "Desmarcar Todos",
		sortByName: "Ordenar por Nome",
		sortByPrice: "Ordenar por Preço",
		sortBySessions: "Ordenar por Sessões",
		showingResults: "Mostrando {{count}} de {{total}} resultados",
		showMore: "Mostrar Mais",
		showLess: "Mostrar Menos",
		// Shared entity-list kit (components/list): table, phone list, toolbar,
		// sort sheet and bulk-action bar.
		list: {
			selectAll: "Selecionar todos",
			select: "Selecionar",
			cancelSelect: "Cancelar seleção",
			clearSelection: "Limpar seleção",
			selectedCount_one: "{{count}} selecionado",
			selectedCount_other: "{{count}} selecionados",
			sortBy: "Ordenar por {{column}}",
			sortAction: "Ordenar",
			sortSheetTitle: "Ordenar por",
			sortSheetDescription:
				"Escolha a coluna que ordena a lista. Tocar na opção já ativa inverte o sentido.",
			ascending: "crescente",
			descending: "decrescente",
			showingRange: "Mostrando {{from}}–{{to}} de {{total}}",
			showMore: "Ver mais {{count}}",
			showAll: "Ver todos os {{count}}",
			densityComfortable: "Linhas confortáveis",
			densityCompact: "Linhas compactas",
			clearSearch: "Limpar busca",
		},
		remaining: "restantes",
		remove: "Remover",
		createSchedule: "Novo Horário",
		selectSchedules: "Selecione os Horários",
		selectSchedulesEnrollmentDescription:
			"Selecione um ou mais horários para esta matrícula",
		existingSchedules: "Horários Existentes",
		noSchedules: "Nenhum horário encontrado",
		noSchedulesDescription: "Nenhum horário encontrado. Crie um novo?",
		establishment: "Fazenda",
		planning: "Planejamento",
		grassProduction: "Pastagem",
		feasibilityAnalysis: "Análise de Viabilidade",
		selectEstablishment: "Selecione a Fazenda",
		group: "Grupo",
		current: "Atual",
		individual: "Individual",
		time: "Horário",
		enrollments: "Matrículas",
		schedule: "Horário",
		schedules: "Horários",
		weeklySessionsLimit: "Limite de Sessões Semanais",
		price: "Preço",
		monthlyAverage: "Média Mensal",
		billingCycle: "Ciclo de Pagamento",
		features: "Recursos",
		type: "Tipo",
		period: "Período",
		to: "para",
		monday: "Segunda-feira",
		tuesday: "Terça-feira",
		wednesday: "Quarta-feira",
		thursday: "Quinta-feira",
		friday: "Sexta-feira",
		saturday: "Sábado",
		sunday: "Domingo",
		monday_short: "Seg",
		tuesday_short: "Ter",
		wednesday_short: "Qua",
		thursday_short: "Qui",
		friday_short: "Sex",
		saturday_short: "Sáb",
		sunday_short: "Dom",
		mon_short_1: "Jan",
		mon_short_2: "Fev",
		mon_short_3: "Mar",
		mon_short_4: "Abr",
		mon_short_5: "Mai",
		mon_short_6: "Jun",
		mon_short_7: "Jul",
		mon_short_8: "Ago",
		mon_short_9: "Set",
		mon_short_10: "Out",
		mon_short_11: "Nov",
		mon_short_12: "Dez",
		createNew: "Criar Novo",
		basicInfo: "Informações Básicas",
		location: "Localização",
		descriptionPlaceholder: "Digite a descrição...",
		addressPlaceholder: "Digite o endereço...",
		phonePlaceholder: "Digite o número de telefone...",
		emailPlaceholder: "Digite o endereço de email...",
		namePlaceholder: "Digite o nome...",
		overview: "Visão Geral",
		quickActions: "Ações Rápidas",
		items: "itens",
		more: "mais",
		today: "Hoje",
		yesterday: "Ontem",
		last7Days: "Últimos 7 dias",
		older: "Mais antigos",
		confirmDelete: "Confirmar Exclusão",
		deleteConfirmDescription:
			"Tem certeza que deseja excluir este item? Esta ação não pode ser desfeita.",
		none: "Nenhum",
		// Planning section translations
		planningDescription: "Gerencie seus objetivos, planos táticos e tarefas",
		objectives: "Objetivos",
		objectivesDescription: "Gerencie seus objetivos anuais e táticos",
		objectivesEmpty: "Nenhum objetivo ainda",
		objectivesEmptyDescription:
			"Crie seu primeiro objetivo para começar a planejar suas atividades.",
		createFirstObjective: "Criar Primeiro Objetivo",
		createObjective: "Criar Objetivo",
		createObjectiveDescription: "Defina metas anuais e táticas",
		tasks: "Tarefas",
		tasksEmpty: "Nenhuma tarefa encontrada",
		tasksDescription:
			"Visualize e gerencie suas tarefas em todas as visualizações",
		createTask: "Criar Tarefa",
		createTaskDescription: "Gerencie e acompanhe o progresso das tarefas",
		objective: "Objetivo",
		selectObjective: "Selecionar Objetivo",
		title: "Título",
		scheduledDate: "Data Agendada",
		activeObjectives: "Objetivos Ativos",
		pendingTasks: "Tarefas Pendentes",
		completedThisMonth: "Concluídas Este Mês",
		calendarDescription: "Visualize tarefas agendadas no calendário",
		selectEstablishmentPrompt: "Selecione uma fazenda para visualizar tarefas",
		allEstablishments: "Todas as Propriedades",
		allFarms: "Todas as Fazendas",
		allFarmsCount: "Todas as Fazendas ({{count}})",
		farmsCount: "{{count}} fazendas",
		viewFarmDashboard: "Abrir painel completo",
	},
	navigation: {
		groups: {
			myFarm: "Minha Fazenda",
			management: "Gestão",
			ai: "IA",
		},
		settings: "Configurações",
		help: "Ajuda",
		more: "Mais",
		synced: "Sincronizado",
		capture: "Registrar",
		captureDescription: "O que você quer registrar?",
		captureFinancial: "Financeiro",
		captureManualEntry: "Lançamento",
		captureScanReceipt: "Escanear nota",
		capturePlanning: "Planejamento",
		captureLivestock: "Rebanho",
		captureLivestockRecords: "Registros de Rebanho",
		captureAllRecordTypes: "Todos os tipos…",
		captureEquipmentMedia: "Equipamentos e Mídia",
		registerAnimal: "Registrar Animal",
		createHerd: "Criar Lote",
		addEquipment: "Adicionar Equipamento",
		takePhoto: "Tirar Foto",
		photoQuestion: "Do que é esta foto?",
		photoAnimal: "Animal",
		photoPaddock: "Piquete",
		photoEquipment: "Equipamento",
		selectFarm: "Selecione a fazenda",
		selectFarmDescription: "Escolha a fazenda para adicionar",
		selectRecordTarget: "Selecione o lote ou animal",
		selectRecordTargetHerd: "Selecione o lote",
		selectRecordTargetDescription: "Escolha para quem é este registro",
		searchRecordTarget: "Buscar lotes e animais…",
		searchRecordTargetHerd: "Buscar lotes…",
		recordTargetEmpty: "Nenhum resultado encontrado",
		home: "Início",
		plan: "Planos",
		livestock: "Rebanho",
	},
	dashboard: {
		summaryPill: {
			farms_one: "fazenda",
			farms_other: "fazendas",
			head_one: "cabeça",
			head_other: "cabeças",
			ha: "ha",
		},
		paddocks: {
			title: "Piquetes",
			helpLabel: "Entender os indicadores dos piquetes",
			help: "Cabeças (cab.): animais ativos dos lotes que estão no piquete. O número ao lado de cada lote mostra suas cabeças.\nÁrea (ha): tamanho cadastrado do piquete em hectares.\nUA (Unidade Animal): equivale a 450 kg de peso vivo e permite comparar a lotação de animais com pesos diferentes. Um animal de 450 kg representa 1 UA; um de 225 kg representa 0,5 UA.\nLotação (UA/ha): soma dos pesos disponíveis ou estimados dos animais, dividida por 450 kg e pela área do piquete. Por exemplo, 10 UA em 5 ha = 2 UA/ha.",
			count_one: "{{count}} piquete",
			count_other: "{{count}} piquetes",
			onGrass: "{{onGrass}} de {{total}} cabeças no pasto",
			couldNotLoad:
				"Não foi possível carregar os piquetes agora. O resto da página está atualizado.",
			viewAll: "Ver todos os piquetes",
			headEyebrow: "cab.",
			outsideAnyPaddock: "Fora de qualquer piquete",
			assignThem: "Alocar animais",
			legendInHerd: "Em lote · {{count}}",
			showing: "Mostrando {{shown}} de {{total}}",
			daysOnPasture_one: "{{count}} dia",
			daysOnPasture_other: "{{count}} dias",
			emptyTitle: "Nenhum piquete ainda",
			emptyBody:
				"Cadastre um piquete com a área e depois coloque um lote nele.",
			emptyAction: "Cadastrar piquete",
		},
		attention: {
			title: "O que precisa de você hoje",
			sortedBy: "Ordenado pelo tempo de espera",
			tileAria: "{{count}} {{label}}, ver lista",
			seeEveryItem: "Ver todos os itens ({{count}})",
			allClear:
				"Nada esperando por você. Novos alertas aparecem aqui conforme os registros entram.",
			farmsAffected_one: "{{count}} fazenda",
			farmsAffected_other: "{{count}} fazendas",
			tiles: {
				tasks: {
					label: "Tarefas atrasadas",
					oldest: "A mais antiga desde {{date}}",
					empty: "Tarefas fora do prazo",
				},
				livestock: {
					label: "Alertas do rebanho",
					empty: "Rotação, pesagem, parição",
					parts: {
						PADDOCK_OVERSTAY_one: "{{count}} rotação",
						PADDOCK_OVERSTAY_other: "{{count}} rotações",
						WEIGHING_OVERDUE_one: "{{count}} pesagem",
						WEIGHING_OVERDUE_other: "{{count}} pesagens",
						OVER_CAPACITY_one: "{{count}} acima da capacidade",
						OVER_CAPACITY_other: "{{count}} acima da capacidade",
						CALVING_WINDOW_one: "{{count}} parição",
						CALVING_WINDOW_other: "{{count}} parições",
						VACCINATION_DUE_one: "{{count}} vacinação",
						VACCINATION_DUE_other: "{{count}} vacinações",
					},
				},
				review: {
					label: "Registros a revisar",
					caption: "Lançados automaticamente, ainda não conferidos",
				},
				proposals: {
					label: "Propostas da IA",
					caption: "Aguardando sua decisão",
				},
			},
			groups: {
				tasks: {
					title_one: "{{count}} tarefa está atrasada",
					title_other: "{{count}} tarefas estão atrasadas",
					subtitle: "{{title}} — prazo {{date}} · {{farm}}",
					badge: "Mais antiga {{date}}",
				},
				PADDOCK_OVERSTAY: {
					title_one: "{{count}} lote passou da data de rotação",
					title_other: "{{count}} lotes passaram da data de rotação",
				},
				WEIGHING_OVERDUE: {
					title_one: "{{count}} lote está com pesagem vencida",
					title_other: "{{count}} lotes estão com pesagem vencida",
					coverage:
						"Só {{numerator}} de {{denominator}} cabeças pesadas nos últimos 90 dias — o ganho de peso está incompleto",
					badge: "Afeta o GMD",
				},
				OVER_CAPACITY: {
					title_one: "{{count}} lote está acima da capacidade",
					title_other: "{{count}} lotes estão acima da capacidade",
				},
				CALVING_WINDOW: {
					title_one: "{{count}} parição prevista",
					title_other: "{{count}} parições previstas",
					badge: "Próximos 30 dias",
				},
				VACCINATION_DUE: {
					title_one: "{{count}} vacinação vencida",
					title_other: "{{count}} vacinações vencidas",
				},
				unassigned: {
					title_one: "{{count}} cabeça não está em nenhum piquete",
					title_other: "{{count}} cabeças não estão em nenhum piquete",
					subtitle:
						"{{share}}% do rebanho. A lotação e a produção acima não as contam.",
					badge: "Dado faltando",
				},
			},
		},
		title: "Gerencie sua organização em um só lugar",
		welcome: "Bem-vindo à {{organization}}",
		quickActions_establishments: "Fazendas",
		quickActions_establishments_description:
			"Gerencie as fazendas e localizações da sua organização",
		quickActions_staff: "Equipe",
		quickActions_staff_description:
			"Gerencie os membros da equipe da sua organização e seus papéis",
		quickActions_planning: "Planejamento e Tarefas",
		quickActions_planning_description:
			"Planeje objetivos e acompanhe o trabalho que os realiza",
		quickActions_assistant: "Assistente de IA",
		quickActions_assistant_description:
			"Tire dúvidas e receba ajuda para gerir sua operação",
		greeting: {
			morning: "Bom dia, {{name}}",
			afternoon: "Boa tarde, {{name}}",
			evening: "Boa noite, {{name}}",
			morning_noName: "Bom dia",
			afternoon_noName: "Boa tarde",
			evening_noName: "Boa noite",
		},
		subtitle: "Veja o que precisa da sua atenção hoje",
		updated: "Atualizado {{when}}",
		scope: {
			allFarms: "Todas as fazendas",
			viewing: "Visualizando {{farm}}",
		},
		capture: {
			record: "Novo registro",
		},
		sync: {
			syncing: "Sincronizando...",
			queued_one: "{{count}} registro a enviar",
			queued_other: "{{count}} registros a enviar",
			offline: "Sem conexão",
			offlineQueued_one: "Sem conexão · {{count}} na fila",
			offlineQueued_other: "Sem conexão · {{count}} na fila",
		},
		activity: {
			title: "Registrado na fazenda",
			empty: "Nenhum registro nos últimos 7 dias.",
			entry: "{{verb}}: {{subject}}",
			systemActor: "Sistema",
			unknownActor: "Autor não identificado",
			verbs: {
				created: "Novo registro",
				updated: "Atualização",
				deleted: "Remoção",
				removed: "Remoção",
				completed: "Concluído",
				approved: "Aprovado",
				rejected: "Recusado",
				invited: "Convite",
				exported: "Exportação",
				toggled: "Ajuste",
				executed: "Execução",
				changed: "Alteração",
			},
			subjects: {
				livestock_animal: "Animal",
				livestock_measurement: "Medição do rebanho",
				livestock_operation: "Manejo do rebanho",
				grass_measurement: "Medição de pasto",
				grass_operation: "Manejo de pasto",
				grass_paddock: "Pasto",
				equipment: "Equipamento",
				equipment_part: "Peça",
				planning_task: "Tarefa",
				soil_analysis: "Análise de solo",
				assistant_proposal: "Proposta do assistente",
				assistant_proposal_action: "Proposta do assistente",
				staff: "Equipe",
				staff_member: "Membro da equipe",
				staff_role: "Papel de acesso",
				staff_invitation: "Convite de equipe",
				vendor: "Fornecedor",
				payroll_run: "Folha de pagamento",
				payroll_worker: "Trabalhador",
				user_profile: "Perfil",
				financialhub_autopost: "Lançamento automático",
				animals: "Animal",
				herds: "Lote",
				measurements: "Medição",
				operations: "Manejo",
				weighing: "Pesagem",
				paddocks: "Pasto",
				tasks: "Tarefa",
				objectives: "Objetivo",
				parts: "Peça",
				establishments: "Fazenda",
				sales: "Venda",
			},
		},
		herdSnapshot: {
			title: "Rebanho",
			head: "Cabeças",
			herds: "Lotes",
			records30d: "Registros (30 d)",
			viewAll: "Ver rebanho",
		},
		livestockKpi: {
			title: "Como vai o rebanho",
			window12m: "últimos 12 meses",
			windowAllFarms: "Últimos 12 meses · todas as fazendas",
			windowFarm: "Últimos 12 meses · {{farm}}",
			definition: {
				gmd90: "ganho médio diário, últimos 90 dias",
				stocking: "unidades animais por hectare",
				production: "quilos de carne por hectare por dia",
				pregnancy: "vacas confirmadas prenhes",
				weaning: "bezerros desmamados por vaca",
				mortality: "mortes no rebanho",
			},
			footnote: {
				headWeighed: "{{numerator}} de {{denominator}} cabeças pesadas",
				cowsChecked: "{{numerator}} de {{denominator}} vacas diagnosticadas",
				deathsOfHead: "{{deaths}} de {{total}} cabeças",
			},
			tiles: {
				gmd90: "GMD 90d",
				stocking: "Lotação",
				production: "Produção",
				pregnancy: "Prenhez",
				weaning: "Desmame",
				mortality: "Mortalidade",
			},
			empty: {
				gmd90: "sem pesagem recente",
				stocking: "cadastre a área dos piquetes",
				production: "sem pesagem ou área de pasto",
				pregnancy: "sem diagnóstico no período",
				weaning: "sem desmame no período",
				mortality: "sem rebanho no período",
			},
			help: {
				aboutSection: "Sobre os indicadores do rebanho",
				aboutTile: "Sobre {{label}}",
				section:
					"Seis indicadores que resumem o desempenho do rebanho, calculados a partir dos registros feitos aqui (pesagens, área dos piquetes, diagnósticos de prenhez, desmames e mortes).\n\nNúmeros como 12/40 mostram quantos animais ou piquetes tinham dados suficientes. A bandeira ⚑ indica pouca cobertura, então interprete o valor com cautela.",
				gmd90:
					"Ganho médio diário nos últimos 90 dias: quantos quilos cada animal ganhou por dia, com base nas pesagens desse período.\n\nO animal precisa de pelo menos duas pesagens no período para entrar no cálculo.",
				stocking:
					"Taxa de lotação: quantas unidades animal (UA) pastejam em cada hectare de pasto. Uma UA equivale a 450 kg de peso vivo.\n\nQuando faltam pesagens, mostramos cabeças por hectare no lugar.",
				production:
					"Produtividade do pasto: quilos de peso vivo produzidos por hectare por dia. Multiplica o ganho médio diário do rebanho pela lotação em cabeças por hectare.",
				pregnancy:
					"Taxa de prenhez: proporção de fêmeas de cria diagnosticadas prenhes entre as que tiveram diagnóstico nos últimos 12 meses.",
				weaning:
					"Taxa de desmame: bezerros desmamados a cada 100 fêmeas de cria nos últimos 12 meses, com o peso total desmamado e o peso desmamado por hectare de pasto.",
				mortality:
					"Mortalidade: mortes nos últimos 12 meses em relação aos animais presentes no período (cabeças presentes mais mortes).",
			},
			starterNote:
				"Estes indicadores são preenchidos conforme você registra pesagens, área dos piquetes, diagnósticos de prenhez, desmames e mortes.",
			couldNotLoad: "não foi possível carregar",
			thin: "pouca cobertura",
			unassigned: "Sem lote",
			headWithoutPaddock: "{{count}} cab. fora de piquete",
			seeHerds: "Ver lotes",
			seePaddocks: "Ver piquetes",
			basis: {
				rolling12m: "últimos 12 meses",
				presentPlusDeaths: "presentes + mortes",
				farmGrazingArea: "área de pastejo da fazenda",
			},
			staleWeight: "A pesagem mais antiga tem {{days}} dias",
			units: {
				kgPerDay: "kg/dia",
				auPerHa: "UA/ha",
				headPerHa: "cab/ha",
				ha: "ha",
				kgPerHaPerDay: "kg/ha/dia",
				percent: "%",
			},
			coverage: "{{numerator}}/{{denominator}}",
			head: "{{count}} cab",
			weanedKg: "{{value}} kg",
			weanedKgPerHa: "{{value}} kg/ha",
			deathsOf: "{{deaths}} de {{total}}",
			percent: "{{value}} %",
			productionBasis: "base: GMD×cab/ha",
			paddockHerd: "{{name}} · {{days}} d",
			pregnancyLabel: "prenhez {{value}} %",
		},
		marketPrice: {
			title: "Preço do boi gordo",
			yourState_one: "Seu estado",
			yourState_other: "Seus estados",
			dailyQuotes: "Cotações diárias",
			source: "Fonte:",
			perArroba: "/@",
			up: "Subiu",
			down: "Caiu",
			since: "desde {{date}}",
			referenceDate: "ref. {{date}}",
			stale: "desatualizado",
			otherStates_one: "Outros estados ({{count}})",
			otherStates_other: "Outros estados ({{count}})",
			gapStateUnknown_one:
				"{{count}} fazenda sem estado identificado — confira o endereço em Configurações.",
			gapStateUnknown_other:
				"{{count}} fazendas sem estado identificado — confira os endereços em Configurações.",
			noPublicQuote_one:
				"Sem cotação pública para este estado ({{count}} fazenda).",
			noPublicQuote_other:
				"Sem cotação pública para este estado ({{count}} fazendas).",
		},
		askAssistant: {
			title: "Perguntar à fazenda",
			label: "Pergunta para o assistente",
			placeholder: "Quantas cabeças no pasto 4?",
			submit: "Perguntar",
			hint: "A resposta usa os registros da sua fazenda. A IA propõe; você decide.",
		},
		equipment: {
			title: "Máquinas",
			nextService: "{{type}} · próxima manutenção",
			noOpenJobs: "Nenhum serviço em aberto",
			dueHours_one: "Em {{count}} hora de uso",
			dueHours_other: "Em {{count}} horas de uso",
			dueNow: "Vencida",
			openTasks_one: "{{count}} serviço em aberto",
			openTasks_other: "{{count}} serviços em aberto",
			more_one: "+{{count}} manutenção",
			more_other: "+{{count}} manutenções",
			viewAll: "Ver manutenções",
		},
		firstWeightNudge: {
			title: "Registre a primeira pesagem",
			body_one:
				"Sua fazenda já tem {{count}} animal. Com a primeira pesagem, o RuralOps começa a acompanhar o ganho de peso.",
			body_other:
				"Sua fazenda já tem {{count}} animais. Com a primeira pesagem, o RuralOps começa a acompanhar o ganho de peso.",
			farmChip: "Fazenda: {{name}}",
			action: "Registrar primeira pesagem",
			dismiss: "Agora não",
		},
		livestockAlerts: {
			title: "Atenção no rebanho",
			viewAll: "Ver rebanho",
		},
		myTasks: {
			title: "Suas tarefas",
			overdue: "Atrasadas",
			today: "Para hoje",
			upcoming: "Próximas",
			noDueDate: "Sem prazo",
			due: "Prazo {{date}}",
			empty: "Nenhuma tarefa atribuída a você no momento.",
			emptyHint:
				"As tarefas atribuídas a você nas suas fazendas aparecerão aqui.",
			viewAll: "Ver todas as tarefas",
			more: "+{{count}} mais",
		},
		financialSummary: {
			title: "Financeiro",
			viewAll: "Ver tudo",
			monthResult: "Resultado do mês",
			monthSoFar: "{{month}}, até agora",
			projectedBalance: "Saldo projetado",
			projectedBalanceCaption: "Onde o mês termina nesse ritmo",
			cashBalanceNudge: "O saldo projetado não está aparecendo",
			cashBalanceNudgeBody:
				"Defina o saldo inicial uma vez e isto se preenche.",
			cashBalanceNudgeCta: "Definir agora",
			upcomingObligations: "Contas a vencer em 7 dias",
			nothingToPay: "Nada a pagar esta semana",
			obligationsCount_one: "{{count}} conta a pagar",
			obligationsCount_other: "{{count}} contas a pagar",
			expectedInflows: "Recebimentos (7 dias)",
			inflowsCount_one: "{{count}} conta a receber",
			inflowsCount_other: "{{count}} contas a receber",
			toReview: "Registros a revisar",
		},
		yourFarms: {
			title: "Suas fazendas",
			allFarms: "Todas as fazendas",
			viewAll: "Gerenciar fazendas",
		},
	},
	staff: {
		title: "Gestão da equipe",
		description:
			"Gerencie os membros da equipe da sua organização e seus papéis",
		searchPlaceholder: "Buscar por nome ou email...",
		inviteDescription:
			"Envie um convite para um novo membro da equipe. Ele receberá um email com instruções para ingressar na sua organização.",
		noStaff: "Nenhum membro da equipe ainda",
		noStaffDescription:
			"Convide membros da equipe para ingressar na sua organização e ajudar a gerenciar as operações.",
		noStaffFound: "Nenhum membro da equipe encontrado",
		noStaffSearchDescription:
			"Nenhum membro da equipe corresponde aos seus critérios de busca. Tente um termo de busca diferente.",
		revoke_title: "Remover membro",
		revoke_description:
			"Tem certeza de que deseja remover {{name}} da sua organização?",
		revoke_confirm: "Remover",
		invitation: {
			expires: "Expira",
		},
		toasts: {
			inviting: "Enviando convite...",
			inviteSuccess: "Convite enviado com sucesso",
			updating: "Salvando alterações...",
			updateSuccess: "Membro da equipe atualizado com sucesso",
			removing: "Removendo membro da equipe...",
			removeSuccess: "Membro da equipe removido com sucesso",
			revoking: "Revogando convite...",
			revokeSuccess: "Convite revogado com sucesso",
		},
		navigation: {
			title: "Membro da Equipe",
			description: "Visualize e gerencie os detalhes deste membro da equipe",
			staffData: "Detalhes",
			permissions: "Permissões",
			unknownStaff: "Membro da equipe desconhecido",
		},
		form: {
			email: "Email",
			joinedAt: "Ingressou em {{date}}",
			organizationRole: "Papel na organização",
			organizationRoleDescription:
				"Controla o que este membro pode ver e fazer na organização.",
			organizationRolesHeader: "Papéis na organização",
			permission: "Permissão",
			permissionsMatrix: "Matriz de permissões",
			updateRole: "Atualizar papel",
			viewPermissions: "Ver permissões",
			sections: {
				information: {
					title: "Informações do membro",
					description: "Dados pessoais deste membro da equipe.",
					editMode: "Atualize o nome e a cor de exibição deste membro.",
					editModeColorOnly: "Atualize a cor de exibição deste membro.",
					firstName: "Nome",
					firstNamePlaceholder: "Digite o nome",
					lastName: "Sobrenome",
					lastNamePlaceholder: "Digite o sobrenome",
					color: "Cor de exibição",
					colorDescription:
						"Usada para identificar este membro em calendários e atribuições.",
					cancel: "Cancelar",
					saveChanges: "Salvar alterações",
					updateSuccess: "Informações do membro atualizadas com sucesso",
				},
				organizationRole: {
					title: "Papel e permissões",
					description:
						"Defina o papel deste membro na organização para controlar o acesso.",
				},
			},
			roleDescriptions: {
				org_owner: "Acesso total a tudo na organização.",
				org_administrator:
					"Gerencia equipe, configurações e a maioria dos dados da organização.",
				org_manager:
					"Gerencia as operações do dia a dia e os dados da fazenda.",
				org_medical_professional:
					"Acesso aos registros sanitários e aos manejos de saúde do rebanho.",
				org_accountant: "Acesso a faturamento, finanças e relatórios.",
				org_viewer: "Acesso somente leitura aos dados da organização.",
			},
		},
	},
	establishments: {
		description: "Cadastre e gerencie as fazendas da sua organização",
		createFarm: "Criar fazenda",
		createTitle: "Cadastre sua fazenda",
		createDescription:
			"Precisamos do nome e do município. O resto pode ficar para depois.",
		saveFarm: "Salvar fazenda",
		editFarm: "Editar fazenda",
		updateFarm: "Atualizar fazenda",
		nameLabel: "Nome da fazenda",
		nameQuestion: "Qual é o nome da fazenda?",
		footerHint: "Você pode completar os dados depois, em Fazenda.",
		optionalDisclosure: "Adicionar outros dados agora",
		optionalDisclosureHelp:
			"Endereço, telefone e descrição podem ser preenchidos depois.",
		citySearch: {
			label: "Cidade da fazenda",
			placeholder: "Comece a digitar o nome do município",
			required: "Escolha o município da fazenda",
			minLength: "Digite pelo menos 2 letras para buscar",
			searching: "Buscando municípios...",
			noResults: "Nenhum município encontrado com esse nome",
			error: "Não foi possível buscar municípios agora. Tente de novo.",
			clear: "Remover cidade",
			resultsLabel: "Municípios encontrados",
			selected: "Cidade selecionada",
		},
		searchPlaceholder: "Buscar fazendas...",
		namePlaceholder: "Fazenda Boa Vista",
		addressPlaceholder: "Estrada do Retiro, km 12",
		phonePlaceholder: "(67) 99999-0000",
		emailPlaceholder: "contato@fazenda.com.br",
		descriptionPlaceholder: "Cria e recria, 1.200 ha",
		noEstablishments: "Nenhuma fazenda ainda",
		noEstablishmentsDescription:
			"Cadastre sua primeira fazenda para começar a organizar a produção.",
		confirmDelete: "Excluir fazenda",
		confirmDeleteDescription:
			"Tem certeza de que deseja excluir esta fazenda? Esta ação não pode ser desfeita.",
		confirmDeleteWarning:
			"Todos os dados associados a esta fazenda serão removidos permanentemente.",
		confirmDeletePhrase: "EXCLUIR",
	},
	platformPlan: {
		checkout: {
			loading: "Preparando o pagamento...",
			success: "Abrindo a página de pagamento...",
			error: "Não foi possível iniciar o pagamento",
		},
		portal: {
			loading: "Abrindo portal de cobrança...",
			success: "Redirecionando para portal de cobrança...",
			error: "Falha ao abrir portal de cobrança",
		},
		success: {
			syncing: "Ativando sua assinatura...",
			syncingDescription:
				"Por favor, aguarde enquanto confirmamos seu pagamento e ativamos sua assinatura.",
			syncError: "Não foi possível confirmar a assinatura",
			syncErrorDescription:
				"Houve um problema ao confirmar sua assinatura. Por favor, tente novamente ou entre em contato com o suporte.",
			title: "Parabéns!",
			description: "Sua assinatura está ativa. Obrigado por assinar!",
			redirectingIn: "Redirecionando em {{seconds}} segundos...",
			cta: "Ir para o painel",
		},
		update: {
			syncing: "Atualizando assinatura...",
			syncingDescription:
				"Por favor, aguarde enquanto sincronizamos as alterações da sua assinatura.",
		},
		subscribeFree: {
			loading: "Ativando plano gratuito...",
			success: "Plano gratuito ativado com sucesso!",
			error: "Falha ao ativar plano gratuito",
		},
		welcomeModal: {
			title: "Bem-vindo ao RuralOps!",
			description:
				"Seu plano gratuito foi ativado. Agora você pode começar a usar todos os recursos do RuralOps.",
			trialTitle: "Seu teste grátis começou!",
			trialDescription:
				"Você tem 30 dias de acesso completo — sem cartão de crédito. Adicione uma forma de pagamento a qualquer momento antes do término para manter sua assinatura ativa.",
			goToDashboard: "Ir para o painel",
			redirectingIn: "Redirecionando em {{seconds}} segundos...",
		},
		trialBanner: {
			message_one:
				"Seu teste grátis termina em {{count}} dia. Adicione uma forma de pagamento para manter o acesso.",
			message_other:
				"Seu teste grátis termina em {{count}} dias. Adicione uma forma de pagamento para manter o acesso.",
			cta: "Adicionar forma de pagamento",
		},
		usage: {
			title: "Uso do Plano",
			description: "Seu uso atual em relação aos limites do plano",
			customLimit: "Limite personalizado",
			expiresAt: "expira em {{date}}",
		},
		entitlements: {
			max_establishments: "Estabelecimentos",
			max_staff_members: "Membros da Equipe",
			max_animals: "Animais",
		},
		llmUsage: {
			title: "Uso de IA",
			description: "Uso de {{periodStart}} a {{periodEnd}}",
			budgetUsed: "Orçamento de IA Utilizado",
			byokEstimate: "Sua própria chave (estimativa nas tarifas da plataforma)",
			fxAsOf: "câmbio de {{date}}",
			summaryUnavailable:
				"O resumo de gastos com IA está temporariamente indisponível. Os demais detalhes do plano não são afetados.",
			topup: {
				planBudget: "Orçamento do plano",
				credits: "Créditos adicionais",
				totalAvailable: "Total disponível neste ciclo",
				impact:
					"Os adicionais somam ao orçamento do plano e aumentam o limite de IA deste ciclo. São aplicados na hora e expiram ao fim do ciclo.",
				yourTopups: "Seus adicionais",
				purchasedOn: "Comprado em {{date}}",
				expiresOn: "expira em {{date}}",
				title: "Precisa de mais neste ciclo?",
				description:
					"Compre um adicional avulso. Ele é aplicado na hora e vale até o fim do seu ciclo.",
				amountLabel: "Valor ({{min}}–{{max}})",
				buyAmount: "Adicionar {{amount}}",
				dunningBlocked:
					"As compras de adicionais estão pausadas enquanto o pagamento da sua assinatura está em atraso.",
			},
			byTaskType: "Por Tipo de Tarefa",
			byProvider: "Por Provedor",
			noUsage: "Nenhum uso de IA neste período",
			taskTypes: {
				ANAMNESIS_SUMMARY: "Resumo de Anamnese",
				SESSION_PLAN_SUGGESTION: "Sugestão de Plano de Sessão",
				CUSTOMER_WORKOUT_RECOMMENDATION: "Recomendação de Treino do Cliente",
			},
			providers: {
				openai: "OpenAI",
				anthropic: "Anthropic",
				bedrock: "AWS Bedrock",
			},
		},
		recurringAddons: {
			title: "Adicionais recorrentes",
			description:
				"Aumente os limites do seu plano com adicionais mensais. As cobranças são proporcionais e na moeda da sua assinatura.",
			perUnit: "{{price}} por +{{step}} / mês",
			increase: "Aumentar",
			decrease: "Diminuir",
			types: {
				animals: { name: "+{{step}} animais" },
				farms: { name: "+{{step}} fazenda" },
			},
			saved: "Adicional atualizado.",
			prorationCharge:
				"Um valor proporcional de {{amount}} será adicionado à sua próxima fatura em {{date}}.",
			prorationCredit:
				"Um crédito proporcional de {{amount}} será aplicado à sua próxima fatura em {{date}}.",
		},
		planChange: {
			changed: "Plano atualizado.",
			noChange: "Você já está neste plano.",
			prorationCharge:
				"Um valor proporcional de {{amount}} será adicionado à sua próxima fatura em {{date}}.",
			prorationCredit:
				"Um crédito proporcional de {{amount}} será aplicado à sua próxima fatura em {{date}}.",
		},
		billingSummary: {
			title: "Cobrança mensal",
			basePlan: "Plano base",
			total: "Total",
			perMonth: "/ mês",
		},
		invoices: {
			title: "Faturas",
			nextInvoice: "Próxima fatura",
			nextInvoiceOn: "em {{date}}",
			nextInvoiceNote:
				"Atualiza automaticamente conforme você adiciona ou remove adicionais.",
			history: "Histórico de cobrança",
			empty: "Nenhuma fatura ainda.",
			viewInvoice: "Ver",
			status: {
				paid: "Paga",
				open: "Em aberto",
				void: "Anulada",
				uncollectible: "Incobrável",
				draft: "Rascunho",
			},
		},
		partnerRedeem: {
			openCta: "Resgatar código de parceiro",
			title: "Resgatar código de parceiro",
			inputDescription:
				"Cole o código que o administrador da sua parceria enviou.",
			confirmDescription: "Confirme o plano que você está prestes a resgatar.",
			codeLabel: "Código do parceiro",
			codePlaceholder: "Cole seu código aqui",
			validating: "Validando…",
			redeeming: "Ativando…",
			confirmCta: "Confirmar e resgatar",
			confirmPartnerLabel: "Parceiro:",
			confirmPlanLabel: "Plano:",
			confirmExpiresLabel: "Acesso até:",
			success: "Assinatura de parceiro ativada.",
			errors: {
				invalid:
					"Este código não é válido. Confira o código enviado pelo administrador da parceria.",
				paidSub:
					"Esta organização já tem um plano pago ativo. Cancele o plano atual antes de resgatar um código de parceiro.",
				raceLost:
					"Este código não é mais válido — alguém pode ter usado a última vaga enquanto você confirmava.",
				disabled:
					"O resgate de códigos de parceiro está temporariamente indisponível. Tente novamente em breve.",
				rateLimited:
					"Muitas tentativas — aguarde um minuto antes de tentar novamente.",
				generic: "Algo deu errado. Tente novamente.",
			},
			activeBanner: {
				title: "Você está no plano de parceiro {{planName}} até {{date}}.",
				description:
					"Se precisar de mais capacidade, escolha um dos planos pagos abaixo.",
			},
		},
	},
	grass: {
		foragePreview: {
			cultivar: "Cultivar na data do registro",
			definition:
				"A densidade representa a matéria seca total acima do solo, incluindo material morto, amostrada desde o nível do solo e dividida pela altura não comprimida do pasto.",
			action: "Massa de forragem",
			onlineRequired: "É necessário estar online para consultar esta prévia.",
			close: "Fechar",
			record: "Registro de campo",
			loadedRecords:
				"Selecione entre os registros carregados. Esta lista pode não incluir todo o histórico.",
			noRecords: "Nenhum registro de campo carregado.",
			preview: "Consultar massa de forragem",
			loading: "Carregando…",
			error:
				"Não foi possível consultar a prévia. Verifique a conexão e tente novamente.",
			confirmConditions:
				"Verifiquei a cultivar neste piquete na data do registro, a medição da altura não comprimida e todas as condições da referência.",
			confirmAndPreview: "Confirmar condições e consultar",
			recordDate: "Data do registro",
			recorded: "Massa de forragem registrada",
			estimated: "Estimativa pela literatura",
			massUnit: "kg MS/ha",
			densityUnit: "kg MS/ha/cm",
			methodUnspecified: "Método não informado",
			referenceRange: "Faixa de altura válida",
			density: "Densidade de referência",
			heightContext:
				"A altura deve ser a altura não comprimida do pasto. Verifique a cultivar e as condições do piquete na data do registro.",
			limitations:
				"Matéria seca total em pé por hectare. Não é alimento aproveitável nem recomendação de lotação. A prévia não é salva.",
			sourceNotProvided: "Fonte não informada",
			conditions: "Condições",
			managementSource: "Referência de manejo",
			reasons: {
				INVALID_RECORDED_MASS: "A massa registrada é inválida.",
				MISSING_HEIGHT: "Nenhuma altura foi registrada.",
				INVALID_HEIGHT: "A altura registrada é inválida.",
				NO_REFERENCE: "Não há referência de densidade informada.",
				INVALID_REFERENCE:
					"A referência de densidade está incompleta ou inválida.",
				MIXED_PASTURE:
					"Pasto misto ou cobertura parcial por cultivar não permite esta estimativa.",
				INCOMPATIBLE_MANAGEMENT: "O método de pastejo difere da referência.",
				OUTSIDE_HEIGHT_RANGE: "A altura está fora da faixa válida.",
				PLANTING_DATE_UNVERIFIED:
					"Não é possível verificar a data de plantio da cultivar para este registro.",
				CONDITIONS_UNCONFIRMED:
					"Verifique e confirme as condições da referência antes de estimar.",
				REFERENCE_CHANGED:
					"A referência mudou. Revise e confirme as condições atualizadas.",
			},
		},
		registries: {
			tab: "Registros",
			measurementType: "Medição do pasto",
			kind: {
				all: "Tudo",
				operation: "Manejos",
				measurement: "Medições",
			},
			groups: {
				pasture: "Pastejo",
				harvest: "Colheita",
				fertility: "Fertilidade",
				water: "Água",
				protection: "Proteção",
				renewal: "Renovação",
			},
			register: {
				button: "Registrar",
				title: "Novo registro",
				search: "Buscar tipo…",
				recents: "Recentes",
				empty: "Nenhum tipo encontrado",
			},
		},
		nav: {
			title: "Piquetes",
		},
		dashboard: {
			quickActions: {
				addMeasurement: "Registrar medição",
				logOperation: "Registrar manejo",
			},
		},
		farm: {
			title: "Fazenda",
			createSuccess: "Fazenda criada com sucesso",
			createError: "Falha ao criar fazenda",
			updateSuccess: "Fazenda atualizada com sucesso",
			updateError: "Falha ao atualizar fazenda",
			selectFarm: "Selecione uma Fazenda",
			noFarms: "Nenhuma fazenda encontrada",
			noFarmsDescription:
				"Cadastre uma fazenda para começar a acompanhar a produção de pasto",
		},
		paddock: {
			selectPaddock: "Selecione um piquete",
			list: {
				title: "Piquetes",
				searchPlaceholder: "Buscar por nome, capim ou tipo de uso...",
				moreCultivars: "+{{count}} mais",
				selectRow: "Selecionar o piquete {{name}}",
				resultLine: "{{shown}} de {{total}} piquetes",
				noResults: "Nenhum piquete corresponde à busca",
				noResultsHint: "Tente outro nome, código, capim ou tipo de uso.",
				columns: {
					establishment: "Fazenda",
				},
				empty: {
					title: "Nenhum piquete ainda",
					description:
						"Cadastre seu primeiro piquete para começar a acompanhar a produção de pasto",
				},
			},
			// Paddock-list multi-select bulk bar.
			bulk: {
				recordOperation: "Registrar operação",
				exportCsv: "Exportar CSV",
				csvExported: "CSV exportado",
				csvAreaHeader: "Área (ha)",
				selectNeedsFarm:
					"A seleção múltipla só está disponível com uma fazenda selecionada. Escolha uma fazenda no seletor acima.",
				capExceeded:
					"As ações em lote são limitadas a {{max}} piquetes por vez.",
				mixedFarms:
					"Selecione piquetes de uma única fazenda para usar as ações em lote.",
				partialResult:
					"{{success}} concluídos, {{failed}} com erro. Revise a lista e tente de novo.",
				allFailed: "Nada foi processado. Veja os erros e tente de novo.",
				notFound: "Piquete não encontrado — pode ter sido excluído ou movido.",
				unknownError: "Erro desconhecido",
				operationTitle_one: "Registrar operação em 1 piquete",
				operationTitle_other: "Registrar operação em {{count}} piquetes",
				operationBody:
					"A mesma operação é registrada em cada piquete: {{names}}. O custo não é dividido entre os piquetes — lance o custo em cada piquete, se precisar.",
				operationCta_one: "Registrar em 1 piquete",
				operationCta_other: "Registrar em {{count}} piquetes",
				operationSuccess_one: "Operação registrada em {{count}} piquete",
				operationSuccess_other: "Operação registrada em {{count}} piquetes",
				delete: "Excluir",
				deleteTitle_one: "Excluir 1 piquete?",
				deleteTitle_other: "Excluir {{count}} piquetes?",
				deleteBody:
					"Estes piquetes saem das listas de piquetes e dos relatórios de pasto. Não é possível desfazer pelo app.",
				// The word that arms the delete button — a verb, not a name.
				deleteWord: "Excluir",
				deleteConfirm_one: "Excluir piquete",
				deleteConfirm_other: "Excluir {{count}} piquetes",
				deleteSuccess_one: "{{count}} piquete excluído",
				deleteSuccess_other: "{{count}} piquetes excluídos",
			},
			create: {
				title: "Criar Piquete",
			},
			edit: {
				title: "Editar Piquete",
			},
			form: {
				identity: "Identificação",
				identityHint: "Nome e código usados para identificar o piquete",
				landAndUse: "Área e uso",
				landAndUseHint: "Características físicas e como o piquete é pastejado",
				areaFromMap: "Calculada pelo contorno",
				areaManual: "Informe manualmente ou desenhe o contorno",
				boundaryHint:
					"Toque no mapa ou use o GPS para traçar o limite do piquete",
				summary: "Resumo do piquete",
				notSet: "Não definido",
				requiredHint: "Campos marcados com * são obrigatórios",
				fromBoundary: "pelo contorno",
				enterManually: "informar manualmente",
				manual: "manual",
				soilTypeSuggestions: "Tipos comuns",
				codeAutoSuggested: "sugerido",
				moreDetails: "Mais detalhes",
			},
			soilTypes: {
				clayLoam: "Franco-argiloso",
				sandyLoam: "Franco-arenoso",
				clayey: "Argiloso",
				sandy: "Arenoso",
				silty: "Siltoso",
				loam: "Franco",
			},
			detail: {
				title: "Detalhes do Piquete",
				notFound: "Piquete não encontrado",
				tabs: {
					paddocks: "Piquetes",
					measurements: "Medições",
					operations: "Manejos",
					soilAnalysis: "Análise de Solo",
				},
				sections: {
					soil: "Solo e fertilidade",
				},
				soilSection: {
					summary_one: "{{count}} análise · última coleta em {{date}}",
					summary_other: "{{count}} análises · última coleta em {{date}}",
				},
				overview: {
					basicInfo: "Informações básicas",
					qualityTargets: "Metas de Qualidade",
					yieldTarget: "Meta de Produção",
					cpMin: "Proteína Bruta Mín.",
					ndfMax: "FDN Máx.",
					utilizationTarget: "Meta de Utilização",
					yieldTargetHelp:
						"Produção anual esperada de matéria seca por hectare (t MS/ha/ano).",
					cpMinHelp: "Teor mínimo de proteína bruta desejado na forragem.",
					ndfMaxHelp:
						"Teor máximo de fibra (FDN) aceitável — fibra maior reduz a digestibilidade.",
					utilizationTargetHelp:
						"Percentual da forragem disponível que o lote realmente consome.",
					noTargets: "Nenhuma meta de qualidade definida",
					noCultivars: "Nenhuma espécie de pasto atribuída",
					noBoundary: "Limite não definido",
					latestMeasurement: "Última Medição",
					noMeasurement: "Nenhuma medição registrada",
					biomass: "Massa de forragem",
					height: "Altura",
					measuredAt: "Medido em",
				},
				measurementsList: {
					empty: "Nenhuma medição registrada para este piquete",
					addFirst:
						"Registre a primeira medição para começar a acompanhar a produção de pasto",
				},
				operationsList: {
					empty: "Nenhum manejo registrado para este piquete",
					addFirst: "Registre o primeiro manejo realizado neste piquete",
				},
			},
			fields: {
				name: "Nome",
				code: "Código",
				area: "Área",
				status: "Status",
				useType: "Tipo de Uso",
				cultivars: "Capins e forrageiras",
				// Legenda curta da linha de métricas do cartão no celular.
				cultivarsShort: "Capins",
				soilType: "Tipo de Solo",
				slope: "Declividade",
			},
			placeholders: {
				name: "ex., Piquete Norte",
				code: "ex., PN-01",
				soilType: "ex., Argila arenosa",
			},
			actions: {
				create: "Criar Piquete",
				// Uma palavra só — a barra do celular não comporta "Criar Piquete".
				createShort: "Piquete",
				record: "Registrar",
				more: "Mais ações",
				delete: "Excluir piquete",
			},
			useTypes: {
				ROTATIONAL_GRAZING: "Pastejo Rotacionado",
				CONTINUOUS_GRAZING: "Pastejo contínuo",
				CUT_AND_CARRY: "Capineira (corte e fornecimento)",
				HAY: "Produção de Feno",
				SILAGE: "Produção de Silagem",
				DEFERRED_STOCKPILING: "Pasto diferido",
				MIXED: "Uso Misto",
			},
			statuses: {
				ESTABLISHED: "Estabelecido",
				RENOVATION: "Em Renovação",
				DEGRADED: "Degradado",
				REST: "Em Descanso",
				DEFERRED: "Diferido",
				UNDER_RECOVERY: "Em Recuperação",
			},
			boundary: {
				title: "Limite do Piquete",
				clear: "Limpar",
				apply: "Aplicar",
				coordinatesLabel: "Digite as coordenadas (latitude, longitude)",
				coordinatesPlaceholder:
					"-23.5505, -46.6333\n-23.5510, -46.6320\n-23.5520, -46.6340",
				coordinatesHelp:
					"Digite uma coordenada por linha. Formato: latitude, longitude (ex: -23.5505, -46.6333)",
				pointsDetected: "{{count}} pontos detectados",
				mapPreviewEmpty: "Digite as coordenadas para ver a prévia",
				tapHint: "Toque no mapa para adicionar os pontos do limite",
				useGps: "Usar minha localização",
				gpsError: "Não foi possível obter sua localização",
				gpsUnsupported: "Geolocalização não é suportada neste dispositivo",
				undo: "Desfazer ponto",
				manualEntry: "Inserir coordenadas manualmente",
				tools: {
					draw: "Desenhar",
					gps: "Caminhar com GPS",
					coordinates: "Coordenadas",
				},
				drawHint: "Toque no mapa para adicionar pontos do limite",
				pointsPerimeter: "{{count}} pontos · {{km}} km de perímetro",
				perimeter: "{{km}} km de perímetro",
				zoomIn: "Aproximar",
				zoomOut: "Afastar",
				errors: {
					minPoints: "Mínimo de 3 pontos necessários para criar um limite",
				},
			},
			kpi: {
				latestBiomass: "Última biomassa registrada",
				swardHeight: "Altura do pasto",
				sinceLastCut: "Desde o último corte",
				sinceDate: "desde {{date}}",
				measured: "medido em {{date}}",
				cutOn: "corte em {{date}}",
				noCut: "Nenhum corte registrado",
				title: "Pasto agora",
				swardOverTime: "Altura do pasto ao longo do tempo",
				chartEmpty: "Registre medições de altura para ver a tendência",
				daysUnit_one: "dia",
				daysUnit_other: "dias",
				stocking: "Lotação atual",
				// 1 UA = 450 kg de peso vivo.
				stockingUnit: "UA/ha",
				headPerHaUnit: "cab./ha",
				stockingDetail: "{{head}} cab. · {{units}} UA",
				stockingNoWeight: "{{head}} cab. · sem pesagem",
				stockingNoHerd: "Nenhum lote no piquete",
			},
			records: {
				title: "Registros",
				hint: "As operações e medições registradas neste piquete ficam aqui.",
				created: {
					badge: "Cadastro",
					title: "Piquete cadastrado",
				},
				filterAll: "Todos",
				filterHarvest: "Colheita",
				filterFertility: "Fertilidade",
				showOlder: "Mostrar anteriores",
				empty: "Nenhum registro ainda",
			},
			images: {
				title: "Imagens",
				dropzone:
					"Nenhuma imagem ainda — solte fotos de campo aqui para manter um registro visual junto às medições",
				upload: "Enviar",
				empty: "Nenhuma imagem ainda",
			},
			aside: {
				boundary: "Limite",
				editOnMap: "Editar no mapa",
				cultivars: "Capins e forrageiras",
				manageCultivars: "Gerenciar",
				soilSummary: "Solo e fertilidade",
				sampled: "amostrado em {{date}}",
				openSoil: "Ver solo e fertilidade",
				qualityTargets: "Metas de qualidade",
				setTargets: "Definir metas",
			},
			grazing: {
				guide: {
					open: "Entender {{status}} e os outros estados do pasto",
					title: "Como o estado do pasto é definido",
					intro:
						"Comparamos a última altura registrada com as alturas de entrada e saída da cultivar de maior cobertura. A data da medição importa: o estado pode ter mudado desde então.",
					measuredAt: "Altura medida em",
					thisPaddock: "Este piquete",
					definitions: {
						ready:
							"Altura igual ou acima da entrada. O pasto atingiu a meta para receber animais.",
						grazing:
							"Altura entre saída e entrada, com animais no piquete. O pastejo pode continuar até a altura de saída.",
						waiting:
							"Altura entre saída e entrada, sem animais. Aguarde crescer até a altura de entrada.",
						remove:
							"Altura igual ou abaixo da saída, com animais no piquete. Retire-os para preservar o resíduo de pasto.",
						regrowing:
							"Altura igual ou abaixo da saída, sem animais. Aguarde o rebrote.",
						belowExit:
							"Altura igual ou abaixo da saída, mas sem informação de ocupação para indicar a ação.",
						unknown:
							"Falta altura registrada, cultivar associada ou meta de entrada/saída para comparar.",
					},
				},
				ready: "Pronto para entrada",
				remove: "Retirar animais",
				regrowing: "Aguardar rebrote",
				belowExit: "Abaixo da altura de saída",
				grazing: "Em pastejo",
				waiting: "Aguardar altura de entrada",
				unknown: "Sem avaliação de altura",
				height: "Pasto {{height}} cm",
				basis:
					"{{cultivar}} ({{coverage}}%) · entrada {{entry}} cm / saída {{exit}} cm",
				noCultivar: "Associe uma cultivar para comparar as alturas de manejo.",
				noHeight: "Registre a altura do pasto para avaliar {{cultivar}}.",
				noTargets:
					"{{cultivar}} não tem alturas de entrada e saída cadastradas.",
				title: "Lotes no piquete",
				daysOnPaddock_one: "{{count}} dia no piquete",
				daysOnPaddock_other: "{{count}} dias no piquete",
				plannedDays_one: "plano de {{count}} dia",
				plannedDays_other: "plano de {{count}} dias",
				since: "desde {{date}}",
				rested_one: "Descansando há {{count}} dia",
				rested_other: "Descansando há {{count}} dias",
				neverGrazed: "Nunca pastejado",
				neverGrazedHint:
					"Nenhuma rotação de pastejo foi registrada neste piquete ainda.",
				history: "Lotes que já passaram pelo piquete",
				unknownHerd: "Lote desconhecido",
				viewAll: "Ver todas ({{count}})",
				viewLess: "Ver menos",
			},
			createSuccess: "Piquete criado com sucesso",
			createError: "Falha ao criar piquete",
			updateSuccess: "Piquete atualizado com sucesso",
			updateError: "Falha ao atualizar piquete",
			deleteSuccess: "Piquete excluído com sucesso",
			deleteError: "Falha ao excluir piquete",
			deleteConfirm: {
				title: "Excluir piquete",
				description:
					'Excluir "{{name}}"? Ele não aparecerá mais na gestão de pastagens desta fazenda. Esta ação não pode ser desfeita.',
			},
			cultivarsAssignSuccess: "Forrageira adicionada ao piquete",
			cultivarsAssignError:
				"Não foi possível adicionar a forrageira ao piquete",
			manageCultivars: {
				title: "Capins e forrageiras do piquete",
				description:
					"Informe quais forrageiras estão plantadas neste piquete e quanto da área cada uma ocupa",
				selectCultivar: "Selecione uma forrageira",
				coverage: "Cobertura %",
				addCultivar: "Adicionar forrageira",
				addAnother: "Adicionar",
				removeCultivar: "Remover",
				totalCoverage: "Cobertura total",
				noCultivarsAvailable:
					"Nenhuma forrageira cadastrada. Cadastre uma forrageira primeiro.",
				allCultivarsAssigned:
					"Todas as forrageiras cadastradas já foram adicionadas ao piquete.",
				cultivarNotFound: "Não encontrou a forrageira que procura?",
				registerNewCultivar: "Cadastre uma nova",
				coverageRange: "Informe uma cobertura entre 0 e 100%",
				coverageExceeds: "A cobertura total não pode ultrapassar 100%",
				save: "Salvar Alterações",
				cancel: "Cancelar",
			},
		},
		measurement: {
			list: {
				title: "Medições",
				empty: {
					title: "Nenhuma medição ainda",
					description: "Registre sua primeira medição",
				},
			},
			create: {
				title: "Registrar medição",
			},
			edit: {
				title: "Editar medição",
			},
			delete: {
				title: "Excluir medição",
				confirm:
					"Esta medição será excluída permanentemente. Essa ação não pode ser desfeita.",
			},
			fields: {
				measuredAt: "Data e hora",
				swardHeight: "Altura do pasto",
				biomass: "Massa de forragem estimada",
				swardHeightHelp:
					"Altura média do pasto, medida do solo até o topo das folhas.",
				biomassHelp:
					"Quantidade estimada de matéria seca disponível por hectare (kg MS/ha).",
				biomassMethodHelp:
					"Como a biomassa foi estimada (régua, prato ascendente, estimativa visual, etc.).",
				biomassMethod: "Método de estimativa",
				method: "Método",
				groundCover: "Cobertura do Solo",
				location: "Localização GPS",
				notes: "Observações",
			},
			placeholders: {
				notes: "Observações sobre a condição da pastagem...",
			},
			actions: {
				save: "Salvar medição",
				getLocation: "Usar localização atual",
			},
			methods: {
				HEIGHT_DENSITY_EQUATION: "Equação Altura-Densidade",
				RISING_PLATE_METER: "Prato Ascendente",
				VISUAL_ESTIMATE: "Estimativa Visual",
				CUT_AND_WEIGH: "Corte e Pesagem",
				NIRS_SENSOR: "Sensor NIRS",
				SATELLITE_NDVI: "NDVI por Satélite",
			},
			createSuccess: "Medição registrada com sucesso",
			createError: "Falha ao registrar medição",
			updateSuccess: "Medição atualizada com sucesso",
			deleteSuccess: "Medição excluída com sucesso",
		},
		operation: {
			list: {
				title: "Manejos",
				empty: {
					title: "Nenhum manejo registrado",
					description: "Registre o primeiro manejo",
				},
			},
			create: {
				title: "Registrar manejo",
			},
			edit: {
				title: "Editar manejo",
			},
			delete: {
				title: "Excluir manejo",
				confirm:
					"Este manejo será excluído permanentemente, junto com o custo lançado no financeiro. Essa ação não pode ser desfeita.",
			},
			fields: {
				type: "Tipo de manejo",
				performedAt: "Data e hora",
				cost: "Custo total",
				notes: "Observações",
			},
			placeholders: {
				notes: "Observações sobre o manejo...",
			},
			actions: {
				save: "Salvar manejo",
			},
			types: {
				GRAZING: "Pastejo",
				CUTTING: "Corte",
				MOWING: "Roçada",
				FERTILIZATION: "Adubação",
				LIMING: "Calagem",
				IRRIGATION: "Irrigação",
				WEED_CONTROL: "Controle de plantas daninhas",
				PEST_CONTROL: "Controle de Pragas",
				RENOVATION: "Renovação",
				SOIL_PREPARATION: "Preparo do Solo",
			},
			grazing: {
				title: "Dados do pastejo",
				animalCount: "Número de animais",
				animalType: "Categoria animal",
				entryBiomass: "Massa de forragem na entrada",
				exitBiomass: "Massa de forragem na saída",
			},
			fertilization: {
				title: "Detalhes da Adubação",
				product: "Produto",
				rate: "Dose aplicada",
				nitrogen: "Nitrogênio aplicado",
			},
			cutting: {
				title: "Detalhes do Corte",
				height: "Altura de Corte",
				yield: "Rendimento",
				destination: "Destino",
				destinations: {
					hay: "Feno",
					silage: "Silagem",
					fresh: "Forragem verde",
				},
			},
			createSuccess: "Manejo registrado com sucesso",
			createError: "Não foi possível registrar o manejo",
			updateSuccess: "Manejo atualizado com sucesso",
			deleteSuccess: "Manejo excluído com sucesso",
		},
		soilLabReport: {
			eyebrow: "Documentos da fazenda",
			pageTitle: "Importar Laudo de Solo",
			pageSubtitle:
				"Envie um laudo, confira os valores lidos e acompanhe suas importações anteriores.",
			importAction: "Importar laudo",
			importing: "Importando análises...",
			importSuccess: "Análises de solo importadas",
			steps: {
				upload: "Enviar",
				extract: "Extrair",
				review: "Revisar",
			},
			disclaimer: {
				title: "Antes de começar",
				body: "Esta importação existe para poupar sua digitação: nossa visão computacional lê os valores direto do seu laudo. Ela acerta na maioria dos laudos, mas a qualidade da digitalização, anotações à mão ou um layout fora do comum podem fazer um valor sair diferente do papel.",
				checkAdvice:
					"Você verá todos os valores extraídos na etapa de revisão — compare-os com o laudo original antes de confirmar. Nada é salvo até lá.",
				confirm: "Entendi, iniciar a importação",
			},
			upload: {
				title: "Enviar laudo de análise de solo",
				helper:
					"Envie o laudo em PDF ou uma foto. A IA extrai os resultados de cada amostra para você revisar antes de salvar.",
				chooseFile: "Escolher arquivo",
				submit: "Enviar e extrair",
				unsupportedType:
					"Tipo de arquivo não suportado. Envie um PDF ou imagem (JPEG, PNG, WebP).",
			},
			extracting: {
				title: "Extraindo o laudo...",
				helper: "Isso pode levar alguns instantes. A página atualiza sozinha.",
				failedTitle: "Falha na extração",
				failedHelper: "Não foi possível extrair o laudo. Tente novamente.",
				retry: "Tentar novamente",
			},
			review: {
				title: "Revisar e mapear amostras",
				paddock: "Piquete",
				selectPaddock: "Selecione o piquete",
				paddocks: "Piquetes",
				selectPaddocks: "Selecione os piquetes",
				selectAllPaddocks: "Selecionar todos os piquetes",
				deselectAllPaddocks: "Limpar seleção",
				nPaddocksSelected_one: "{{count}} piquete selecionado",
				nPaddocksSelected_other: "{{count}} piquetes selecionados",
				crossCheck: "Conferência (calculado / impresso)",
				mismatchHint:
					"Algum índice calculado diverge do impresso — verifique os valores (possível erro de leitura).",
				unrecognizedUnit:
					'A unidade "{{unit}}" não é reconhecida — selecione a unidade correspondente para que este valor seja usado.',
				mapAllError: "Mapeie cada amostra para um piquete.",
				duplicatePaddockError:
					"Cada amostra deve ir para um piquete diferente.",
				collisionError:
					"As Glebas {{glebaA}} e {{glebaB}} estão mapeadas para o mesmo piquete ({{paddock}}), com a mesma data de coleta e a mesma profundidade. Ajuste o mapeamento de uma das duas.",
				repeatedPaddockError:
					"O piquete {{paddock}} está selecionado mais de uma vez na Gleba {{gleba}}. Remova a repetição.",
				skipWarning:
					"Glebas sem piquete selecionado não serão importadas: {{glebas}}",
				skipCannotReimport:
					"Este laudo não pode ser importado de novo — o que ficar sem piquete será perdido.",
				skipAcknowledge: "Entendi que estas Glebas não serão importadas",
				allSkippedError:
					"Selecione ao menos um piquete em pelo menos uma Gleba antes de importar.",
				sampleN: "Amostra {{n}}",
				importing: "Importando...",
				confirm_one: "Confirmar e criar {{count}} análise",
				confirm_other: "Confirmar e criar {{count}} análises",
			},
			indices: {
				sumOfBases: "SB",
				effectiveCec: "t",
				totalCec: "T",
				baseSaturation: "V%",
				aluminumSaturation: "m%",
			},
		},
		soilAnalysis: {
			reference: {
				label: "Referência para interpretação do solo",
				source: "Consultar fonte científica",
				unclassified: "Sem critério aplicável nesta referência",
				loadError: "Não foi possível carregar as referências de solo.",
				saveError: "Não foi possível salvar a referência escolhida.",
			},
			empty: "Nenhuma análise de solo registrada",
			addFirst:
				"Adicione sua primeira análise de solo para acompanhar a saúde do solo",
			addButton: "Adicionar Análise de Solo",
			addTitle: "Adicionar Análise de Solo",
			resultsSection: "Resultados do Laboratório",
			formIntro:
				"Transcreva os valores do laudo do laboratório. Deixe em branco o que não tiver — apenas o que for preenchido é interpretado.",
			valuesLabel: "valores",
			optionalNote: "Todos os campos são opcionais",
			glebaBadgeUnshared: "{{name}}",
			glebaBadge_one: "{{name}} · compartilhada com mais {{count}} piquete",
			glebaBadge_other: "{{name}} · compartilhada com mais {{count}} piquetes",
			sections: {
				metadata: "Amostra e Laboratório",
				acidity: "Acidez e Matéria Orgânica",
				phosphorus: "Fósforo (por método)",
				cations: "Cátions Trocáveis e Enxofre",
				micronutrients: "Micronutrientes",
				texture: "Textura",
			},
			sectionDesc: {
				metadata:
					"Quando e onde a amostra foi coletada, e o formato de unidades do laboratório.",
				acidity:
					"Reação do solo e matéria orgânica — a base para calagem e fertilidade.",
				phosphorus:
					"Informe o método de extração que o seu laboratório reportou.",
				cations:
					"Bases trocáveis, acidez e enxofre que definem a saturação por bases.",
				micronutrients:
					"Elementos traço — preencha apenas os que o laboratório mediu.",
				texture:
					"Frações granulométricas usadas para derivar a classe textural.",
			},
			systems: {
				IAC: "IAC (Boletim 100)",
				CFSEMG: "CFSEMG (5ª Aproximação)",
				EMBRAPA_CERRADO: "Embrapa Cerrado",
			},
			fields: {
				sampleDate: "Data da Amostra",
				sampleDateOptional: "Data da Amostra (opcional)",
				labEntrada: "Data de Entrada (Lab)",
				labSaida: "Data de Saída (Lab)",
				labName: "Laboratório",
				labReportNumber: "Número do Laudo",
				interpretationSystem: "Sistema de Interpretação",
				labUnitPreset: "Formato de unidades do laboratório",
				depthTop: "Profundidade de (cm)",
				depthBottom: "Profundidade até (cm)",
				soilTypeCode: "Código do Tipo de Solo",
				clayActivity: "Atividade da Argila (T)",
				ph: "pH",
				phWater: "pH (H₂O)",
				phCaCl2: "pH (CaCl₂)",
				phKCl: "pH (KCl)",
				organicMatter: "Matéria Orgânica",
				organicCarbon: "Carbono Orgânico (C.O.)",
				phosphorus: "Fósforo (P)",
				phosphorusMehlich: "P (Mehlich-1)",
				phosphorusResin: "P (resina)",
				phosphorusMehlich3: "P (Mehlich-3)",
				phosphorusRemaining: "P remanescente (P-rem)",
				phosphorusTotal: "P total",
				potassium: "Potássio (K)",
				calcium: "Cálcio (Ca)",
				magnesium: "Magnésio (Mg)",
				sodium: "Sódio (Na)",
				aluminum: "Alumínio (Al)",
				hydrogenAluminum: "H + Al",
				sulfur: "Enxofre (S)",
				boron: "Boro (B)",
				copper: "Cobre (Cu)",
				iron: "Ferro (Fe)",
				manganese: "Manganês (Mn)",
				zinc: "Zinco (Zn)",
				clay: "Argila",
				silt: "Silte",
				sand: "Areia",
			},
			createSuccess: "Análise de solo adicionada com sucesso",
			createError: "Falha ao adicionar análise de solo",
			updateSuccess: "Análise de solo atualizada com sucesso",
			updateError: "Falha ao atualizar análise de solo",
			deleteSuccess: "Análise de solo excluída com sucesso",
			deleteError: "Falha ao excluir análise de solo",
			editTitle: "Editar Análise de Solo",
			details: {
				open: "Detalhes",
				title: "Análise de solo · {{date}}",
				notFound: "Análise de solo não encontrada",
				sampleTitle: "Amostra",
				imported: "Importada do laudo",
				manual: "Digitada manualmente",
				depth: "Profundidade",
				gleba: "Gleba",
				valuesTitle: "Valores medidos",
				noValues: "Nenhum valor registrado nesta análise.",
				notRequested: "não solicitado",
				sourceFile: "Laudo",
				openInNewTab: "Abrir em nova aba",
			},
			samplesLabel: "Amostras",
			viewReportError: "Não foi possível abrir o laudo",
			showDerivedIndices: "Mostrar todos os índices derivados",
			hideDerivedIndices: "Ocultar índices derivados",
			analysisTitle: "Análise",
			derivedLabel: "Derivados:",
			deleteTitle: "Excluir Análise de Solo",
			confirmDelete:
				"Tem certeza que deseja excluir esta análise de solo? Esta ação não pode ser desfeita.",
			trend: {
				title: "Evolução da fertilidade",
				needMore:
					"Adicione uma segunda análise com data para ver como pH, P e V% variam entre amostragens.",
			},
			interpretation: {
				title: "Interpretação",
				insufficient: "Dados insuficientes para interpretar esta análise.",
				noDate: "sem data",
				cationUnit: "Unidade dos cátions",
				texturalClass: "Classe textural",
				measured: "medido",
				derived: "derivado",
				warnings: "Observações",
			},
			indices: {
				baseSaturation: "Saturação por bases (V%)",
				aluminumSaturation: "Saturação por alumínio (m%)",
			},
			scale: {
				label: "{{level}} — {{zone}}",
				marker: "Esta amostra",
				zones: {
					bad: "Problema",
					attention: "Atenção",
					good: "Bom",
				},
			},
			levels: {
				muito_baixo: "muito baixo",
				baixo: "baixo",
				medio: "médio",
				adequado: "adequado",
				alto: "alto",
				muito_alto: "muito alto",
			},
			classLabels: {
				phWater: "pH",
				phosphorusMehlich: "P",
				phosphorusMehlich3: "P (M3)",
				potassium: "K",
				calcium: "Ca",
				magnesium: "Mg",
				aluminum: "Al",
				organicMatter: "M.O.",
				baseSaturation: "V%",
				aluminumSaturation: "m%",
				effectiveCec: "t",
				totalCec: "T",
			},
			texturalClass: {
				arenosa: "Arenosa",
				media: "Média",
				argilosa: "Argilosa",
				muito_argilosa: "Muito argilosa",
			},
		},
		cultivar: {
			list: {
				title: "Capins e forrageiras",
				description:
					"Esta lista reúne as forrageiras e seus indicadores médios. As forrageiras do sistema trazem valores de referência; você pode cadastrar uma forrageira própria com ajustes para a sua realidade.",
				searchPlaceholder: "Buscar por nome, espécie ou variedade",
				sourceFilter: "Filtrar por origem",
				filters: {
					all: "Todas",
					organization: "Personalizadas",
					system: "Do sistema",
				},
				resultCount: "{{count}} de {{total}} forrageiras",
				noResults: "Nenhuma forrageira encontrada",
				noResultsDescription: "Tente outro termo ou altere o filtro de origem.",
				clearFilters: "Limpar filtros",
				systemDialog: {
					title: "Forrageira do sistema",
					description:
						"Forrageiras do sistema não podem ser editadas. Crie uma forrageira própria com nome, alturas de pastejo e descanso preenchidos a partir desta. A densidade e as fontes continuam como referências do sistema.",
					createFromSystem: "Criar a partir desta",
				},
				columns: {
					cultivar: "Forrageira",
					grazing: "Alturas de pastejo",
					rest: "Descanso",
					density: "Densidade de referência",
				},
				minimum: "Mínimo",
				maximum: "Máximo",
				densityUnit: "kg MS/ha/cm",
				empty: {
					title: "Nenhuma forrageira cadastrada",
					description:
						"Cadastre os capins e outras forrageiras usados nos piquetes",
				},
			},
			create: {
				title: "Cadastrar forrageira",
			},
			edit: {
				title: "Editar forrageira",
			},
			fields: {
				species: "Espécie",
				variety: "Variedade",
				commonName: "Nome comum",
				source: "Origem",
				entryHeight: "Altura de entrada (cm)",
				exitHeight: "Altura de saída (cm)",
				residualHeight: "Altura do resíduo (cm)",
				restDaysMin: "Descanso mínimo (dias)",
				restDaysMax: "Descanso máximo (dias)",
			},
			placeholders: {
				species: "ex., Urochloa brizantha",
				variety: "ex., Marandu",
				commonName: "ex., Brachiaria Marandu",
			},
			required: "obrigatório",
			sections: {
				heights: {
					title: "Alturas de pastejo e descanso",
					optional: "opcional",
					body: "Adicione estes e o piquete avisa quando entrar e sair com o rebanho. Deixe em branco e a forrageira ainda funciona — você só não recebe esses alertas.",
				},
			},
			help: {
				species: "O nome botânico impresso no saco de semente.",
				variety: "O nome da cultivar, logo após a espécie.",
				commonName:
					"O nome que sua equipe fala no dia a dia. É o que aparece nos piquetes e registros.",
			},
			suggestion: {
				text: "A maioria das fazendas chamaria de <b>{{name}}</b>.",
				useIt: "Usar",
			},
			measures: {
				remove: "remover",
				units: {
					cm: "cm",
					days: "dias",
				},
				entry: {
					label: "Altura de entrada",
					help: "Quão alto o capim está quando o rebanho entra.",
				},
				exit: {
					label: "Altura de saída",
					help: "Quando o rebanho deve sair, antes de rebaixar demais.",
				},
				residual: {
					label: "Altura do resíduo",
					help: "O que fica em pé após o pastejo. É o que rebrota.",
				},
				minRest: {
					label: "Descanso mínimo",
					help: "Menor intervalo antes de pastejar o piquete de novo.",
				},
				maxRest: {
					label: "Descanso máximo",
					help: "Maior intervalo antes de o capim passar do ponto.",
				},
			},
			diagram: {
				eyebrow: "O QUE ISSO SIGNIFICA",
				meaning:
					"O rebanho entra com {{entry}} cm e sai com {{exit}} cm. Abaixo disso a planta gasta as reservas para rebrotar.",
				prompt:
					"Preencha as alturas de entrada e saída para ver a janela de pastejo desta forrageira.",
				entry: "Entrada",
				exit: "Saída",
				residual: "Resíduo",
			},
			status: {
				blocked: "Espécie, variedade e nome comum são obrigatórios",
				readyWithAlerts: "Pronto para salvar com alertas de pastejo ativados",
				readyLater: "Pronto para salvar — as alturas podem vir depois",
			},
			validation: {
				exitBelowEntry:
					"A altura de saída deve ser menor que a de entrada ({{entry}} cm).",
				residualVsExit:
					"O resíduo costuma ser igual ou menor que a altura de saída.",
				maxRestVsMin:
					"O descanso máximo deve ser maior que o mínimo ({{minRest}} dias).",
			},
			source: {
				system: "Sistema",
				organization: "Personalizado",
			},
			actions: {
				create: "Cadastrar forrageira",
				createShort: "Forrageira",
			},
			createSuccess: "Forrageira cadastrada com sucesso",
			createError: "Não foi possível cadastrar a forrageira",
			updateSuccess: "Forrageira atualizada com sucesso",
			updateError: "Não foi possível atualizar a forrageira",
		},
		map: {
			title: "Mapa de Piquetes",
			legend: "Legenda",
			basemap: {
				label: "Mapa base",
				street: "Mapa",
				satellite: "Satélite",
			},
			colorBy: "Colorir por",
			colorByStatus: "Status",
			colorByBiomass: "Biomassa",
			selectPaddock: "Selecione um piquete para ver detalhes",
			viewDetails: "Ver Detalhes",
			paddockList: "Piquetes",
			noBoundaries: "Nenhum piquete possui limites de mapa definidos",
			noBoundary: "Limite não definido",
			biomass: {
				low: "Baixa (<1500 kg/ha)",
				medium: "Média (1500-2500 kg/ha)",
				good: "Boa (2500-3500 kg/ha)",
				high: "Alta (>3500 kg/ha)",
			},
		},
		alert: {
			title: "Alertas",
			acknowledgeSuccess: "Alerta reconhecido",
			acknowledgeError: "Falha ao reconhecer alerta",
			resolveSuccess: "Alerta resolvido",
			resolveError: "Falha ao resolver alerta",
			noAlerts: "Nenhum alerta encontrado",
			filterByStatus: "Filtrar por status",
			filterBySeverity: "Filtrar por severidade",
			severity: {
				CRITICAL: "Crítico",
				HIGH: "Alto",
				MEDIUM: "Médio",
				LOW: "Baixo",
			},
			statuses: {
				ACTIVE: "Ativo",
				ACKNOWLEDGED: "Reconhecido",
				RESOLVED: "Resolvido",
				DISMISSED: "Dispensado",
			},
		},
		recommendation: {
			title: "Recomendações de IA",
			approveSuccess: "Recomendação aprovada",
			approveError: "Falha ao aprovar recomendação",
			rejectSuccess: "Recomendação rejeitada",
			rejectError: "Falha ao rejeitar recomendação",
			rejectTitle: "Rejeitar Recomendação",
			rejectReasonPlaceholder:
				"Por favor, forneça um motivo para a rejeição...",
			confirmReject: "Confirmar Rejeição",
			noRecommendations: "Nenhuma recomendação encontrada",
			filterByStatus: "Filtrar por status",
			statuses: {
				PENDING: "Pendente",
				APPROVED: "Aprovada",
				REJECTED: "Rejeitada",
				EXPIRED: "Expirada",
			},
		},
		forecast: {
			title: "Previsões de Crescimento",
			noData: "Dados de previsão não disponíveis",
			readyForGrazing: "Pronto para Pastejo",
			approachingOptimal: "Aproximando do Ideal",
			avgGrowthRate: "Taxa Média de Crescimento",
			needsRest: "Precisa Descansar",
			kgHaDay: "kg/ha/dia",
			daysToOptimal: "dias para o ideal",
			paddockForecasts: "Previsões por Piquete",
			statuses: {
				ready: "Pronto",
				approaching: "Aproximando",
				resting: "Descansando",
				overgrown: "Crescido Demais",
			},
		},
		planning: {
			dashboard: {
				title: "Painel de Planejamento",
				subtitle: "Gerencie planos anuais e táticos",
			},
			kpi: {
				activePlans: "Planos Ativos",
				pendingTasks: "Tarefas Pendentes",
				completedThisMonth: "Concluídas Este Mês",
				totalTasks: "Total de Tarefas",
				totalPlans: "Total de Planos",
			},
			status: {
				label: "Status",
				DRAFT: "Rascunho",
				APPROVED: "Aprovado",
				ACTIVE: "Ativo",
				COMPLETED: "Concluído",
				CANCELLED: "Cancelado",
			},
			annual: {
				title: "Planos Anuais",
				subtitle: "Gerencie planos de produção anuais",
				activePlans: "Planos Ativos",
				recentPlans: "Planos Recentes",
				noActivePlans: "Nenhum plano ativo",
				noPlans: "Nenhum plano anual",
				noPlansDesc: "Crie seu primeiro plano anual para começar",
				create: "Criar Plano Anual",
				createTitle: "Criar Plano Anual",
				createSubtitle: "Configure um novo plano de produção anual",
				createSuccess: "Plano anual criado com sucesso",
				createError: "Falha ao criar plano anual",
				updateSuccess: "Plano anual atualizado com sucesso",
				updateError: "Falha ao atualizar plano anual",
				deleteSuccess: "Plano anual excluído com sucesso",
				deleteError: "Falha ao excluir plano anual",
				deleteConfirmTitle: "Excluir Plano Anual",
				deleteConfirmDescription:
					"Tem certeza que deseja excluir este plano anual? Esta ação não pode ser desfeita e também excluirá todos os planos táticos associados.",
				editStatus: "Editar Status do Plano",
				details: "Detalhes do Plano",
				name: "Nome do Plano",
				namePlaceholder: "ex: Plano de Produção 2024",
				year: "Ano",
				description: "Descrição",
				descriptionPlaceholder: "Descreva os objetivos do plano...",
				yieldTarget: "Meta de Produção",
				budget: "Orçamento",
				targets: "Metas",
				createdAt: "Criado Em",
			},
			tactical: {
				title: "Planos Táticos",
				noPlans: "Nenhum plano tático para este plano anual",
				create: "Criar Plano Tático",
				createSuccess: "Plano tático criado com sucesso",
				createError: "Falha ao criar plano tático",
				updateSuccess: "Plano tático atualizado com sucesso",
				updateError: "Falha ao atualizar plano tático",
				deleteSuccess: "Plano tático excluído com sucesso",
				deleteError: "Falha ao excluir plano tático",
				name: "Nome do Plano",
				namePlaceholder: "ex: Plano de Pastejo de Primavera",
				startDate: "Data de Início",
				endDate: "Data de Término",
				description: "Descrição",
				descriptionPlaceholder: "Descreva o plano tático...",
			},
			quickLinks: {
				tasks: "Tarefas",
				tasksDesc: "Gerencie operações de campo",
				rotation: "Planejador de Rotação",
				rotationDesc: "Planeje rotações de pastejo",
				analytics: "Análises",
				analyticsDesc: "Visualize métricas de desempenho",
			},
			tasks: {
				status: {
					pending: "Pendente",
					scheduled: "Agendada",
					in_progress: "Em Andamento",
					completed: "Concluída",
					cancelled: "Cancelada",
				},
				priority: {
					critical: "Crítica",
					high: "Alta",
					medium: "Média",
					low: "Baixa",
				},
				kanbanView: "Visualização Kanban",
				kanbanDescription: "Organize tarefas por status com arrastar e soltar",
				listView: "Visualização Lista",
				calendarView: "Visualização Calendário",
				selectEstablishment: "Selecionar Fazenda",
				selectEstablishmentPrompt:
					"Selecione uma fazenda para visualizar tarefas",
				markComplete: "Marcar como Concluída",
				detail: {
					scheduledDate: "Data Prevista",
					dueDate: "Prazo",
					priority: "Prioridade",
					duration: "Duração",
					establishment: "Fazenda",
					assignedTo: "Responsável",
					domain: "Módulo",
					objective: "Objetivo",
					completedAt: "Concluída em {{date}}",
					completedBy: "por {{name}}",
				},
			},
			objectives: {
				annual: {
					createSuccess: "Objetivo anual criado com sucesso",
					createError: "Falha ao criar objetivo anual",
					updateSuccess: "Objetivo anual atualizado com sucesso",
					updateError: "Falha ao atualizar objetivo anual",
					deleteSuccess: "Objetivo anual excluído com sucesso",
					deleteError: "Falha ao excluir objetivo anual",
				},
				tactical: {
					createSuccess: "Objetivo tático criado com sucesso",
					createError: "Falha ao criar objetivo tático",
					updateSuccess: "Objetivo tático atualizado com sucesso",
					updateError: "Falha ao atualizar objetivo tático",
					deleteSuccess: "Objetivo tático excluído com sucesso",
					deleteError: "Falha ao excluir objetivo tático",
				},
			},
		},
		rotation: {
			title: "Planejador de Rotação",
			subtitle: "Planeje e gerencie rotações de pastejo",
			kpi: {
				totalSlots: "Total de Slots",
				activeSlots: "Slots Ativos",
				plannedSlots: "Slots Planejados",
				conflicts: "Conflitos",
			},
			conflicts: {
				title: "Conflitos de Agendamento",
			},
			calendar: {
				title: "Calendário de Rotação",
				paddock: "Piquete",
			},
		},
		analytics: {
			title: "Painel de Análises",
			subtitle: "Indicadores e análises de desempenho",
			export: "Exportar",
			noData: "Sem dados disponíveis para este período",
			timeRange: {
				"7d": "Últimos 7 dias",
				"30d": "Últimos 30 dias",
				"90d": "Últimos 90 dias",
				"1y": "Último ano",
				all: "Todo o período",
			},
			tabs: {
				growth: "Crescimento",
				operations: "Operações",
				economic: "Econômico",
			},
			growth: {
				avgGrowthRate: "Taxa Média de Crescimento",
				totalBiomass: "Biomassa Total",
				paddocksAnalyzed: "Piquetes Analisados",
				measurementCount: "Medições",
			},
			operations: {
				totalOperations: "Total de Operações",
				completedOperations: "Concluídas",
				avgDuration: "Duração Média",
				efficiency: "Eficiência",
				byType: "Operações por Tipo",
			},
			economic: {
				totalRevenue: "Receita Total",
				totalCosts: "Custos Totais",
				netProfit: "Lucro Líquido",
				roi: "ROI",
				breakdown: "Detalhamento de Custos",
			},
		},
		assistant: {
			memories: "Memórias",
			memoryAuthor: "Informada por {{name}}",
			myMemories: "Minhas",
			farmMemories: "Da fazenda",
			noMemories: "Nenhuma memória salva",
			deleteMemory: "Excluir memória",
			title: "Assistente de IA",
			subtitle: "Receba análises e recomendações da IA",
			conversations: "Conversas",
			noConversations: "Nenhuma conversa ainda",
			newConversation: "Nova Conversa",
			welcomeTitle: "Como posso ajudar com a fazenda hoje?",
			welcomeSubtitle:
				"Pergunte sobre pecuária, piquetes ou clima em todas as suas fazendas ou em uma fazenda específica.",
			openChat: "Abrir assistente",
			openFullView: "Abrir tela cheia",
			chattingAboutFarm: "Assistente da fazenda",
			generalAssistant: "Assistente geral",
			welcome: {
				title: "Como posso ajudar você hoje?",
				description:
					"Pergunte sobre produção de pastagem, gestão de piquetes ou obtenha recomendações para sua fazenda.",
			},
			thinking: "Pensando...",
			processing: "Processando...",
			emptyThread: "Faça uma pergunta para começar.",
			deleteConversation: "Excluir conversa",
			agents: {
				livestock: "Consultando especialista em pecuária...",
				pasture: "Consultando especialista em pastagem...",
				weather: "Verificando dados climáticos...",
				planning: "Revisando o planejamento...",
				equipment: "Verificando os equipamentos...",
				economics: "Analisando as finanças...",
			},
			allFarms: "Todas as fazendas",
			scopedTo: "Conversa será focada em",
			suggestions: "Perguntas sugeridas",
			suggestedPrompts: [
				"Quantos animais eu tenho no total em todas as fazendas?",
				"Como estão os piquetes em todas as minhas fazendas?",
				"Quais fazendas eu tenho cadastradas?",
				"Quais são as melhores práticas de manejo de gado?",
			],
			inputPlaceholder: "Faça uma pergunta sobre sua fazenda...",
			sending: "Enviando mensagem...",
			sendMessage: "Enviar mensagem",
			sendError: "Falha ao enviar mensagem",
			inputTooLong: "Mensagem muito longa",
			proposalFlushError:
				"As alterações citadas nesta resposta não puderam ser enviadas para aprovação. Nada foi registrado — peça novamente.",
			// Terminal failure of a chat turn (BUG-3) — the bubble shows one of
			// these plus a Retry action instead of staying permanently empty.
			turnFailed: "Não foi possível concluir esta resposta.",
			streamStalled:
				"A resposta parou de chegar. Verifique sua conexão e tente novamente.",
			streamDeadline:
				"A resposta demorou mais do que o esperado e foi cancelada. Tente novamente.",
			// O stream fechou sem dizer que o turno terminou — conexão caiu, não é
			// uma resposta concluída.
			streamIncomplete:
				"A conexão foi encerrada antes da resposta terminar. Tente novamente.",
			// Falha interna do servidor (código INTERNAL_ERROR) — a mensagem crua em
			// inglês do backend nunca deve chegar a um balão do chat.
			internalError:
				"Ocorreu um erro interno ao processar sua pergunta. Tente novamente em instantes.",
			retry: "Tentar novamente",
			createSuccess: "Conversa criada",
			createError: "Falha ao criar conversa",
			deleteSuccess: "Conversa excluída",
			deleteError: "Falha ao excluir conversa",
			voiceInput: {
				record: "Gravar mensagem de voz",
				stopRecording: "Parar gravação",
				transcribing: "Transcrevendo...",
				autoSend: "Enviar automaticamente",
				transcriptionError: "Falha ao transcrever o áudio",
				unavailable: "Entrada por voz indisponível no momento",
				recording: "Gravando…",
				cancelRecording: "Descartar gravação",
				confirmRecording: "Parar e transcrever",
				remaining: "{{seconds}} s restantes",
				sendingIn: "Enviando em {{seconds}} s — toque para editar",
				cutShort:
					"A gravação foi interrompida. O texto captado fica no campo para você revisar antes de enviar.",
				startFailed:
					"A gravação não começou. Toque no microfone para tentar de novo.",
				alreadyTranscribed:
					"Esta gravação já foi transcrita. Grave de novo para enviar o texto.",
				transcriptionInProgress:
					"Esta gravação ainda está sendo transcrita. Tente de novo em instantes.",
				retry: "Tentar novamente",
				micDeniedIosApp:
					"Microfone bloqueado. Abra Ajustes → o app → Microfone e permita o acesso.",
				micDeniedAndroid:
					"Microfone bloqueado. Toque no cadeado da barra de endereço → Permissões → Microfone.",
				micDeniedDefault:
					"Microfone bloqueado. Permita o acesso ao microfone nas configurações do navegador.",
				micNotFound: "Nenhum microfone encontrado neste dispositivo",
				micInUse: "O microfone está sendo usado por outro app",
				explainerTitle: "Falar com o assistente",
				explainerBody:
					"O navegador vai pedir acesso ao microfone. A gravação só acontece enquanto a barra de gravação estiver aberta, e o áudio não é guardado depois da transcrição.",
				explainerContinue: "Continuar",
				explainerCancel: "Agora não",
			},
			voiceOutput: {
				play: "Ouvir resposta",
				stop: "Parar áudio",
				autoPlay: "Ouvir respostas automaticamente",
				truncatedHint: "Áudio resumido — a resposta completa está no texto",
			},
			voice: {
				title: "Assistente de Voz",
				startVoice: "Iniciar Chat por Voz",
				stopVoice: "Parar Chat por Voz",
				connecting: "Conectando...",
				connected: "Conectado",
				listening: "Ouvindo...",
				processing: "Processando...",
				speaking: "Falando...",
				idle: "Pronto",
				disconnected: "Desconectado",
				error: "Erro",
				micPermissionDenied: "Acesso ao microfone negado",
				micPermissionPrompt:
					"Por favor, permita acesso ao microfone para usar o chat por voz",
				micNotSupported: "Microfone não suportado neste navegador",
				connectionFailed: "Falha ao conectar ao servidor de voz",
				transcription: "Transcrição",
				tapToSpeak: "Toque para falar",
				releaseToSend: "Solte para enviar",
				holdToSpeak: "Segure para falar",
				speakNow: "Fale agora...",
				noAudioDetected: "Nenhum áudio detectado",
				audioLevel: "Nível de áudio",
				retryConnection: "Tentar Novamente",
				endSession: "Encerrar Sessão",
				quality: {
					noInput: "Nenhum áudio detectado. Verifique seu microfone.",
					tooQuiet: "Áudio muito baixo. Fale mais alto ou aproxime-se.",
					tooLoud: "Áudio muito alto. Fale mais baixo ou afaste-se.",
				},
			},
		},
	},
	feasibility: {
		nav: {
			title: "Análise de viabilidade",
		},
		study: {
			createSuccess: "Estudo de viabilidade criado",
			createError: "Falha ao criar estudo",
			updateSuccess: "Estudo atualizado",
			updateError: "Falha ao atualizar estudo",
			deleteSuccess: "Estudo excluído",
			deleteError: "Falha ao excluir estudo",
			calculating: "Executando análise...",
			calculateSuccess: "Análise concluída",
			calculateError: "Falha na análise",
		},
		list: {
			title: "Estudos de viabilidade",
			newStudy: "Novo estudo",
			noStudies: "Nenhum estudo de viabilidade ainda",
			createFirst:
				"Crie seu primeiro estudo de viabilidade para analisar uma operação de cria",
		},
		new: {
			lede: "Monte um estudo de viabilidade da atividade. Informe o rebanho, a oferta de forragem, os custos e as receitas; depois, calcule a projeção.",
			formTitle: "Detalhes do estudo",
			formSubtitle: "Dê um nome ao estudo e escolha onde ele será executado.",
			typeSection: "Tipo de operação",
			typeSectionHint: "Escolha o tipo de operação a modelar.",
			whatsNextTitle: "O que vem a seguir",
			whatsNextSubtitle:
				"Depois de criar o estudo, você passará por estas seções:",
			whatsNextNote:
				"Nada é definitivo até executar a análise — você pode revisar cada seção.",
			descriptions: {
				COW_CALF:
					"Projete uma atividade de cria, considerando nascimentos, desmama, vendas, disponibilidade de forragem e custos.",
			},
		},
		types: {
			COW_CALF: "Cria de gado de corte",
		},
		status: {
			DRAFT: "Rascunho",
			PENDING_CALC: "Calculando",
			CALCULATED: "Calculado",
			ERROR: "Erro",
		},
		verdict: {
			GO: "Viável",
			CONDITIONAL_GO: "Viável com condições",
			NO_GO: "Inviável",
		},
		wizard: {
			steps: {
				farmForage: "Fazenda e forragem",
				herdDefinition: "Composição do rebanho",
				reproductionSurvival: "Reprodução e sobrevivência",
				nutritionIntake: "Nutrição e consumo",
				commercialFinancial: "Comercial e financeiro",
				review: "Revisão",
			},
			runAnalysis: "Calcular análise",
			recalculate: "Recalcular",
			review: {
				title: "Revise os dados informados",
				allComplete:
					"Todas as seções estão completas. Você pode executar a análise.",
				incomplete:
					"Por favor, complete todas as seções obrigatórias antes de executar a análise.",
				stepIncomplete: "Esta seção precisa ser completada",
				requiredSections:
					"Complete todas as seções obrigatórias para prosseguir",
				farmForage: {
					pastureCount: "Tipos de pasto: {{count}}",
					totalArea: "{{area}} ha de área total",
					waterPoints: "Pontos de água: {{count}}",
				},
				herdDefinition: {
					breedingCows: "{{count}} matrizes",
					bulls: "{{count}} touros",
					target: "Meta: {{count}} matrizes",
				},
				reproductionSurvival: {
					pregnancyRate: "{{rate}}% taxa de prenhez",
					weaningWeight: "{{weight}} kg peso de desmama",
				},
				nutritionIntake: {
					cowWeight: "{{weight}} kg peso de vaca adulta",
					bullWeight: "{{weight}} kg peso de touro",
				},
				commercialFinancial: {
					calfPrice: "{{price}} {{currency}}/kg preço do bezerro",
					startingCash: "{{amount}} {{currency}} capital inicial",
				},
			},
		},
		cowcalf: {
			farmForage: {
				location: {
					title: "Localização e clima",
					description:
						"Defina a estação chuvosa e o risco de seca para sua região",
					wetSeasonMonths: "Meses do período chuvoso",
					droughtFrequency: "Frequência de seca",
					droughtFrequencyHint: "Ex.: 0,2 significa uma seca a cada 5 anos",
				},
				waterAccess: {
					title: "Disponibilidade de água",
					description: "Bebedouros, açudes e outras fontes de água para o gado",
					waterPoints: "Número de pontos de água",
					maxWalkingDistance: "Distância máxima até a água (km)",
					reliabilityScore: "Segurança do abastecimento",
				},
				pasture: {
					title: "Áreas de pasto",
					description:
						"Informe os tipos de pasto, as áreas e a capacidade de produção",
					addPasture: "Adicionar tipo de pasto",
					name: "Nome do pasto",
					areaHa: "Área (ha)",
					condition: "Condição",
					utilizationPercent: "% de Utilização",
				},
			},
			herdDefinition: {
				startingHerd: {
					title: "Rebanho inicial",
					description: "Composição atual do rebanho",
					breedingCows: "Matrizes",
					bulls: "Touros",
					heifers12to24: "Novilhas 12-24 meses",
					heifers0to12: "Novilhas 0-12 meses",
				},
				targetHerd: {
					title: "Rebanho planejado",
					description: "Objetivos de crescimento para sua operação",
					targetFemales: "Número desejado de matrizes",
					rampUpStrategy: "Estratégia de Crescimento",
					targetYear: "Ano Alvo",
					strategies: {
						PURCHASE: "Compra",
						RETAIN: "Reter novilhas para reposição",
						HYBRID: "Compra e retenção",
					},
				},
				breedingSystem: {
					title: "Sistema de Reprodução",
					description: "Estação de monta e manejo de touros",
					breedingMonths: "Meses da Estação de Monta",
					bullCowRatio: "Relação touro:vaca",
				},
			},
			reproductionSurvival: {
				reproduction: {
					title: "Taxas de Reprodução",
					description: "Desempenho reprodutivo esperado",
				},
				mortality: {
					title: "Mortalidade e Descarte",
					description: "Perdas esperadas e taxas de descarte",
				},
				weaning: {
					title: "Parâmetros de Desmama",
					description: "Idade e peso na desmama",
				},
				pregnancyRate: "Taxa de Prenhez",
				abortionStillbirth: "Taxa de Aborto/Natimorto",
				preWeaningMortality: "Mortalidade Pré-Desmama",
				cowCullRate: "Taxa de Descarte de Vacas",
				cowMortality: "Mortalidade de Vacas",
				bullMortality: "Mortalidade de Touros",
				heiferMortality: "Mortalidade de Novilhas",
				heiferConceptionRate: "Taxa de Concepção de Novilhas",
				heiferSurvival: "Sobrevivência das novilhas até o primeiro parto",
				sexRatioMale: "Machos ao nascer (%)",
				weaningAge: "Idade de Desmama",
				weaningWeight: "Peso de Desmama",
			},
			nutritionIntake: {
				animalWeights: {
					title: "Pesos dos Animais",
					description: "Pesos adultos para diferentes classes de animais",
				},
				intakeRates: {
					title: "Taxas de Consumo",
					description:
						"Consumo diário de matéria seca como porcentagem do peso corporal",
				},
				supplementation: {
					title: "Suplementação",
					description: "Custos de suplementação mineral e feno",
					mineralCostPerCowYear: "Custo Mineral por Vaca/Ano",
					mineralCostPerBullYear: "Custo Mineral por Touro/Ano",
					mineralCostPerHeiferYear: "Custo Mineral por Novilha/Ano",
					hayDryMatterPercent: "Matéria Seca do Feno",
					hayFeedingWastePercent: "Perda no fornecimento de feno",
					hayCostPerKgAsFed: "Custo do feno por kg fornecido",
				},
				cowMatureWeight: "Peso de Vaca Adulta",
				bullWeight: "Peso do Touro",
				heifer12to24Weight: "Peso de Novilha (12-24m)",
				heifer0to12Weight: "Peso de Novilha (0-12m)",
				lactatingCowIntake: "Consumo de Vaca Lactante",
				dryCowIntake: "Consumo de Vaca Seca",
				bullIntake: "Consumo do Touro",
				heifer12to24Intake: "Consumo de Novilha (12-24m)",
				heifer0to12Intake: "Consumo de Novilha (0-12m)",
			},
			commercialFinancial: {
				capitalFinancing: {
					title: "Investimento e Financiamento",
					description: "Infraestrutura, equipamentos e termos de financiamento",
					infrastructureCapex: "Investimento em Infraestrutura",
					equipmentCapex: "Investimento em Equipamentos",
					animalPurchaseCosts: "Custos de Compra de Animais",
					debtPercent: "Financiamento por Dívida",
					interestRatePercent: "Taxa de Juros",
					tenorYears: "Prazo do Empréstimo",
				},
				workingCapital: {
					title: "Capital de Giro",
					description: "Caixa inicial e liquidez",
					startingCash: "Caixa Inicial",
				},
				calfSales: {
					title: "Venda de Bezerros",
					description: "Preços e custos de venda de bezerros",
					saleMonth: "Mês de Venda",
					pricePerKg: "Preço por kg de peso vivo",
					shrinkPercent: "Quebra",
					commissionPercent: "Comissão",
					freightPerHead: "Frete por Cabeça",
				},
				cullSales: {
					title: "Venda de Vacas de Descarte",
					description: "Preços e custos de venda de vacas de descarte",
					saleMonth: "Mês de Venda",
					pricePerKg: "Preço por kg",
					saleWeightKg: "Peso de Venda",
					shrinkPercent: "Quebra",
					commissionPercent: "Comissão",
					freightPerHead: "Frete por Cabeça",
				},
				operatingCosts: {
					title: "Custos Operacionais",
					description: "Despesas operacionais anuais",
					vetPerCow: "Sanidade por matriz",
					vetFixedCostYear: "Custo veterinário fixo por ano",
					bullUpkeepPerBullYear: "Manutenção por Touro/Ano",
					pastureMaintPerHaYear: "Manutenção de Pastagem/Ha/Ano",
					laborMonthly: "Custo Mensal de Mão de Obra",
					fuelRepairsYear: "Combustível e Reparos/Ano",
					adminInsuranceTaxesYear: "Administração, seguros e impostos por ano",
				},
			},
		},
		results: {
			title: "Resultados da Análise",
			summary: "Resumo",
			verdict: "Veredito",
			viewDetails: "Ver Detalhes",
			editInputs: "Editar Dados",
			recalculate: "Recalcular",
			downloadPdf: "Baixar PDF",
			keyMetrics: "Métricas Principais",
			npv: "Valor Presente Líquido",
			irr: "Taxa Interna de Retorno",
			payback: "Prazo de retorno do investimento",
			dscr: "Índice de Cobertura do Serviço da Dívida",
			years: "anos",
			herdProjection: "Projeção do Lote",
			feedBalance: "Balanço Forrageiro",
			financials: "Projeções Financeiras",
			cashFlow: "Fluxo de Caixa",
			profitLoss: "Lucros e Perdas",
			sensitivity: "Análise de Sensibilidade",
			scenarios: "Cenários",
			constraints: "Restrições Principais",
			conditions: "Condições para Prosseguir",
			noConditions: "Sem condições - projeto viável como projetado",
			// Constraint types
			constraintType: {
				CAPITAL: "Capital",
				RETURNS: "Retornos",
				LIQUIDITY: "Liquidez",
				FORAGE: "Forragem",
				REPRODUCTION: "Reprodução",
			},
			// Condition messages
			conditionMessage: {
				reduceInvestment:
					"Reduzir investimento inicial ou obter financiamento de menor custo",
				improveReturns:
					"Melhorar retornos para atingir mínimo de {{irr}}% de TIR",
				reduceDept:
					"Reduzir dívida ou melhorar fluxo de caixa para atender requisitos de ICSD",
				reducePayback:
					"Reduzir o prazo de retorno do investimento para menos de {{years}} anos",
				reduceStockingRate:
					"Reduzir taxa de lotação ou garantir fontes suplementares de alimentação",
				secureWorkingCapital:
					"Garantir linha de crédito para capital de giro ou aumentar caixa inicial",
				improveReproduction:
					"Melhorar desempenho reprodutivo para atingir mínimo de 75% de taxa de desmame",
			},
			// Verdict summaries
			verdictSummary: {
				go: "O projeto é financeiramente viável, com VPL de {{npv}}, TIR de {{irr}}% e retorno do investimento em {{payback}} anos. Os principais indicadores estão dentro dos limites esperados.",
				conditionalGo:
					"O projeto mostra potencial mas tem restrições em: {{constraints}}. VPL: {{npv}}, TIR: {{irr}}%, ICSD: {{dscr}}. Atenda as condições listadas antes de prosseguir.",
				noGo: "O projeto não é viável em sua forma atual. Restrições principais: {{constraints}}. VPL: {{npv}}, TIR: {{irr}}%. Reestruturação significativa é necessária.",
			},
			riskFactors: "Fatores de Risco",
			riskCategory: {
				DROUGHT: "Seca",
				DISEASE: "Surto de Doenças",
				PRICE: "Volatilidade do Preço do Bezerro",
				FERTILITY: "Desempenho Reprodutivo",
				INPUT_COST: "Inflação de Custos de Insumos",
			},
			probability: {
				LOW: "Baixa",
				MEDIUM: "Média",
				HIGH: "Alta",
			},
			impact: {
				LOW: "Baixo",
				MEDIUM: "Médio",
				HIGH: "Alto",
				CRITICAL: "Crítico",
			},
			mitigation: {
				DROUGHT:
					"Manter reservas de feno, estabelecer gatilhos de descarte, seguro contra seca",
				DISEASE:
					"Programa de vacinação, protocolos de biossegurança, quarentena para novos animais",
				PRICE:
					"Contratos futuros, proteção contra variações de preço e vendas em épocas diferentes",
				FERTILITY:
					"Melhorar nutrição, testes de fertilidade de touros, suporte veterinário",
				INPUT_COST:
					"Fixar preços de ração, otimizar utilização de pastagem, reduzir desperdício",
			},
			unitEconomics: "Economia Unitária",
			costPerCow: "Custo por Fêmea Exposta",
			costPerCalf: "Custo por Bezerro Desmamado",
			marginPerCalf: "Margem Líquida por Bezerro",
			marginPerHa: "Margem Líquida por Hectare",
			breakEven: "Análise de Ponto de Equilíbrio",
			breakEvenCalfPrice: "Preço de Equilíbrio do Bezerro",
			breakEvenWeaningRate: "Taxa de Desmame de Equilíbrio",
			year: "Ano",
			breedingCows: "Vacas de Cria",
			bulls: "Touros",
			calvesWeaned: "Bezerros Desmamados",
			weaningRate: "Taxa de Desmame",
			supply: "Oferta",
			demand: "Demanda",
			balance: "Balanço",
			deficit: "Déficit",
			surplus: "Superávit",
			revenue: "Receita",
			costs: "Custos",
			netProfit: "Lucro Líquido",
			grossMargin: "Margem Bruta",
			deficitMonths: "Meses em Déficit",
			totalHayCost: "Custo Total de Feno",
			criticalPeriods: "Períodos Críticos",
			inflows: "Entradas",
			outflows: "Saídas",
			endingCash: "Saldo Final",
		},
		tooltips: {
			npv: "Valor Presente Líquido (VPL) representa o valor total dos fluxos de caixa futuros em valores de hoje.\n\nFórmula: Soma de (Fluxo de Caixa / (1 + Taxa de Desconto)^Ano)\n\nVPL positivo indica que o projeto gera valor.",
			irr: "Taxa Interna de Retorno (TIR) é a taxa de desconto que iguala o VPL a zero.\n\nRepresenta o retorno anual esperado do investimento.\n\nTIR maior = investimento mais atrativo.",
			payback:
				"O prazo de retorno indica quanto tempo leva para recuperar o investimento inicial.\n\nÉ o momento em que o fluxo de caixa acumulado passa a ser positivo.\n\nQuanto menor o prazo, menor tende a ser o risco.",
			dscr: "Índice de Cobertura do Serviço da Dívida mede a capacidade de pagar obrigações de dívida.\n\nFórmula: Resultado Operacional / Serviço Total da Dívida\n\nICSD > 1,2 é tipicamente exigido por credores.",
			herdProjection:
				"Projeção do lote mostra a evolução do inventário de gado ao longo do tempo.\n\nLinhas mostram: Vacas em reprodução, Touros e Bezerros desmamados por ano.\n\nBaseado em taxas de prenhez, desmame, descarte e retenção de novilhas.",
			weaningRate:
				"Taxa de desmame é a porcentagem de bezerros desmamados com sucesso das vacas.\n\nFórmula: (Bezerros Desmamados / Vacas em Reprodução) × 100\n\nAfetada por taxa de prenhez, mortalidade de bezerros e perdas de vacas.",
			deficitMonths:
				"Número de meses onde a demanda de forragem excede a oferta de pastagem.\n\nEstes meses requerem alimentação suplementar com feno.\n\nBaseado na produção mensal de pastagem vs. consumo do lote.",
			totalHayCost:
				"Custo total de compras de feno suplementar para o ano.\n\nFórmula: Soma de (Déficit Mensal kg × Preço do Feno/kg)\n\nDéficit = máx(0, Demanda - Oferta) para cada mês.",
			criticalPeriods:
				"Meses identificados como tendo déficit de alimentação.\n\nDurante períodos críticos, a pastagem não atende à demanda do lote.\n\nPlaneje reservas de feno ou reduza a lotação para estes períodos.",
			feedBalance:
				"Balanço alimentar compara a oferta mensal de forragem com a demanda do lote.\n\nOferta: Produção de pastagem em kg MS (matéria seca)\nDemanda: Consumo do lote baseado em peso dos animais e taxas de ingestão\n\nVerde = excedente, Vermelho = déficit requerendo feno.",
			unitEconomics:
				"Economia unitária mostra a rentabilidade por animal.\n\nCusto por Vaca: Custos totais / Vacas em reprodução\nCusto por Bezerro: Custos totais / Bezerros desmamados\nMargem por Bezerro: (Receita - Custos) / Bezerros desmamados\nMargem por Ha: Lucro líquido / Hectares totais",
			breakEven:
				"Análise de ponto de equilíbrio mostra os valores limites onde lucro = 0.\n\nPreço do Bezerro: Preço mínimo de venda para cobrir custos\nTaxa de Desmame: Taxa mínima necessária para equilibrar\nPreço do Feno: Custo máximo do feno antes de ter prejuízo",
			profitLoss:
				"Gráfico de Lucros e Perdas mostra o desempenho financeiro anual.\n\nReceita: Vendas de bezerros + Vendas de vacas de descarte\nCustos: Custos operacionais variáveis + fixos\nLucro Líquido: Receita - Todos os Custos (incluindo juros e depreciação)",
			cashFlow:
				"Gráfico de fluxo de caixa mostra a movimentação de dinheiro na operação.\n\nEntradas: Receita de vendas + Empréstimos recebidos\nSaídas: Custos operacionais + Pagamentos de empréstimos + CAPEX\nSaldo Final: Posição acumulada de caixa",
		},
		calculations: {
			showCalculations: "Cálculos",
			title: "Detalhes dos Cálculos",
			herdDynamics: "Lote",
			feedBalance: "Forragem",
			financials: "Financeiro",
			unitEconomics: "Unitário",
			investmentMetrics: "Investimento",
			cashFlow: "Fluxo Caixa",
			// Estrutura do Lote
			herdStructure: "Estrutura do Lote",
			breedingCows: "Vacas de Cria",
			bulls: "Touros",
			heifers12to24: "Novilhas de Reposição (12-24 meses)",
			heifers0to12: "Novilhas de Reposição (0-12 meses)",
			// Bezerros Desmamados
			weanedCalves: "Cálculo de Bezerros Desmamados",
			pregnancyRate: "Taxa de Prenhez",
			weaningRate: "Taxa de Desmame",
			calvesWeanedResult: "Bezerros Desmamados",
			replacements: "Necessidades de Reposição",
			cowsCulled: "Vacas Descartadas",
			cowDeaths: "Mortes de Vacas",
			heifersRetained: "Novilhas Retidas",
			salesOutput: "Saída de Vendas",
			calvesSold: "Bezerros Vendidos",
			// Balanço Forrageiro
			feedBalanceFormula: "Fórmula do Balanço Forrageiro",
			feedBalanceDescription:
				"A oferta mensal de forragem é comparada à demanda do lote. Déficits requerem feno suplementar.",
			monthlyDeficits: "Déficits Mensais (Ano 1)",
			noDeficits: "Sem déficit forrageiro em nenhum mês.",
			hayRequirement: "Necessidade de Feno",
			totalHayTonnes: "Total de Feno Necessário",
			totalHayCost: "Custo Anual Total de Feno",
			// Receita
			revenueCalc: "Cálculos de Receita",
			calfRevenue: "Receita Líquida de Bezerros",
			cullRevenue: "Receita Líquida de Descarte",
			grossRevenue: "Receita Bruta",
			// Custos Operacionais
			operatingCosts: "Custos Operacionais",
			hayCosts: "Custos de Feno",
			mineralCosts: "Custos de Mineral",
			vetCosts: "Veterinário e Medicamentos",
			laborCosts: "Custos de Mão de Obra",
			pastureMaint: "Manutenção de Pastagem",
			totalVariableCosts: "Total de Custos Variáveis",
			totalFixedCosts: "Total de Custos Fixos",
			// Rentabilidade
			profitability: "Rentabilidade",
			grossMargin: "Margem Bruta",
			ebitda: "EBITDA",
			ebitdaPerCow: "EBITDA por Vaca",
			ebitdaPerCalf: "EBITDA por Bezerro Vendido",
			interestExpense: "Despesa de Juros",
			depreciation: "Depreciação",
			netProfit: "Lucro Líquido",
			// Economia Unitária
			costMetrics: "Métricas de Custo",
			costPerCow: "Custo por Fêmea Exposta",
			costPerCalf: "Custo por Bezerro Desmamado",
			marginMetrics: "Métricas de Margem",
			marginPerCalf: "Margem Líquida por Bezerro",
			marginPerHa: "Margem Líquida por Hectare",
			breakEvenAnalysis: "Análise de Ponto de Equilíbrio",
			breakEvenDescription:
				"Valores de equilíbrio mostram o limite em que a operação gera lucro zero.",
			breakEvenCalfPrice: "Preço de Equilíbrio do Bezerro",
			breakEvenCalfPriceFormula:
				"Custos Totais / (Bezerros Vendidos × Peso ao Desmame)",
			breakEvenWeaningRate: "Taxa de Desmame de Equilíbrio",
			breakEvenWeaningRateFormula:
				"Custos Totais / (Receita de Bezerros / Taxa de Desmame Atual)",
			breakEvenHayPrice: "Preço de Equilíbrio do Feno",
			breakEvenHayPriceFormula:
				"Preço máximo estimado do feno antes da operação se tornar não lucrativa",
			// Métricas de Investimento
			investmentReturns: "Retornos de Investimento",
			npv: "Valor Presente Líquido (VPL)",
			irr: "Taxa Interna de Retorno (TIR)",
			paybackPeriod: "Prazo de retorno do investimento",
			years: "anos",
			roic: "Retorno sobre Capital Investido (ROIC)",
			debtCoverage: "Cobertura de Dívida",
			dscr: "Índice de Cobertura do Serviço da Dívida (DSCR)",
			dscrDescription:
				"DSCR > 1.0 significa que o fluxo de caixa cobre os pagamentos da dívida. Quanto maior, melhor.",
			// Fluxo de Caixa
			cashFlowSummary: "Resumo do Fluxo de Caixa (Ano 1)",
			totalCashInflows: "Total de Entradas de Caixa",
			totalCashOutflows: "Total de Saídas de Caixa",
			netCashFlow: "Fluxo de Caixa Líquido",
			liquidity: "Liquidez",
			peakNegativeCash: "Pico de Caixa Negativo (Necessidade de CG)",
			endingCashBalance: "Saldo Final de Caixa",
			// Serviço da Dívida
			debtService: "Serviço da Dívida (Ano 1)",
			openingDebt: "Saldo Inicial da Dívida",
			principalPayment: "Pagamento de Principal",
			interestPayment: "Pagamento de Juros",
			totalDebtService: "Serviço Total da Dívida",
			closingDebt: "Saldo Final da Dívida",
		},
	},
	livestock: {
		waterIntake: {
			herdTotal: "Consumo médio diário de água do lote",
			animal: "Consumo médio estimado de água",
			unit: "L/dia",
		},
		dryMatterIntake: {
			herdTotal: "Consumo diário de MS do lote",
			herdWeightWarning:
				"O cálculo considera apenas os {{weighed}} de {{total}} animais com pesagem registrada. Os animais sem peso não foram incluídos.",
			animal: "Consumo diário estimado de MS",
			unit: "kg MS/dia",
		},
		nav: {
			title: "Rebanho",
		},
		attention: {
			title: "Precisa de atenção",
			columnHeader: "Atenção",
			forEntity: { title: "Pontos de atenção" },
			forEntityCount_one: "{{count}} ponto de atenção",
			forEntityCount_other: "{{count}} pontos de atenção",
			allClear: "Tudo em dia",
			allClearHint:
				"Pesagens, vacinações e rotações atrasadas, piquetes acima da capacidade e partos previstos aparecerão aqui conforme você registra.",
			// Sem nenhum registro nada foi avaliado — a frase não promete o que
			// dispara um alerta (§2.7).
			nothingYet:
				"Sem pendências até agora. Quando algo precisar de atenção, aparece aqui.",
			needAttention_one: "{{count}} precisa de atenção",
			needAttention_other: "{{count}} precisam de atenção",
			viewDetails_one: "Ver {{count}} ponto de atenção",
			viewDetails_other: "Ver {{count}} pontos de atenção",
			badgeLabel_one: "{{count}} item de atenção: {{breakdown}}",
			badgeLabel_other: "{{count}} itens de atenção: {{breakdown}}",
			categories: {
				VACCINATION_DUE: "Vacinação pendente",
				WEIGHING_OVERDUE: "Pesagem atrasada",
				PADDOCK_OVERSTAY: "Troca de piquete atrasada",
				OVER_CAPACITY: "Acima da capacidade",
				CALVING_WINDOW: "Parto previsto",
			},
			affectedAnimals_one: "{{overdue}} de {{count}} animal",
			affectedAnimals_other: "{{overdue}} de {{count}} animais",
			wholeHerd: "Rebanho inteiro",
			overdueBy_one: "{{count}} dia de atraso",
			overdueBy_other: "{{count}} dias de atraso",
			overdueYears_one: "{{count}}+ ano de atraso",
			overdueYears_other: "{{count}}+ anos de atraso",
			yearsShort_one: "{{count}}+ ano",
			yearsShort_other: "{{count}}+ anos",
			daysCount_one: "{{count}} dia",
			daysCount_other: "{{count}} dias",
			neverVaccinated: "Nunca vacinado",
			overBy_one: "{{count}} a mais",
			overBy_other: "{{count}} a mais",
			inDays_one: "em {{count}} dia",
			inDays_other: "em {{count}} dias",
			today: "hoje",
			loadError: "Não foi possível carregar os alertas",
			moreCount: "+{{count}} mais",
			asOf: "atualizado {{when}}",
			retry: "Tentar novamente",
			vaccinationDescription: 'A vacina "{{rule}}" está fora do prazo.',
			vaccinationLastDose: 'Última dose de "{{rule}}" em {{date}}.',
			vaccinationNeverDosed: 'Nenhuma dose de "{{rule}}" registrada.',
			neverVaccinatedCount_one: "{{count}} nunca vacinado",
			neverVaccinatedCount_other: "{{count}} nunca vacinados",
			weighingDescription: "Sem pesagem há mais de {{days}} dias.",
			weighingLastDate: "Última pesagem em {{date}}.",
			neverWeighed: "Nenhuma pesagem registrada.",
			neverWeighedCount_one: "{{count}} nunca pesado",
			neverWeighedCount_other: "{{count}} nunca pesados",
			overstayDescription:
				'Está há {{duration}} no piquete "{{paddock}}" (planejado: {{target}} dias).',
			overstayShort: "{{duration}} neste piquete (planejado: {{target}} dias)",
			capacityDescription:
				"O lote está com {{head}} cabeças; a capacidade informada é de {{max}}.",
			calvingDescription:
				"Previsto para {{date}}, com base no diagnóstico de {{diagDate}}.",
			actions: {
				recordVaccination: "Registrar vacinação",
				recordVaccinationBulk: "Registrar vacina pendente",
				recordWeight: "Pesar",
				rotate: "Mudar de piquete",
				viewHerd: "Ver lote",
				viewAnimal: "Ver animal",
			},
		},
		// Painel de vacinação do animal. Diferente de `attention`: aqui entram
		// também os estados que NÃO são cobrança — bezerro novo demais, dose já
		// aplicada, regra que não se aplica. Nada daqui vira alerta ou e-mail.
		vaccinationStatus: {
			title: "Vacinação",
			empty: {
				title: "Nenhuma regra de vacinação configurada",
				description:
					"Sem regras no calendário sanitário, não há nada para avaliar neste animal.",
				action: "Configurar calendário sanitário",
			},
			statuses: {
				DUE: {
					label: "Atrasada",
					detail_one: "Vencida desde {{date}} — {{count}} dia.",
					detail_other: "Vencida desde {{date}} — {{count}} dias.",
				},
				WINDOW_MISSED: {
					label: "Janela encerrada",
					detail:
						"A janela para esta dose fechou em {{date}} e nenhuma aplicação foi registrada.",
				},
				UNKNOWN_AGE: {
					label: "Idade desconhecida",
					detail:
						"Sem data de nascimento não dá para avaliar a idade deste animal nesta regra.",
				},
				// O caso do bezerro recém-nascido: tranquiliza, não cobra.
				TOO_YOUNG: {
					label: "Ainda não",
					detail:
						"Ainda não é hora — primeira dose prevista por volta de {{date}}.",
				},
				UPCOMING: {
					label: "Programada",
					detail: "Próxima dose prevista por volta de {{date}}.",
				},
				DONE: {
					label: "Em dia",
					detail: "Dose registrada em {{date}}.",
				},
				NOT_APPLICABLE: {
					label: "Não se aplica",
					detail: "Esta regra não vale para este animal.",
				},
			},
		},
		// Cartão de sanidade da página do animal (enriquecimento 2026-09-04, fase 9).
		care: {
			title: "Sanidade",
			subtitle: "Carência, vermifugação, doenças e tratamentos deste animal",
			withdrawal: {
				banner:
					"Em carência até {{date}} ({{medication}}) — não pode ser vendido nem abatido",
				bannerNoMedication:
					"Em carência até {{date}} — não pode ser vendido nem abatido",
			},
			lastDeworming: "Última vermifugação",
			lastEctoparasiteControl: "Último controle de ectoparasitas",
			neverRecorded: "Nunca registrado",
			openDiseases: {
				title: "Doenças em aberto",
				noDiagnosis: "Sem diagnóstico",
				quarantined: "Em quarentena",
			},
			treatments: {
				title: "Tratamentos recentes",
				noMedication: "Medicação não informada",
				durationDays_one: "{{count}} dia",
				durationDays_other: "{{count}} dias",
				withdrawalUntil: "Carência até {{date}}",
				performedBy: "por {{name}}",
			},
			upcoming: {
				title: "Próximos",
				kinds: {
					weighing: "Pesagem",
					vaccination: "Vacinação",
					pregnancy_check: "Diagnóstico de gestação",
				},
			},
			nutrition: {
				title: "Nutrição",
			},
		},
		reproduction: {
			notRecorded: "Não disponível",
			statuses: {
				PREGNANT: "Prenhe",
				EMPTY: "Vazia",
				DOUBTFUL: "Inconclusivo",
				UNKNOWN: "Desconhecido",
			},
			values: {
				days_one: "{{count}} dia",
				days_other: "{{count}} dias",
				months_one: "{{count}} mês",
				months_other: "{{count}} meses",
				kg: "{{value}} kg",
				measurementWithDate: "{{value}} {{unit}} · {{date}}",
			},
			cow: {
				title: "Reprodução",
				subtitle: "Situação do ciclo e produtividade reprodutiva acumulada",
				cycleStatus: "Situação do ciclo",
				calvings: "Partos",
				averageCalvingInterval: "Intervalo médio entre partos",
				ageAtFirstCalving: "Idade ao primeiro parto",
				daysOpen: "Dias em aberto",
				lastDiagnosis: "Último diagnóstico de gestação",
				weanedKgPerCalving: "Kg desmamados por parto",
				currentPregnancySire: "Pai da gestação atual",
			},
			bull: {
				title: "Desempenho reprodutivo",
				subtitle: "Aptidão, cobertura e desempenho da progênie",
				scrotalCircumference: "Circunferência escrotal",
				lastExam: "Último exame andrológico",
				cowsExposed: "Vacas expostas · últimos 12 meses",
				progenyCount: "Progênie",
				progenyAverageGmd90: "GMD médio da progênie · 90 dias",
				viewOffspring: "Ver progênie",
			},
		},
		settings: {
			title: "Rebanho",
			tabLabel: "Rebanho",
			updateSuccess: "Configurações salvas",
			thresholds: {
				title: "Alertas e parâmetros",
				weighingOverdueDays: {
					label: "Pesagem atrasada (dias)",
					help: "Lotes de engorda sem pesagem há mais de N dias aparecem como pendentes.",
				},
				paddockOverstayDefaultDays: {
					label: "Permanência padrão no piquete (dias)",
					help: "Usada quando a troca de piquete não tem duração planejada. Deixe em branco para não gerar alerta.",
					placeholder: "Sem padrão",
				},
				calvingWindowDays: {
					label: "Janela de parto (dias)",
					help: "Antecedência para alertar partos previstos.",
				},
				waterIntakePercent: {
					label: "Consumo médio de água (% do peso)",
					help: "Percentual do último peso vivo usado para estimar o consumo diário em litros. Padrão: 10%.",
					invalid: "Informe um percentual maior que 0 e até 100",
				},
				dryMatterIntakePercent: {
					label: "Consumo diário de matéria seca (MS) (% do peso)",
					help: "Percentual do último peso vivo usado para estimar o consumo em kg de MS/dia. Padrão: 2,5%. Deixe em branco para usar o padrão.",
					placeholder: "2,5% (padrão)",
					invalid: "Informe um percentual maior que 0 e até 100",
				},
				carcassYieldPercent: {
					label: "Rendimento de carcaça (%)",
					help: "Usado no cálculo de @ produzida e nas projeções de margem.",
				},
			},
			rules: {
				title: "Calendário sanitário (vacinações)",
				add: "Nova regra",
				addTitle: "Nova regra de vacinação",
				editTitle: "Editar regra de vacinação",
				empty: "Nenhuma regra configurada.",
				createSuccess: "Regra criada",
				updateSuccess: "Regra atualizada",
				deleteSuccess: "Regra excluída",
				summaryRecurring: "A cada {{days}} dias",
				summaryAgeWindow: "Dose única entre {{min}} e {{max}} dias de idade",
				matchLabel: 'critério: "{{match}}"',
				kinds: {
					RECURRING: "Recorrente",
					SINGLE_DOSE_AGE_WINDOW: "Dose única por idade",
				},
				sex: {
					ANY: "Ambos os sexos",
					FEMALE: "Fêmeas",
					MALE: "Machos",
				},
				fields: {
					name: "Nome",
					namePlaceholder: "Febre Aftosa",
					vaccineMatch: "Critério de busca",
					vaccineMatchPlaceholder: "aftosa",
					vaccineMatchHelp:
						"Trecho comparado com a descrição/medicamento dos registros de vacinação.",
					ruleKind: "Tipo",
					appliesToSex: "Sexo",
					intervalDays: "Intervalo (dias)",
					minAgeDays: "Idade mínima (dias)",
					maxAgeDays: "Idade máxima (dias)",
				},
				validation: {
					maxAgeAfterMin: "A idade máxima deve ser maior que a mínima",
				},
				deleteConfirm: {
					title: 'Excluir regra "{{name}}"?',
					body: "A regra deixa de gerar alertas imediatamente.",
				},
			},
		},
		margin: {
			title: "Margem",
			subtitle: "Resultado da venda, calculado a partir dos dados de rebanho",
			presaleSubtitle: "Custo acumulado e projeção de margem antes da venda",
			notSold: "Este animal ainda não foi vendido.",
			revenue: "Receita",
			acquisitionCost: "Custo de aquisição",
			animalOperationCost: "Custos de operações do animal",
			herdOperationCostShare: "Parcela dos custos do lote",
			deductions: "Deduções da venda",
			netMargin: "Margem líquida",
			soldOn: "Vendido em {{date}}",
			accumulatedCost: "Custo acumulado",
			referencePriceLabel: "Preço de referência (R$/@)",
			referencePriceInUse: "Preço de referência: {{price}}/@",
			simulateAnotherPriceLabel: "Simular outro preço (R$/@)",
			staleQuote: "desatualizada",
			referencePricePlaceholder: "Ex: 320,00",
			simulate: "Simular",
			useOrgPrice: "Voltar à cotação da organização",
			noProjection:
				"Informe um preço de referência e registre uma pesagem para calcular a margem projetada.",
			noProjectionNeedsWeighing:
				"Registre uma pesagem para projetar a margem a {{price}}/@.",
			projectionTitle: "Margem projetada",
			simulationBadge: "simulação",
			projectionBasis:
				"Base: {{weight}} kg (~{{arrobas}} @) a {{price}}/@ · pesado em {{date}}",
			projectedRevenue: "Receita projetada",
			projectedMargin: "Margem projetada",
			// Economia por unidade (enriquecimento do animal, fase 8): valores do servidor.
			costPerKgGained: "Custo por kg ganho",
			costPerDay: "Custo por dia",
			breakEven: "Preço de equilíbrio (@)",
			perDay: "{{value}}/dia",
			nutrition: {
				feedingPlan: "Plano alimentar: {{name}} desde {{date}} ({{source}})",
				supplementation: "Suplementação: {{name}} desde {{date}} ({{source}})",
				unnamed: "sem nome",
				source: {
					animal: "animal",
					herd: "lote",
				},
			},
			// Antes de existir qualquer insumo (§2.6): diz o que falta, não um zero.
			prerequisites: {
				title: "Para projetar a margem, o RuralOps precisa de:",
				weighing: "uma pesagem",
				simulateHint:
					"Já definido, nas configurações financeiras. Simule outro preço se quiser.",
				recordWeighing: "Registrar pesagem",
				referencePrice: "um preço de referência da arroba",
				showBreakdown: "Ver detalhamento",
				hideBreakdown: "Ocultar detalhamento",
			},
			// Fatos de honestidade — o backend decide QUAIS aparecem (por código);
			// a redação é daqui. Ver KeyDecisions/2026-09-03-margin-honesty-labels-as-codes.
			honesty: {
				PASTURE_COSTS_EXCLUDED: "custos de pasto não incluídos",
				LOT_COSTS_PER_HEAD: "custos de lote rateados por cabeça",
				CARCASS_YIELD:
					"@ produzida estimada com rendimento de carcaça de {{percent}}%",
				WEIGHED_COVERAGE:
					"ganho de peso calculado sobre {{withData}}/{{total}} animais com pesagens",
			},
		},
		growth: {
			tab: "Crescimento",
			title: "Crescimento",
			subtitle_one: "{{count}} pesagem registrada",
			subtitle_other: "{{count}} pesagens registradas",
			empty: {
				title: "Nenhuma pesagem ainda",
				body: "Gráfico, GMD, arrobas e previsão de peso-alvo aparecem a partir da primeira pesagem.",
				recordWeighing: "Registrar pesagem",
			},
			latestWeight: "Último peso",
			arrobas: "Arrobas (rendimento {{percent}}%)",
			estimatedCarcass: "Carcaça estimada",
			chartTitle: "Evolução de peso",
			weightSeries: "Peso",
			targetLine: "Alvo {{value}} kg",
			windows: {
				window: "Período",
				gmd: "GMD",
				weights: "Pesos",
				period: "Datas",
				lastTwoWeighings: "Últimas duas pesagens",
				rolling30: "Últimos 30 dias",
				rolling90: "Últimos 90 dias",
				lifetime: "Desde a primeira pesagem",
				needTwo: "O ganho diário aparece a partir da segunda pesagem.",
			},
			target: {
				title: "Peso-alvo do lote: {{value}} kg",
				reaches_one: "Atinge o alvo em {{count}} dia, a {{basis}} kg/dia, em",
				reaches_other:
					"Atinge o alvo em {{count}} dias, a {{basis}} kg/dia, em",
				noProjection:
					"Sem previsão: o animal já está no alvo ou não há ganho de peso recente para projetar.",
				noTarget:
					"Defina um peso-alvo no lote para ver a previsão de quando este animal o atinge.",
			},
			lotRank: {
				title: "Posição no lote",
				byWeight: "Por peso",
				byGmd: "Por GMD",
				position: "Posição {{rank}} de {{size}}",
				percentile: "percentil {{value}}",
				cullTitle: "Candidato a descarte",
				cullBody:
					"Está entre os 10% mais leves do lote. Avalie sanidade, nutrição ou venda antecipada.",
			},
			weaning: {
				title: "Desmame",
				date: "Data",
				weight: "Peso ao desmame",
				age: "Idade ao desmame",
				ageValue_one: "{{count}} dia",
				ageValue_other: "{{count}} dias",
				adjusted205: "Peso ajustado 205 dias",
			},
		},
		lotResult: {
			title: "Resultado do lote",
			subtitle_one:
				"{{count}} cabeça neste ciclo, líquida de mortalidade (ciclo fechado)",
			subtitle_other:
				"{{count}} cabeças neste ciclo, líquidas de mortalidade (ciclo fechado)",
			empty: "Nenhum animal passou por este lote ainda.",
			totalHead: "Total de cabeças",
			soldHead: "Vendidos",
			deadHead: "Mortos",
			activeHead: "Ativos",
			proceeds: "Receita das vendas",
			acquisitionCost: "Custo de aquisição",
			operationCost: "Custos de operações",
			deductions: "Deduções das vendas",
			netResult: "Resultado líquido",
			kpis: {
				title: "Indicadores estratégicos",
				kgGained: "Ganho de peso",
				arrobasProduced: "@ produzidas",
				revenuePerArroba: "Receita por @ produzida",
				costPerKgGained: "Custo por kg ganho",
				breakEven: "Preço de equilíbrio (@)",
				marginPercent: "Margem",
			},
		},
		kpi: {
			gmdShort: "GMD",
			gmd90: "GMD (90d)",
			gmdValue: "{{value}} kg/dia",
			gmdUnit: "kg/dia",
			coverage: "{{weighed}}/{{total}} pesados",
			onPaddockDays_one: "{{count}} dia no pasto",
			onPaddockDays_other: "{{count}} dias no pasto",
			kgValue: "{{value}} kg",
			arrobaValue: "{{value}} @",
			perArroba: "{{value}}/@",
			perKg: "{{value}}/kg",
			percentValue: "{{value}}%",
		},
		sales: {
			sellCta: "Vender",
			sellAnimalsCta: "Vender animais",
			step1Title: "Selecionar animais",
			step1Description: "Escolha os animais que farão parte desta venda.",
			step2Title: "Detalhes da venda",
			step2Description:
				"Comprador, tipo de acerto (ao gancho, peso vivo, cabeça ou lote) e valor.",
			step3Title: "Confirmação",
			step3Description: "Revise antes de registrar a venda.",
			completion: {
				title: "Venda registrada",
				description:
					"Marque a venda como a prazo se for a crédito, ou conclua.",
				done: "Concluir",
			},
			emptyHerd: "Nenhum animal ativo neste lote.",
			totalWeightEstimateHint:
				"Estimado pela última pesagem — ajuste se necessário.",
			sections: {
				buyer: "Comprador",
				conditions: "Condições da venda",
				pricing: "Peso e preço",
			},
			buyerLabel: "Comprador",
			saleDateLabel: "Data da venda",
			channelLabel: "Canal",
			pricingModelLabel: "Modelo de preço",
			dealKind: {
				label: "Como a venda foi fechada?",
				hint: "No Brasil o acerto vem antes do preço: ao gancho no frigorífico, ao peso vivo entre fazendas, por cabeça ou lote fechado.",
				ON_HOOK: "Ao gancho (carcaça)",
				ON_HOOKHint:
					"Frigorífico. Preço por @ de carcaça, com rendimento ou romaneio.",
				LIVE_WEIGHT: "Ao peso vivo",
				LIVE_WEIGHTHint:
					"Bezerro, recria ou venda entre fazendas. Preço por @ vivo ou por kg.",
				PER_HEAD: "Por cabeça",
				PER_HEADHint: "Mesmo valor para cada animal, sem pesar o lote.",
				LOT_TOTAL: "Lote fechado",
				LOT_TOTALHint: "Um valor único combinado para o lote inteiro.",
			},
			livePriceUnit: {
				ARROBA: "R$ por @ de peso vivo",
				KG: "R$ por kg vivo",
			},
			totalWeightLabel: "Peso total (kg)",
			liveWeightLabel: "Peso vivo total",
			carcassWeightLabel: "Peso de carcaça do romaneio",
			totalWeightPlaceholder: "Ex: 1500",
			liveWeightHint:
				"Soma das últimas pesagens: {{weight}} kg. Ajuste para o peso vivo efetivamente negociado.",
			actualCarcassHint:
				"Informe o peso líquido de carcaça apurado pelo frigorífico no romaneio.",
			estimatedCarcassHint:
				"{{liveWeight}} kg de peso vivo × {{yield}}% = {{carcassWeight}} kg de carcaça estimada.",
			carcassYieldLabel: "Rendimento de carcaça",
			carcassYieldHint:
				"Conversão de peso vivo em carcaça (couro, vísceras, cabeça). Não é desconto comercial — o típico no Brasil é 50–54%.",
			shrinkLabel: "Quebra de peso",
			shrinkHint:
				"Desconto de transporte ou curral sobre o peso vivo. 2% é o mais comum; deixe 0 se não houver.",
			carcassDiscountLabel: "Desconto comercial na carcaça",
			carcassDiscountHint:
				"Percentual extra que alguns frigoríficos tiram depois do rendimento (1–2%). Condenação e classificação entram no romaneio ou como custo depois.",
			weightBasis: {
				label: "Como o peso de carcaça foi obtido?",
				arrobaExplanation:
					"No boi gordo, 1 @ = 15 kg de carcaça. @ de peso vivo é outro acerto, usado entre fazendas.",
				live: "Peso vivo",
				actual: "Carcaça apurada no romaneio",
				actualHint: "Use após o abate, com o peso informado pelo frigorífico.",
				estimated: "Carcaça estimada por rendimento",
				estimatedHint:
					"Use quando o acordo for liquidado por estimativa; o sistema converte o peso vivo.",
			},
			settlement: {
				title: "Acerto da venda",
				liveWeight: "Peso vivo",
				shrink: "Quebra {{percent}}%",
				yield: "Rendimento {{percent}}%",
				romaneio: "Carcaça do romaneio",
				carcassDiscount: "Desconto de carcaça {{percent}}%",
				billedLive: "Peso vivo liquidado",
				billedCarcass: "Carcaça liquidada",
				liveArrobas: "Arrobas de peso vivo",
				carcassArrobas: "Arrobas de carcaça",
				pricePerKg: "Preço por kg",
				pricePerLiveArroba: "Preço por @ vivo",
				pricePerCarcassArroba: "Preço por @ de carcaça",
				note: "Acerto: quebra {{shrink}}%; desconto de carcaça {{discount}}%.",
			},
			notesLabel: "Notas",
			notesPlaceholder: "Observações opcionais",
			perAnimalWeightsLabel: "Pesos por animal (opcional)",
			perAnimalLiveWeightsLabel: "Pesos vivos por animal (opcional)",
			liveTotalLabel: "Total",
			unitLabels: {
				PER_HEAD: "Preço por cabeça (R$)",
				PER_KG: "Preço por kg vivo (R$)",
				PER_ARROBA: "Preço por @ (R$)",
				LOT_TOTAL: "Valor total do lote (R$)",
				LIVE_ARROBA: "Preço por @ de peso vivo (R$)",
				CARCASS_ARROBA: "Preço por @ de carcaça (R$)",
			},
			pricingModels: {
				PER_HEAD: "Por cabeça",
				PER_KG: "Por kg",
				PER_ARROBA: "Por arroba",
				LOT_TOTAL: "Total do lote",
			},
			channels: {
				DIRECT: "Direto",
				AUCTION: "Leilão",
				MARKETPLACE: "Plataforma RuralOps",
				OTHER: "Outro",
			},
			statuses: {
				COMPLETED: "Concluída",
				CANCELED: "Cancelada",
			},
			confirmSubmit: "Confirmar venda",
			validation: {
				selectAnimals: "Selecione ao menos um animal",
				buyerRequired: "Informe o comprador",
				priceRequired: "Informe um preço maior que 0",
				weightRequired: "Informe um peso total maior que 0",
				carcassYieldRequired: "Informe um rendimento de carcaça entre 0 e 100%",
				percentRange: "Informe um percentual entre 0 e 100",
			},
			createSuccess: "Venda registrada com sucesso.",
			toastSuccess_one: "Venda registrada — {{count}} animal.",
			toastSuccess_other: "Venda registrada — {{count}} animais.",
			toastError: "Não foi possível registrar a venda.",
			undoLabel: "Desfazer",
			reverseSuccess: "Venda revertida.",
			reverseError: "Não foi possível reverter a venda.",
			reverseConfirmTitle: "Reverter venda?",
			reverseConfirmDescription:
				"Os animais voltarão ao status ATIVO e os lançamentos serão removidos. Esta ação só pode ser feita em até 24 horas da venda.",
			reverseConfirmAction: "Reverter",
			summary: {
				headerTitle: "Resumo da venda",
				buyer: "Comprador",
				headCount: "Cabeças",
				pricingModel: "Modelo",
				dealKind: "Tipo de acerto",
				unitPrice: "Preço unitário",
				totalWeight: "Peso total",
				liveWeight: "Peso vivo",
				carcassWeight: "Peso de carcaça",
				weightBasis: "Base de peso",
				carcassYield: "Rendimento de carcaça",
				arrobas: "Arrobas de carcaça",
				arrobasLive: "Arrobas de peso vivo",
				saleDate: "Data",
				channel: "Canal",
				totalAmount: "Total",
				moneyDeductionsHint:
					"FUNRURAL, frete e comissão entram no próximo passo — são custos em R$, não desconto de carcaça.",
				willEmptyHerdTitle: "Isto vai esvaziar o lote",
				willEmptyHerdBody:
					"Todos os animais ativos estão sendo vendidos. O lote será marcado como inativo e o piquete em que ele estiver pastando será liberado para outros lotes.",
			},
			// Guarda de carência (enriquecimento 2026-09-04, fase 9).
			withdrawal: {
				title: "Animal em carência",
				body: "Este animal está em carência de {{medication}} até {{date}}. Vender ou abater antes disso descumpre a carência do medicamento.",
				bodyNoMedication:
					"Este animal está em carência até {{date}}. Vender ou abater antes disso descumpre a carência do medicamento.",
				acknowledge: "Estou ciente e quero registrar a venda mesmo assim",
				rejected: "Venda recusada — animal em carência: {{detail}}",
				rejectedItem: "{{tagId}} até {{date}}",
			},
			deductions: {
				title: "Custos de comercialização",
				subtitle:
					"FUNRURAL, frete, comissão e outros custos da venda. A receita bruta é mantida; a margem é calculada líquida.",
				empty: "Nenhuma dedução registrada.",
				amountPlaceholder: "Valor (R$)",
				descriptionPlaceholder: "Descrição (opcional)",
				types: {
					FUNRURAL: "FUNRURAL",
					FREIGHT: "Frete",
					COMMISSION: "Comissão",
					OTHER: "Outros",
				},
			},
		},
		buyers: {
			placeholder: "Selecionar comprador",
			searchPlaceholder: "Buscar por nome ou documento",
			noResults: "Nenhum comprador encontrado.",
			createNew: "+ Criar novo comprador",
			createNamed: '+ Criar "{{name}}"',
			nameLabel: "Nome",
			namePlaceholder: "Ex: João da Silva",
			documentLabel: "Documento (CPF/CNPJ)",
			documentPlaceholder: "Opcional",
			createSubmit: "Criar",
			createSuccess: "Comprador criado.",
		},
		tabs: {
			overview: "Resumo",
			herds: "Lotes",
			animals: "Animais",
			health: "Saúde",
			activity: "Atividade",
			measurements: "Medições",
			operations: "Manejos",
		},
		farm: {
			selectFarm: "Selecionar fazenda",
			noFarms: "Nenhuma fazenda cadastrada",
			noFarmsDescription:
				"Você precisa criar uma fazenda antes de gerenciar o gado.",
		},
		dashboard: {
			title: "Gestão do rebanho",
			herdsOverview: "Situação dos lotes",
			kpi: {
				totalAnimals: "Total de animais",
				herds: "Lotes",
				recentActivity: "Atividade Recente",
				recentOperations: "Manejos recentes",
				recentMeasurements: "Pesagens recentes",
			},
			recentActivity: {
				title: "Atividade Recente",
				viewAll: "Ver tudo",
				thisMonth: "este mês",
				noActivity: "Nenhuma atividade recente",
			},
			herds: {
				title: "Lotes",
				viewAll: "Ver todos",
				createHerd: "Criar lote",
				empty: "Nenhum lote ainda. Crie um lote para organizar seus animais.",
			},
			quickActions: {
				title: "Ações rápidas",
				addHerd: "Criar lote",
				// Uma palavra só — a barra do celular não comporta "Criar lote".
				addHerdShort: "Lote",
				animals: "Animais",
				health: "Saúde",
			},
			sections: {
				herds: "Lotes",
				herdsDesc: "Organize os animais em lotes",
				animals: "Animais",
				animalsDesc: "Consulte e gerencie cada animal",
				health: "Manejo sanitário",
				healthDesc: "Acompanhe vacinações, doenças e tratamentos",
				grazing: "Pastejo",
				grazingDesc: "Acompanhe os lotes em cada piquete",
				feeding: "Alimentação",
				feedingDesc: "Gerencie suplementação e dietas",
				reproduction: "Reprodução",
				reproductionDesc: "Acompanhe eventos de reprodução e partos",
			},
		},
		herd: {
			singular: "Lote",
			select: "Selecionar lote",
			name: "Nome",
			animals: "Animais",
			activeCount_one: "{{count}} ativo",
			activeCount_other: "{{count}} ativos",
			otherCount_one: "{{count}} outro",
			otherCount_other: "{{count}} outros",
			purpose: "Finalidade",
			description: "Descrição",
			primaryBreed: "Raça predominante",
			managementSystem: "Sistema de criação",
			targetWeightKg: "Peso-alvo (kg)",
			maxCapacity: "Capacidade máxima",
			formationDate: "Data de formação",
			currentPaddock: "Piquete atual",
			unassigned: "Sem piquete",
			rotateToPaddock: "Mudar de piquete",
			assignPaddock: "Colocar no piquete",
			rotateToPaddockShort: "Mudar",
			assignPaddockShort: "Colocar",
			rotate: {
				dialog: {
					title: "Mudar lote de piquete",
					description:
						"Escolha o novo piquete do lote. A mudança ficará registrada no histórico de pastejo.",
					descriptionFrom: "Pastando em {{name}}. Escolha o próximo piquete.",
				},
				fields: {
					paddock: "Piquete de destino",
					paddockPlaceholder: "Selecione um piquete",
					occupiedBy: "ocupado por {{name}}",
					restedDays_one: "descansado há {{count}} dia",
					restedDays_other: "descansado há {{count}} dias",
				},
				samePaddockWarning: "O lote já está neste piquete",
				noPaddocks: "Nenhum piquete cadastrado nesta fazenda",
				createPaddockLink: "Criar um",
				detailsToggle: "+ Informar planejamento",
				endGrazing: "Encerrar pastejo",
				endGrazingConfirm:
					"Marcar o lote como fora do pasto. A rotação atual será encerrada.",
				endGrazingConfirmButton: "Confirmar encerramento",
			},
			healthAlerts: "Alertas sanitários",
			details: "Detalhes",
			totalAnimals: "Total de Animais",
			healthEvents: "Ocorrências sanitárias",
			feedingPlans: "Planos de alimentação",
			tabs: {
				operations: "Manejos",
				measurements: "Medições",
				lotResult: "Resultado do lote",
			},
			sections: {
				basicInfo: {
					title: "Informações básicas",
					description: "Nome do lote e finalidade produtiva",
				},
				herdProfile: {
					title: "Perfil do lote",
					description: "Composição racial e sistema de criação",
				},
				managementGoals: {
					title: "Metas de produção",
					description: "Metas de produção e planejamento de capacidade",
				},
				additionalDetails: {
					title: "Outras informações",
					description: "Notas e informações extras",
				},
			},
			list: {
				title: "Lotes",
				empty: {
					title: "Nenhum lote cadastrado",
					// Diz para que serve um lote e que dá para começar sem nenhum — não
					// promete que algum animal será colocado nele (§2.7).
					description:
						"Lotes agrupam animais para manejar juntos — pesar, vacinar ou mover de uma vez. Você pode começar sem eles.",
					createButton: "Criar lote",
				},
			},
			create: {
				title: "Criar lote",
			},
			edit: {
				title: "Editar lote",
			},
			placeholders: {
				name: "Digite o nome do lote",
				purpose: "Selecione a finalidade",
				description: "Digite a descrição do lote (opcional)",
				primaryBreed: "Digite a raça principal",
				targetWeightKg: "ex. 480",
				maxCapacity: "ex. 100",
			},
			purposes: {
				BREEDING: "Reprodução",
				FATTENING: "Engorda",
				DAIRY: "Produção de leite",
				MIXED: "Misto",
				REPLACEMENT: "Reposição",
			},
			purposeDescriptions: {
				BREEDING: "Cria e reprodução",
				FATTENING: "Ganho de peso para venda/abate",
				DAIRY: "Produção de leite",
				MIXED: "Múltiplos objetivos produtivos",
				REPLACEMENT: "Novilhas e touros de reposição",
			},
			managementSystems: {
				EXTENSIVE: "Extensivo",
				SEMI_INTENSIVE: "Semi-intensivo",
				INTENSIVE: "Intensivo",
				CONFINEMENT: "Confinamento",
			},
			managementSystemDescriptions: {
				EXTENSIVE: "Pastejo livre em grandes pastagens",
				SEMI_INTENSIVE: "Pastejo com suplementação alimentar",
				INTENSIVE: "Pastejo intensivo com alta lotação",
				CONFINEMENT: "Confinamento",
			},
			tooltips: {
				primaryBreed:
					"A raça predominante neste lote. Determina genética, desempenho esperado e protocolos de saúde.",
				managementSystem:
					"Como os animais são criados e alimentados. Define alimentação, espaço e planejamento de custos.",
				targetWeightKg:
					"O peso alvo de saída/abate dos animais deste lote. Especialmente relevante para lotes de engorda.",
				maxCapacity:
					"Número máximo de animais planejado para este lote. Ajuda a prevenir superlotação e auxilia no cálculo da taxa de lotação.",
				formationDate:
					"Quando este lote foi formado. Útil para acompanhar a idade e o desempenho do lote ao longo do tempo.",
			},
			quickBreeds: [
				"Nelore",
				"Angus",
				"Brahman",
				"Hereford",
				"Senepol",
				"Tabapuã",
				"Girolando",
				"Guzerá",
			],
			form: {
				nameLabel: "Nome do lote",
				required: "obrigatório",
				namePlaceholder: "Vacas — Retiro Alto",
				nameError:
					"O lote precisa de um nome — é a única coisa obrigatória aqui.",
				purposeTitle: "Para que serve este lote",
				purposeSub:
					"Define quais números o RuralOps acompanha para ele. Você pode mudar depois.",
				purposeDesc: {
					BREEDING:
						"Reprodução e melhoramento genético. O RuralOps vai acompanhar partos, coberturas e diagnósticos de gestação.",
					FATTENING:
						"Ganho de peso para venda ou abate. O RuralOps vai acompanhar o ganho diário e os dias até o peso-alvo.",
					DAIRY:
						"Produção de leite. O RuralOps vai acompanhar a produção por vaca e o estágio de lactação.",
					MIXED:
						"Mais de um objetivo no mesmo lote. O RuralOps acompanha tanto os números de reprodução quanto os de peso.",
					REPLACEMENT:
						"Animais jovens mantidos para futura reprodução. O RuralOps vai acompanhar o crescimento até o peso de entrada em cobertura.",
				},
				breedTitle: "Raça predominante",
				breedSub: "Toque em uma, ou digite uma raça que não está na lista.",
				otherBreed: "+ Outra raça",
				otherBreedPlaceholder: "Nome da raça",
				systemTitle: "Como é criado",
				systemSub: "Orienta o planejamento de alimentação, espaço e custo.",
				systemDesc: {
					EXTENSIVE: "Pastejo livre em grandes pastagens.",
					SEMI_INTENSIVE: "Pastejo com suplementação alimentar.",
					INTENSIVE: "Pastejo intensivo com alta lotação.",
					CONFINEMENT: "Sistema de confinamento em curral ou galpão.",
				},
				systemNone:
					"Não definido. O lote funciona sem isso — o planejamento de alimentação e custo fica desligado até você escolher.",
				planningTitle: "Detalhes de planejamento",
				planningOptional: "opcional",
				planningSub:
					"Informe o que você já sabe. Cada item é usado em um cálculo específico, indicado abaixo do campo.",
				remove: "remover",
				units: {
					head: "cab",
					kg: "kg",
				},
				details: {
					capacity: {
						label: "Capacidade máxima",
						help: "Usado para avisar antes de o lote passar da capacidade dos piquetes.",
					},
					formed: {
						label: "Data de formação",
						help: "Usado para relatar a idade e o desempenho do lote ao longo do tempo.",
					},
					notes: {
						label: "Observações",
						help: "Texto livre. Aparece no registro do lote, não nos relatórios.",
						placeholder: "Algo que a próxima pessoa deve saber sobre este lote",
					},
					targetWeight: {
						label: "Peso-alvo",
						help: "O peso de saída que o RuralOps usa de referência — dias até o peso-alvo em lote de engorda.",
					},
				},
				statusReady: "Pronto para criar",
				upToHead: "até {{count}} cabeças",
				create: "Criar lote",
			},
			saved: {
				title: "{{name}} criado",
				body: "O lote fica vazio até ter animais nele. Transfira animais já cadastrados ou cadastre novos direto neste lote.",
				addAnimals: "Adicionar animais a este lote",
				createAnother: "Criar outro lote",
				undo: "Desfazer",
				missingTitle: "Preencha quando souber",
				missingCaption_one:
					"{{count}} detalhe deixado de fora. Nenhum deles bloqueia nada hoje.",
				missingCaption_other:
					"{{count}} detalhes deixados de fora. Nenhum deles bloqueia nada hoje.",
			},
			animalsSection: {
				title: "Animais do Lote",
				description: "Gerencie os animais atribuídos a este lote",
				searchPlaceholder: "Buscar animal para adicionar...",
				addAnimal: "Adicionar",
				empty:
					"Nenhum animal neste lote ainda. Use a busca acima para adicionar animais.",
				removeConfirm: "Remover este animal do lote?",
				count: "{{count}} animais neste lote",
				noUnassigned: "Nenhum animal sem lote disponível",
			},
			animalsList: {
				toggleShow: "Mostrar animais",
				toggleHide: "Ocultar animais",
				empty: "Nenhum animal neste lote ainda.",
			},
			/**
			 * Ficha do lote no mesmo arranjo da ficha do animal: trilho de
			 * identidade + cartões empilhados no desktop; barra + números
			 * primeiro no telefone.
			 */
			detail: {
				weight: {
					title: "Peso",
					weigh: "Pesar",
					average: "Média do lote",
					noWeighing: "Sem pesagem ainda",
					emptyHint:
						"Peso médio e ganho diário aparecem depois das primeiras pesagens.",
					gmd90: "GMD (90 dias)",
					gmd30: "GMD (30 dias)",
					gmdTitle: "Ganho médio diário",
					target: "Meta",
					targetUnset: "Sem meta definida",
					toTarget: "Para a meta",
					percentOfTarget: "{{percent}}% da meta",
					thinCoverage: "Pouca cobertura — {{weighed}} de {{total}} pesados",
					head: "Cabeças",
				},
				attention: {
					title: "Atenção",
					nothingPending: "Nada pendente",
					openItems_one: "{{count}} item em aberto",
					openItems_other: "{{count}} itens em aberto",
				},
				animals: {
					title: "Animais",
					empty: "Nenhum animal neste lote ainda.",
					caption_one: "{{count}} animal neste lote",
					caption_other: "{{count}} animais neste lote",
				},
				records: {
					title: "Registros",
					hint: "Pesagens, vacinas, tratamentos e mudanças de piquete deste lote ficam aqui.",
				},
				details: {
					title: "Ficha",
					add: "Adicionar",
					purpose: "Finalidade",
					paddock: "Piquete",
					animals: "Animais",
					breed: "Raça",
					system: "Sistema",
					target: "Meta",
					capacity: "Capacidade",
					formed: "Formado",
					registered: "Cadastro",
					paddockNotRecorded: "Sem piquete",
					notRecorded: "Não registrado",
					capacityValue: "{{count}} cabeças",
					fieldsFilled: "{{filled}} de {{total}} campos preenchidos.",
					fieldsFilledShort: "{{filled}} de {{total}} preenchidos",
					completeDetails: "Completar ficha",
				},
				lotResult: {
					open: "Abrir resultado do lote",
					empty: "Sem resultado ainda",
				},
				more: "Mais ações",
				delete: "Excluir lote",
			},
			confirmDelete: "Tem certeza que deseja excluir este lote?",
			notFound: "Lote não encontrado",
			deleteConfirm: {
				title: "Excluir lote {{name}}?",
				body: "Esta ação não pode ser desfeita.",
				blocked:
					"Este lote tem {{count}} animais. Remova ou transfira os animais antes de excluir.",
			},
			actionsComingSoon: "Mais ações em breve...",
			createSuccess: "Lote criado com sucesso",
			createError: "Falha ao criar lote",
			updateSuccess: "Lote atualizado com sucesso",
			updateError: "Falha ao atualizar lote",
			deleteSuccess: "Lote excluído com sucesso",
			deleteError: "Falha ao excluir lote",
		},
		animal: {
			singular: "Animal",
			select: "Selecionar animal",
			tagId: "Número do brinco",
			tagIdFormLabel: "Número do brinco",
			electronicId: "Brinco eletrônico (RFID)",
			registrationNumber: "Registro genealógico",
			sex: "Sexo",
			breed: "Raça",
			coatColor: "Pelagem",
			herd: "Lote",
			status: "Status",
			birthDate: "Data de nascimento",
			birthWeight: "Peso ao nascer",
			originType: "Origem",
			acquisitionDate: "Data da compra",
			acquisitionCost: "Valor de compra",
			supplier: "Fornecedor",
			sire: "Pai (touro)",
			dam: "Mãe (matriz)",
			sireTagId: "Brinco do pai (animal externo)",
			damTagId: "Brinco da mãe (animal externo)",
			hornStatus: "Chifres",
			isCastrated: "Castrado",
			notes: "Observações de manejo",
			temperament: "Temperamento",
			temperaments: {
				DOCILE: "Dócil",
				NORMAL: "Normal",
				NERVOUS: "Nervoso",
				AGGRESSIVE: "Agressivo",
			},
			gtaNumber: "Número da GTA",
			invoiceNumber: "Número da nota fiscal",
			originFarmName: "Fazenda de origem",
			// Ficha do animal (plano 2026-09-04, fase 7): categoria, idade,
			// identificação, procedência, piquete, morte.
			categories: {
				BEZERRO: "Bezerro",
				BEZERRA: "Bezerra",
				GARROTE: "Garrote",
				NOVILHA: "Novilha",
				VACA: "Vaca",
				TOURO: "Touro",
				BOI_MAGRO: "Boi magro",
				BOI_GORDO: "Boi gordo",
			},
			castration: {
				yes: "Sim",
				no: "Não (inteiro)",
			},
			daysOnFarm: "Tempo na fazenda",
			daysOnFarmValue_one: "na fazenda há {{count}} dia",
			daysOnFarmValue_other: "na fazenda há {{count}} dias",
			currentPaddock: "Piquete atual",
			paddockDays_one: "há {{count}} dia",
			paddockDays_other: "há {{count}} dias",
			noPaddock: "Sem piquete registrado",
			death: {
				title: "Morte",
				date: "Data da morte",
				cause: "Causa",
				causeUnknown: "Causa não registrada",
			},
			latestWeight: "Último peso",
			notWeighedYet: "Sem pesagem",
			noHerd: "Sem lote",
			moveHerd: "Mover",
			adg: "Ganho médio diário",
			estimatedCarcassBasis: "{{percent}}% de {{weight}} kg",
			targetWeight: "Peso-alvo",
			targetWeightUnset: "Não definido",
			targetMet: "Atingido",
			targetNotMet: "Não atingido",
			setTarget: "Definir",
			setTargetTitle: "Peso-alvo do lote",
			setTargetDescription: "Vale para todos os animais de {{herd}}.",
			setTargetSave: "Salvar alvo",
			acquisitionCostNotApplicable: "Não se aplica — nascido na fazenda",
			acquisitionCostUnset: "Não registrado",
			// Dia um (§2.4, revisto em 2026-09-04): a ficha vazia dizia o mesmo
			// fato ausente em seis lugares e não oferecia a saída em nenhum.
			// Tudo o que falta vem de UMA pesagem — então diga isso uma vez só.
			dayOne: {
				unlockTitle: "Pese {{tagId}} para liberar ganho, margem e alertas",
				unlockBody:
					"É o único registro que falta — o resto da ficha se preenche a partir dele.",
				addPhoto: "Adicionar foto",
				assignHerd: "Colocar em um lote",
				createHerd: "Criar o primeiro lote",
				profileIncomplete:
					"Nascimento, origem e filiação ainda não registrados.",
				completeProfile: "Completar ficha",
			},
			/**
			 * Redesenho da ficha do animal (handoff Claude Design 1b/2a/3a/3b):
			 * trilho de identidade + cartões empilhados, sem abas.
			 */
			detail: {
				weight: {
					title: "Peso",
					add: "Peso",
					overTime: "Peso ao longo do tempo",
					lastOn: "Última em {{date}}",
					herdTarget: "Meta do lote",
					herdTargetUnset: "Meta do lote · definida pelo lote",
					toTarget: "Para a meta",
					estimatedCarcass: "Carcaça est. ({{percent}}%)",
					percentOfTarget: "{{percent}}% da meta",
					yieldNote:
						"@ com rendimento de carcaça de {{percent}}% (1 @ = {{kgPerArroba}} kg de carcaça)",
					rankInLot: "{{rank}}º de {{size}} no lote",
					chartTarget: "Meta {{kg}} kg · {{arrobas}} @",
					noWeighing: "Sem pesagem ainda",
					emptyHint:
						"Arrobas, meta e ganho diário aparecem depois das primeiras pesagens.",
					chartEmpty: "A curva começa na primeira pesagem.",
					gmdTitle: "Ganho médio diário",
					gmdLifetime: "Desde a primeira pesagem",
					gmdLastTwo: "Últimas duas pesagens",
				},
				attention: {
					title: "Atenção",
					nothingPending: "Nada pendente",
					next: "próximo: {{label}}, {{date}}",
					scheduleFirstWeighing: "Agendar a primeira pesagem",
					openItems_one: "{{count}} item em aberto",
					openItems_other: "{{count}} itens em aberto",
				},
				health: {
					title: "Sanidade",
					noWithdrawal: "Sem carência",
					noTreatment: "sem tratamento ativo",
					noVaccines: "nenhuma vacina registrada",
					withdrawalUntil: "Carência até {{date}}",
					treatments_one: "{{count}} tratamento recente",
					treatments_other: "{{count}} tratamentos recentes",
					openDiseases_one: "{{count}} ocorrência aberta",
					openDiseases_other: "{{count}} ocorrências abertas",
					vaccinesOverdue_one: "{{count}} vacina atrasada",
					vaccinesOverdue_other: "{{count}} vacinas atrasadas",
					vaccinesUpToDate: "vacinas em dia",
					vaccinesWindowMissed_one: "{{count}} janela de vacina fechada",
					vaccinesWindowMissed_other: "{{count}} janelas de vacina fechadas",
					showDetail: "Detalhe sanitário",
					hideDetail: "Ocultar detalhe sanitário",
				},
				vaccination: {
					record: "Vacina",
					recordShort: "Vacina",
					columns: {
						vaccine: "Vacina",
						status: "Situação",
						lastApplication: "Última aplicação",
						nextDue: "Próxima dose",
					},
					lastAndDue: "Última {{last}} · vence {{due}}",
					lastOnly: "Última {{last}}",
					dueOnly: "Vence {{due}}",
					noApplication: "Nenhuma aplicação registrada",
					footerNote:
						"As vacinas obrigatórias da região estão listadas. Registre a última aplicação para começar o acompanhamento.",
				},
				records: {
					title: "Registros",
					hint: "Pesagens, vacinas, tratamentos e mudanças de lote deste animal ficam aqui.",
				},
				details: {
					title: "Ficha",
					add: "Adicionar",
					age: "Idade",
					paddock: "Pasto",
					birth: "Nascimento",
					coat: "Pelagem",
					horns: "Chifres",
					acquisition: "Aquisição",
					acquisitionNotApplicable: "Não se aplica",
					onFarmValue_one: "{{count}} dia",
					onFarmValue_other: "{{count}} dias",
					registered: "Cadastrado",
					onFarm: "Na fazenda",
					paddockNotRecorded: "Não registrado",
					sexCastrated: "{{sex}}, castrado",
					fieldsFilled: "{{filled}} de {{total}} campos preenchidos.",
					fieldsFilledShort: "{{filled}} de {{total}} preenchidos",
					completeDetails: "Completar ficha",
				},
				margin: {
					noCost: "Sem custo de aquisição. Adicione custos para ver a margem.",
					addCost: "Adicione o custo de aquisição para acompanhar a margem.",
					open: "Abrir margem",
					projected: "Projeção de {{value}} a {{price}}/@",
					realized: "Margem líquida {{value}}",
					needsWeighing: "Registre uma pesagem para projetar a margem.",
				},
				images: {
					title: "Imagens · {{count}}",
					none: "Nenhuma ainda.",
				},
				suggestion: {
					source: "Assistente RuralOps",
					title: "Complete {{tagId}} com uma pesagem e um lote",
					body: "Com o primeiro peso e um lote, a ficha mostra meta, arrobas e posição no lote. Raça e data de nascimento podem esperar.",
					evidence: "Só brinco e sexo registrados",
					approve: "Registrar pesagem",
					dismiss: "Agora não",
				},
				quickAdd: {
					weighing: "Pesagem",
					moveToHerd: "Mover para lote",
					vaccine: "Vacina",
					photo: "Foto",
				},
				badges: {
					registeredToday: "Cadastrado hoje",
				},
				categoryGuide: {
					title: "Como a categoria é definida",
					intro:
						"O RuralOps define a categoria pelo sexo, idade, castração e último escore corporal do animal. Não é um campo que você escolhe.",
					open: "Como {{category}} e as outras categorias são definidas",
					thisAnimal: "Este animal",
					bandCalf: "Menos de 12 meses",
					bandYoung: "12 a 23 meses",
					bandAdult: "24 meses ou mais",
					definitions: {
						BEZERRO: "Macho.",
						BEZERRA: "Fêmea.",
						GARROTE: "Macho.",
						NOVILHA: "Fêmea.",
						VACA: "Fêmea.",
						TOURO: "Macho inteiro (não castrado).",
						BOI_MAGRO:
							"Macho castrado, ainda magro (ECC em geral 5 ou menos). Também usado quando a castração é desconhecida.",
						BOI_GORDO:
							"Macho castrado com acabamento de abate (ECC 7 ou mais).",
					},
					finishingTitle: "Boi magro e boi gordo",
					finishingBody:
						"A diferença é o escore de condição corporal na escala 1–9 que o RuralOps já registra (1 = emaciado, 5 = moderado, 9 = obeso). Boi magro ainda está magro — em geral 5 ou menos. Boi gordo já tem acabamento de abate — em geral 7 ou mais. Um escore de 7 ou mais muda este selo para boi gordo.",
					noBirthDate: "Sem data de nascimento, nenhuma categoria é mostrada.",
				},
				more: "Mais ações",
				delete: "Excluir animal",
			},
			ageMonths: "Idade (meses)",
			details: "Detalhes",
			weightRecords: "Histórico de pesagens",
			healthEvents: "Histórico sanitário",
			reproductionEvents: "Histórico reprodutivo",
			plural: "animais",
			sections: {
				identification: {
					title: "Identificação",
					description: "Dados primários de identificação e registro",
				},
				classification: {
					title: "Classificação",
					description: "Sexo, raça e aparência física",
				},
				birthAndOrigin: {
					title: "Nascimento e origem",
					description: "Dados do nascimento ou da compra do animal",
				},
				parentage: {
					title: "Filiação",
					description: "Informações do pai e da mãe",
				},
				physicalCharacteristics: {
					title: "Características físicas",
					description: "Pelagem, chifres e outras características",
				},
				assignment: {
					title: "Situação no rebanho",
					description: "Lote e situação atual do animal",
				},
			},
			tooltips: {
				electronicId:
					"Número do transponder RFID/EID usado para identificação eletrônica",
				registrationNumber: "Número oficial de registro de raça ou pedigree",
				birthWeight: "Peso ao nascer em quilogramas",
				hornStatus: "Condição atual dos chifres do animal",
				isCastrated: "Se o animal macho foi castrado",
			},
			parentageMode: {
				systemAnimal: "Selecionar do sistema",
				externalTag: "Informar brinco de animal externo",
			},
			calvingPrompt: {
				title: "Registrar também este parto?",
				description:
					"A mãe está nesta fazenda, então podemos registrar um parto nela e cadastrar este animal como bezerro(a) — a filiação e o registro de nascimento são preenchidos automaticamente.",
				birthDateRequired:
					"Informe a data de nascimento — ela é a data do parto.",
			},
			// Cadastro rápido (design handoff "Cadastro de animal"): brinco, sexo
			// e data de nascimento são obrigatórios; o resto entra por toque nas pílulas.
			quick: {
				required: "obrigatório",
				nextFree: "próximo livre: {{tag}}",
				tagFree: "Livre — nenhum animal com esse brinco.",
				tagTaken: "Brinco {{tag}} já está no rebanho.",
				tagTakenInHerd: "Brinco {{tag}} já está no rebanho, no {{herd}}.",
				seeAnimal: "Ver esse animal",
				detailsTitle: "Detalhes (opcional)",
				detailsHint: "Toque no que você tem agora. O resto fica para depois.",
				remove: "remover",
				missing: "Falta {{fields}}",
				missingJoin: " e ",
				missingTag: "número do brinco",
				missingSex: "sexo",
				missingBirthDate: "data de nascimento",
				fixTag: "Corrija o brinco para continuar",
				ready: "Pronto para criar",
				editNote: "Alterações entram no histórico do animal",
				createAndNext: "Criar e próximo",
				createAnimal: "Criar animal",
				saveChanges: "Salvar alterações",
			},
			created: {
				title: "Animal {{tag}} criado",
				noDetails: "Sem detalhes ainda",
				next: "Cadastrar próximo",
				viewRecord: "Ver a ficha",
				undo: "Desfazer",
				repeat: "Repetir raça, lote e origem no próximo",
				sessionTitle: "Cadastrados agora",
				count_one: "{{count}} animal",
				count_other: "{{count}} animais",
				queued: "Sem sinal — vai subir sozinho quando a conexão voltar.",
			},
			quickBreeds: [
				"Nelore",
				"Angus",
				"Brahman",
				"Girolando",
				"Gir",
				"Guzerá",
				"Tabapuã",
				"Senepol",
				"Hereford",
				"Charolais",
			],
			quickCoatColors: [
				"Branco",
				"Preto",
				"Vermelho",
				"Amarelo",
				"Baio",
				"Cinza",
				"Malhado",
				"Rajado",
			],
			tabs: {
				operations: "Manejos",
				measurements: "Medições",
			},
			list: {
				title: "Animais",
				empty: {
					title: "Nenhum animal cadastrado",
					description:
						"Cadastre o primeiro animal para começar a acompanhar o rebanho.",
				},
				// Categoria derivada da idade e do sexo — o domínio não guarda esse
				// campo, ele é lido na hora a partir do que já está na linha.
				category: {
					calf: "Bezerro",
					breeder: "Matriz",
					fattening: "Engorda",
				},
				// Etiquetas curtas dos pontos de atenção no cartão do celular; o
				// texto completo da categoria continua sendo o rótulo acessível.
				flags: {
					vaccination: "Vacina",
					weighing: "Sem pesagem",
					calving: "Parto próximo",
				},
				noWeighing: "sem pesagem",
				weighedDaysAgo_one: "há {{count}} dia",
				weighedDaysAgo_other: "há {{count}} dias",
				lotOverCapacity: "Lote superlotado",
				selectRow: "Selecionar o animal {{tag}}",
				resultLine: "{{shown}} de {{total}} animais",
				showMore_one: "Ver mais {{count}} animal",
				showMore_other: "Ver mais {{count}} animais",
				showAll: "Ver todos os {{count}} animais",
				// Rótulos curtos das colunas da tabela e do menu de ordenação — a
				// coluna já está num contexto onde "Número do brinco" e "Idade
				// (meses)" só gastam largura.
				columns: {
					tagId: "Brinco",
					sex: "Sexo",
					breed: "Raça",
					herd: "Lote",
					latestWeight: "Último peso",
					age: "Idade",
					establishment: "Fazenda",
					status: "Status",
				},
			},
			filters: {
				searchPlaceholder: "Buscar por brinco ou raça...",
				allStatuses: "Todos",
				count: "{{count}} de {{total}}",
				noResults: "Nenhum animal corresponde aos filtros",
				noResultsHint: "Tente ajustar ou limpar os filtros.",
				clear: "Limpar filtros",
				advanced: {
					button: "Filtros",
					title: "Filtros avançados",
					description:
						"Combine sexo, raça, lote, idade, datas e registros para definir um grupo de animais.",
					apply: "Aplicar",
					clearAll: "Limpar tudo",
					breedPlaceholder: "Selecione as raças",
					herdPlaceholder: "Selecione os lotes",
					selectedCount: "Selecionados: {{count}}",
					age: "Idade",
					agePresets: {
						"0-12": "0 a 12 meses",
						"12-24": "12 a 24 meses",
						"24-36": "24 a 36 meses",
						"36+": "Mais de 36 meses",
					},
					acquisition: "Data de aquisição",
					clearRange: "Limpar período",
					onlineOnly: "Disponível apenas online.",
				},
				records: {
					title: "Registros",
					empty: "Nenhuma condição de registro adicionada.",
					add: "Adicionar condição",
					remove: "Remover condição",
					more: "Mais tipos...",
					has: "Possui",
					hasNot: "Não possui",
					from: "De",
					to: "Até",
					anyDate: "Qualquer data",
					presets: {
						last30: "Últimos 30 dias",
						last90: "Últimos 90 dias",
						last365: "Últimos 12 meses",
					},
				},
			},
			create: {
				title: "Cadastrar animal",
				button: "Adicionar animal",
				// Uma palavra só — a barra do celular não tem largura para "Adicionar
				// animal" ao lado de "Importar".
				buttonShort: "Animal",
			},
			managementViews: {
				label: "Visão de manejo",
				general: "Geral",
				cowCalf: "Cria",
				stocking: "Recria",
				fattening: "Engorda",
			},
			managementColumns: {
				tagHerd: "Brinco / Lote",
				categoryBreed: "Categoria / Raça",
				acquisitionValueDate: "Valor / Data da aquisição",
				statusFarm: "Status / Fazenda",
				ageSex: "Idade / Sexo",
				dam: "Mãe",
				calf: "Última cria / parto",
				pregnancy: "Prenhez",
				expectedCalving: "Parto previsto",
				sire: "Touro / IATF",
				acquisitionDate: "Entrada",
			},
			managementColumnHelp: {
				label: "Sobre {{column}}",
				calf: "Mostra o brinco da cria mais recente vinculada à matriz e a data do último parto. Para preencher, abra a matriz e registre um Parto; a cria é cadastrada e vinculada automaticamente. Uma cria cadastrada com esta matriz como mãe também aparece aqui.",
				pregnancy:
					"Mostra o resultado do diagnóstico de gestação mais recente. Abra a matriz, escolha Registrar e lance um Diagnóstico de gestação. Após um parto, a situação volta a Desconhecido até um novo diagnóstico.",
				expectedCalving:
					"Data prevista para a matriz diagnosticada como prenhe. Registre uma IATF ou Monta natural antes do diagnóstico para calcular a previsão; sem cobertura, informe a idade gestacional estimada no diagnóstico. Sem esses dados, a previsão fica vazia.",
				sire: "Brinco do touro ou identificação do sêmen da prenhez atual. Registre a Monta natural com o brinco do touro, ou a IATF com a identificação do touro do sêmen, antes do Diagnóstico de gestação positivo. Só aparece para prenhez confirmada.",
			},
			quickFilters: {
				rowLabel: "Filtros rápidos",
				notVaccinated12m: "Não vacinados (12 meses)",
				noRecentWeighing90d: "Sem pesagem recente (90 dias)",
				femalesNoPregnancyCheck12m: "Fêmeas sem diagnóstico (12 meses)",
				recentCalvings30d: "Partos recentes (30 dias)",
				calves: "Bezerros (até 12 meses)",
				toWean: "Para desmamar",
				recentTreatment30d: "Tratamento recente (30 dias)",
				recentlyAcquired60d: "Adquiridos recentes (60 dias)",
				offlineUnavailable: "Indisponível offline",
				// Rótulos de celular. Mesma coorte, janela em abreviação de campo
				// (12m / 90d) — nunca uma afirmação menor que o rótulo completo
				// acima, que segue sendo o nome acessível em qualquer largura.
				short: {
					notVaccinated12m: "Não vacinados 12m",
					noRecentWeighing90d: "Sem pesagem 90d",
					femalesNoPregnancyCheck12m: "Fêmeas sem DG 12m",
					recentCalvings30d: "Partos 30d",
					calves: "Bezerros ≤12m",
					toWean: "Para desmamar",
					recentTreatment30d: "Tratamento 30d",
					recentlyAcquired60d: "Adquiridos 60d",
				},
			},
			saveAndAddAnother: "Salvar e adicionar outro",
			batchAdded_one: "{{count}} animal adicionado nesta sessão",
			batchAdded_other: "{{count}} animais adicionados nesta sessão",
			requiredHint: "Obrigatório",
			draft: {
				title: "Rascunho não salvo encontrado",
				description: "Você começou a cadastrar um animal nesta fazenda.",
				restore: "Restaurar",
				discard: "Descartar",
			},
			age: {
				label: "Idade",
				newborn: "Recém-nascido",
				year_one: "{{count}} ano",
				year_other: "{{count}} anos",
				month_one: "{{count}} mês",
				month_other: "{{count}} meses",
				monthShort: "{{count}} m",
			},
			validation: {
				sexRequired: "Escolha o sexo do animal",
				tagIdRequired: "Informe o número do brinco",
				tagIdDuplicate: "Já existe um animal com este brinco",
				tagIdFormat: "Use apenas letras, números, traços e espaços",
				birthDateRequired: "Informe a data de nascimento",
				birthDateFuture: "A data de nascimento não pode ser no futuro",
				birthWeightRange: "Informe um peso ao nascer entre 0 e 100 kg",
				costNegative: "O custo não pode ser negativo",
				acquisitionBeforeBirth:
					"A data de aquisição não pode ser anterior ao nascimento",
				acquisitionFuture: "A data de aquisição não pode ser no futuro",
			},
			edit: {
				title: "Editar Animal",
			},
			placeholders: {
				// Curto de propósito: o campo do brinco é um número grande de 26px, e
				// um exemplo longo estoura a linha no celular.
				tagId: "042",
				electronicId: "Digite o número RFID/EID",
				registrationNumber: "Digite o número de registro",
				sex: "Selecione o sexo",
				breed: "Digite a raça (ex: Angus)",
				coatColor: "Digite a cor da pelagem (ex: Preto)",
				herd: "Selecione o lote (opcional)",
				originType: "Selecione a origem",
				birthWeight: "Peso em kg",
				acquisitionCost: "Custo",
				supplier: "Nome do fornecedor",
				sire: "Selecione o pai",
				dam: "Selecione a mãe",
				sireTagId: "Informe o brinco do pai",
				damTagId: "Informe o brinco da mãe",
				notes: "Ex.: cuidado no tronco, mansa com o tratador",
				gtaNumber: "Número da GTA de entrada",
				invoiceNumber: "Número da nota fiscal de compra",
				originFarmName: "Nome da fazenda de origem",
			},
			sexes: {
				MALE: "Macho",
				FEMALE: "Fêmea",
			},
			statuses: {
				ACTIVE: "Ativo",
				SOLD: "Vendido",
				DECEASED: "Morto",
				TRANSFERRED: "Transferido",
			},
			origins: {
				born_on_farm: "Nascido na fazenda",
				purchased: "Comprado",
			},
			hornStatuses: {
				HORNED: "Com chifres",
				POLLED: "Mocho",
				DEHORNED: "Descornado",
				SCURRED: "Chifretes",
			},
			confirmDelete: "Tem certeza que deseja excluir este animal?",
			deleteConfirm: {
				title: "Excluir animal {{name}}?",
				body: "Esta ação não pode ser desfeita. Os registros deste animal também serão removidos.",
			},
			notFound: "Animal não encontrado",
			remove: "Remover",
			addResult: {
				success_one: "{{count}} animal adicionado ao lote",
				success_other: "{{count}} animais adicionados ao lote",
				partial:
					"{{success}} adicionados, {{failed}} falharam. Tente novamente os restantes.",
				allFailed: "Não foi possível adicionar os animais. Tente novamente.",
			},
			bulk: {
				select: "Selecionar",
				cancelSelect: "Cancelar seleção",
				actions: "Ações",
				moveToHerd: "Mover para lote",
				vaccinate: "Registrar vacinação",
				weigh: "Pesar (sessão)",
				exportCsv: "Exportar CSV",
				selectNeedsFarm:
					"A seleção múltipla só está disponível com uma fazenda selecionada. Escolha uma fazenda no seletor acima.",
				capExceeded: "Ações em lote são limitadas a {{max}} animais por vez.",
				mixedFarms:
					"Selecione animais de uma única fazenda para executar ações em lote.",
				moveTitle: "Mover para lote",
				moveDescription_one:
					"O animal selecionado será movido para o lote escolhido.",
				moveDescription_other:
					"Os {{count}} animais selecionados serão movidos para o lote escolhido.",
				moveCta_one: "Mover {{count}} animal",
				moveCta_other: "Mover {{count}} animais",
				moveSuccess_one: "{{count}} animal movido",
				moveSuccess_other: "{{count}} animais movidos",
				partialResult:
					"{{success}} concluídos, {{failed}} falharam. Revise a lista e tente novamente.",
				allFailed:
					"Nenhum item foi processado. Verifique os erros e tente novamente.",
				failuresTitle: "Itens com falha",
				herdPaddock_one: "{{paddock}} · há {{count}} dia",
				herdPaddock_other: "{{paddock}} · há {{count}} dias",
				csvExported: "CSV exportado",
				csvWeightHeader: "Último peso (kg)",
				delete: "Excluir",
				deleteTitle_one: "Excluir 1 animal?",
				deleteTitle_other: "Excluir {{count}} animais?",
				deleteBody:
					"O histórico de pesagens, vacinações e movimentações desses animais sai das listas e dos relatórios. Você pode registrar uma saída em vez de excluir.",
				deleteCancel: "Agora não",
				// A palavra que arma o botão de excluir — um verbo, não um brinco.
				deleteWord: "Excluir",
				deleteConfirm_one: "Excluir animal",
				deleteConfirm_other: "Excluir {{count}} animais",
				deleteSuccess_one: "{{count}} animal excluído",
				deleteSuccess_other: "{{count}} animais excluídos",
			},
			viewFullProfile: "Ver ficha completa",
			addToHerd: "Adicionar animal",
			addToHerdDescription:
				"Selecione animais sem lote para adicionar a este lote.",
			addCount: "Adicionar animais ({{count}})",
			noUnassigned: "Nenhum animal sem lote disponível",
			transferToHerd: "Transferir para outro lote",
			transferToHerdDescription: "Selecione o lote para transferir {{tagId}}.",
			removeFromHerd: "Retirar do lote",
			confirmRemoveFromHerd: "Remover {{tagId}} deste lote?",
			noOtherHerds: "Nenhum outro lote disponível",
			transfer: "Transferir",
			createSuccess: "Animal criado com sucesso",
			createError: "Falha ao criar animal",
			updateSuccess: "Animal atualizado com sucesso",
			updateError: "Falha ao atualizar animal",
			deleteSuccess: "Animal excluído com sucesso",
			deleteError: "Falha ao excluir animal",
		},
		// Genealogia (plano 2026-09-04, fase 7): duas gerações, com ancestrais
		// externos mostrados só pelo brinco.
		pedigree: {
			title: "Genealogia",
			subtitle:
				"Pais e avós; animais de fora da fazenda aparecem só pelo brinco.",
			sire: "Pai",
			dam: "Mãe",
			sireSire: "Avô paterno",
			sireDam: "Avó paterna",
			damSire: "Avô materno",
			damDam: "Avó materna",
			unknown: "Desconhecido",
		},
		offspring: {
			title: "Progênie",
			subtitle_one:
				"{{count}} cria registrada com este animal como pai ou mãe.",
			subtitle_other:
				"{{count}} crias registradas com este animal como pai ou mãe.",
			columns: {
				tag: "Brinco",
				sex: "Sexo",
				birthDate: "Nascimento",
				status: "Status",
				otherParent: "Outro progenitor",
				weaningWeight: "Peso ao desmame",
				weaningDate: "Desmame",
				latestWeight: "Último peso",
				gmd90: "GMD 90d",
			},
			empty: "Nenhuma cria encontrada.",
		},
		animalImport: {
			commitStopped:
				"A importação foi interrompida: alguns animais precisam de revisão. Confira a lista e tente de novo.",
			noAnimalsTitle: "Nenhum animal individual neste arquivo",
			noAnimalsBody:
				"Todas as linhas lidas eram totais ou resumos. Envie uma lista com uma linha por animal.",
			pageTitle: "Importar animais",
			eyebrow: "Rebanho",
			pageSubtitle:
				"Envie a lista do jeito que você já guarda. Nada é salvo no seu rebanho até você confirmar.",
			importAction: "Importar animais",
			importActionShort: "Importar",
			emptyStateHint:
				"Já tem o rebanho numa planilha, num relatório ou no caderno? Importe em vez de digitar animal por animal.",
			steps: {
				upload: "Enviar",
				read: "Ler",
				match: "Combinar",
				check: "Conferir",
			},
			volume: {
				title: "Quantos animais entram em uma importação",
				spreadsheet:
					"Uma planilha (.xlsx ou .csv) traz até {{max}} animais por importação.",
				visual:
					"PDF e foto são lidos de uma só vez, então o limite é de {{visualMax}} animais. Por enquanto os {{max}} animais valem só para planilha — uma lista maior precisa vir em planilha ou ser dividida em mais de um arquivo.",
				splitFile:
					"Este PDF ou foto tem mais animais do que cabe em uma leitura ({{visualMax}} no máximo). Divida em arquivos menores ou exporte a lista em planilha para trazer até {{max}} animais de uma vez.",
				spreadsheetTooManyRows:
					"Este arquivo tem {{rows}} linhas e cada importação leva até {{max}} animais. Divida em arquivos menores e importe um depois do outro — assim nada fica de fora sem você ver.",
			},
			upload: {
				title: "Envie sua lista de animais",
				helper:
					"Planilha, PDF ou uma foto da lista de papel. O assistente lê cada animal e você confere antes de qualquer coisa ser salva.",
				dropTitle: "Solte seu arquivo aqui",
				dropTypes: ".xlsx · .csv · PDF · JPEG · PNG",
				chooseFile: "Escolher um arquivo",
				takePhoto: "Tirar uma foto",
				readingFile: "Lendo o arquivo...",
				removeFile: "Remover",
				fileMetaSheet_one:
					"{{size}} · {{count}} linha · {{columns}} colunas encontradas",
				fileMetaSheet_other:
					"{{size}} · {{count}} linhas · {{columns}} colunas encontradas",
				fileMetaPhoto: "{{size}} · foto · lida de uma só vez",
				fileMetaPdf: "{{size}} · PDF · lido de uma só vez",
				submit_one: "Ler {{count}} animal",
				submit_other: "Ler {{count}} animais",
				submitPhoto: "Ler esta foto",
				submitPdf: "Ler este PDF",
				limitsLine:
					"Até {{max}} animais por planilha · até {{visualMax}} por PDF ou foto",
				showLimits: "O que posso enviar?",
				hideLimits: "Ocultar limites",
				limitSheet:
					"Planilha até {{sheetMax}}, {{max}} animais por importação.",
				limitVisual:
					"PDF ou foto até {{mediaMax}}, {{visualMax}} animais por importação — são lidos de uma só vez.",
				limitSplit:
					"Uma lista maior pode vir em planilha ou ser dividida em mais de um arquivo.",
				unsupportedType:
					"Tipo de arquivo não aceito. Envie uma planilha (.xlsx, .csv), um PDF ou uma foto (JPEG, PNG, WebP).",
				tooLarge: "Este arquivo é grande demais. O limite é {{max}}.",
				emptyFile:
					"Este arquivo não tem nenhuma linha para ler. Confira se a lista está mesmo nele e envie de novo.",
				unreadableFile:
					"Não foi possível ler este arquivo. Salve de novo como .xlsx ou .csv e envie outra vez.",
			},
			sheetPicker: {
				label: "Em qual aba estão os animais?",
				placeholder: "Selecione a aba",
				helper:
					"Esta planilha tem mais de uma aba. Escolha a que tem a lista de animais para a importação não ler a aba errada.",
				sheetRows_one: "{{count}} linha",
				sheetRows_other: "{{count}} linhas",
				emptySheet: "Esta aba não tem nenhuma linha.",
			},
			expectedRowCount: {
				label: "Quantos animais este arquivo deve ter?",
				optional: "Opcional",
				placeholder: "ex.: 120",
				helper:
					"Só para PDF e foto. Se você informar, comparamos com o que a IA leu e avisamos se faltar algum animal em vez de passar batido.",
				blankNote:
					"Em branco — a importação roda normalmente, mas não temos como avisar se algum animal ficou de fora.",
				invalid: "Informe um número inteiro de animais ou deixe em branco.",
				aboveVisualCap:
					"PDF e foto são lidos de uma só vez, até {{visualMax}} animais. Acima disso, envie a lista em planilha ou divida o arquivo.",
			},
			extraction: {
				title: "Lendo sua lista",
				helper:
					"Isso pode levar alguns minutos. A página atualiza sozinha. Nada foi salvo ainda.",
				doneTitle_one: "{{count}} animal lido",
				doneTitle_other: "Todos os {{count}} animais lidos",
				doneTitleUnknown_one: "{{count}} animal lido",
				doneTitleUnknown_other: "{{count}} animais lidos",
				doneHelper:
					"Agora, confirme para onde vão os animais. Nada foi salvo ainda.",
				animalsRead: "{{read}} de {{total}} animais lidos",
				animalsReadUnknown_one: "{{count}} animal lido",
				animalsReadUnknown_other: "{{count}} animais lidos",
				needsYouEyebrow: "Precisa de você",
				leaveNote:
					"Você pode sair desta página. A leitura continua e a importação fica esperando em Rebanho.",
				cancel: "Cancelar importação",
				continue: "Combinar os lotes",
				chunk: {
					label: "Parte {{index}} de {{total}}",
					rows: "Linhas {{from}}–{{to}}",
					failedNote:
						"Esta parte não pôde ser lida. Peça de novo — as outras partes ficam guardadas.",
					failedNoRetry:
						"Esta parte não pôde ser lida. Envie outro arquivo para continuar.",
					shortfall:
						"Esta parte devolveu menos animais do que tinha linhas. Leia de novo antes de seguir, para não importar meio rebanho.",
					stalled:
						"Esta parte está sendo lida há mais tempo do que deveria. Nada está trabalhando nela agora — peça de novo.",
					retry: "Ler esta parte de novo",
					retrying: "Lendo de novo...",
				},
			},
			failures: {
				retry: "Tentar novamente",
				manualEntry: "Cadastrar os animais na mão",
				chooseAnotherFile: "Enviar outro arquivo",
				budgetExceeded: {
					title: "Seu saldo de IA do mês acabou",
					helper:
						"Nada foi lido e nada foi cobrado. O saldo volta no começo do mês que vem, ou um administrador pode aumentar o limite nas configurações da organização. Até lá você pode cadastrar os animais na mão.",
				},
				noAccess: {
					title: "A extração por IA não está disponível nesta organização",
					helper:
						"Peça a um administrador para liberar os recursos de IA desta organização. Enquanto isso, o cadastro manual de animais continua funcionando.",
				},
				subscriptionInactive: {
					title: "Sua assinatura não está ativa",
					helper:
						"A extração por IA fica desligada enquanto o plano estiver inativo. Reative a assinatura para importar arquivos — cadastrar animais na mão funciona de qualquer jeito.",
				},
				providerRefusal: {
					title: "A IA se recusou a ler este arquivo",
					helper:
						"Enviar o mesmo arquivo outra vez não resolve — ela vai recusar de novo e a tentativa ainda consome seu saldo de IA. Confira se o arquivo é mesmo uma lista de animais, exporte de outra forma ou cadastre os animais na mão.",
					noRetryNote:
						"Não há o que tentar de novo aqui: o mesmo arquivo dá a mesma resposta.",
				},
				coverageMismatch: {
					title: "Os animais lidos não batem com o seu arquivo",
					helper:
						"Esperávamos {{expected}} animais e vieram {{extracted}}, então paramos em vez de importar meio rebanho. Leia de novo a parte que falhou ou divida o arquivo e importe por partes.",
				},
				tooManyRows: {
					title: "Este arquivo tem linhas demais",
					helper:
						"Este arquivo tem mais linhas do que conseguimos ler de uma vez (até {{max}} linhas para PDF ou foto). Divida em arquivos menores ou envie a lista em planilha.",
				},
				mediaContentMismatch: {
					title: "Este arquivo não é uma lista de animais",
					helper:
						"Envie uma lista de animais para continuar. Ler este arquivo novamente dará o mesmo resultado e consumirá mais do seu saldo de IA.",
				},
				extractionFailed: {
					title: "Não conseguimos ler este arquivo",
					helper:
						"Algo deu errado na leitura. Tente novamente — se falhar de novo, envie a lista em planilha ou cadastre os animais na mão.",
				},
			},
			slots: {
				shortfallTitle: "Seu plano não tem espaço para tantos animais",
				shortfall:
					"Seu plano tem {{remaining}} vagas de animal disponíveis e este arquivo pede {{requested}}.",
				shortfallAdvice:
					"Tire {{excess}} animais do arquivo, deixe-os de fora na revisão ou passe para um plano maior — depois importe de novo.",
			},
			match: {
				continue_one: "Conferir {{count}} animal",
				continue_other: "Conferir {{count}} animais",
			},
			check: {
				allClearTitle: "Está tudo pronto",
				allClearBody:
					"Todos os animais foram lidos sem problemas. Importe quando quiser.",
				metricReady: "Prontos para importar",
				metricReadyCaption: "Lidos sem problemas",
				metricAttention: "Precisam de atenção",
				metricAttentionCaption: "Corrija ou deixe de fora",
				metricAttentionNone: "Nada pendente",
				metricExcluded: "Deixados de fora",
				metricExcludedCaption: "Não vão entrar",
				metricExcludedNone: "Nenhum até agora",
				leaveThisOut: "Deixar este de fora",
				tagHeading: "Brinco {{tag}}",
				leaveOutShort: "Deixar de fora",
				backToLots: "Voltar aos lotes",
				filterLabel: "Quais animais mostrar",
				filterAll: "Todos {{count}}",
				filterAttention: "Precisam de atenção {{count}}",
				listEmpty:
					"Nenhum animal precisa de atenção. Tudo nesta lista está pronto para importar.",
				statusAttention: "Pendências",
				statusReady: "Pronto",
				lotLabel: "Lote",
				lotNone: "Sem lote",
				lotNew: "{{name}} (novo)",
				lotUndecided: "{{name}} (a decidir)",
				moreFields: "Mais campos",
				nothingToImport: "Nada para importar ainda",
				bulk: {
					birthDate: {
						title_one: "{{count}} animal está sem data de nascimento",
						title_other: "{{count}} animais estão sem data de nascimento",
						label: "Data de nascimento para todos",
						apply: "Preencher a data",
					},
					sex: {
						title_one: "{{count}} animal está sem sexo",
						title_other: "{{count}} animais estão sem sexo",
						label: "Sexo para todos",
						apply: "Definir o sexo",
					},
					currentWeightDate: {
						title_one: "{{count}} animal tem peso mas não tem data da pesagem",
						title_other:
							"{{count}} animais têm peso mas não têm data da pesagem",
						label: "Data da pesagem para todos",
						apply: "Preencher a data",
					},
				},
			},
			/** Títulos dos cartões de atenção, um por código. `{{tag}}` é o brinco da linha. */
			attention: {
				MISSING_TAG_ID: "Este animal está sem brinco",
				MISSING_SEX: "Sexo não lido no brinco {{tag}}",
				MISSING_BIRTH_DATE: "Nascimento não lido no brinco {{tag}}",
				INVALID_ENUM_VALUE:
					"Um valor do brinco {{tag}} não está entre as opções",
				INVALID_DATE: "Uma data do brinco {{tag}} não pôde ser lida",
				DATE_OUT_OF_RANGE: "Uma data do brinco {{tag}} não faz sentido",
				WEIGHT_OUT_OF_RANGE: "Um peso do brinco {{tag}} não faz sentido",
				MISSING_WEIGHING_DATE: "Um peso do brinco {{tag}} está sem data",
				REPRODUCTION_ON_MALE:
					"O brinco {{tag}} é macho e tem dados de reprodução",
				COST_OUT_OF_RANGE:
					"O preço de compra do brinco {{tag}} não faz sentido",
				DUPLICATE_TAG_IN_PAYLOAD:
					"O brinco {{tag}} aparece duas vezes neste arquivo",
				TAG_ALREADY_EXISTS: "O brinco {{tag}} já está no seu rebanho",
				HERD_REF_UNRESOLVED: "O lote do brinco {{tag}} não foi decidido",
				HERD_NOT_ON_ESTABLISHMENT:
					"O lote escolhido para o brinco {{tag}} não é um lote ativo desta fazenda",
				NON_ACTIVE_STATUS: "O brinco {{tag}} está marcado como saído",
			},
			review: {
				title: "Confira antes de salvar",
				helper:
					"Nada é salvo até você confirmar. Corrija o que precisa e deixe de fora o que não deve entrar.",
				rowLabel: "Linha {{n}}",
				pagination: "Linhas {{from}}–{{to}} de {{total}}",
				dateFormatHint: "dia/mês/ano",
				notRead: "não lido",
				fields: {
					notes: "Observações",
					currentWeightKg: "Peso atual (kg)",
					currentWeightDate: "Data da pesagem",
					acquisitionWeightKg: "Peso na compra (kg)",
					reproductiveStatus: "Situação reprodutiva",
					breedingDate: "Data da cobertura",
					breedingMethod: "Tipo de cobertura",
					sireName: "Touro / sêmen",
					pregnancyDiagnosisDate: "Data do diagnóstico de prenhez",
					expectedCalvingDate: "Parto previsto",
					lastCalvingDate: "Último parto",
				},
				reproductiveStatuses: {
					PREGNANT: "Prenha",
					EMPTY: "Vazia",
				},
				breedingMethods: {
					ARTIFICIAL_INSEMINATION: "Inseminação artificial",
					NATURAL_BREEDING: "Monta natural",
				},
				vaccinations: "Vacinações",
				nonAnimalRowsTitle_one:
					"{{count}} linha foi ignorada por ser total ou resumo",
				nonAnimalRowsTitle_other:
					"{{count}} linhas foram ignoradas por serem totais ou resumos",
				nonAnimalRowsBody:
					"Elas não são animais, então não serão importadas. Linhas: {{lines}}.",
				notReadHint:
					"Para os campos em branco quer dizer não conseguimos fazer a leitura ou os dados estão ausentes — por favor preencha manualmente.",
				excludeRow: "Deixar este animal de fora",
				includeRow: "Trazer este animal de volta",
				excludedBadge: "Fora da importação",
				excludeExisting_one:
					"Deixar de fora o {{count}} animal que já existe nesta fazenda",
				excludeExisting_other:
					"Deixar de fora os {{count}} animais que já existem nesta fazenda",
				includedCount_one: "{{count}} animal será importado",
				includedCount_other: "{{count}} animais serão importados",
				commit: "Importar {{count}} animais",
				committing: "Importando...",
				commitDisabledHint:
					"Corrija ou deixe de fora as linhas com problema antes de importar.",
				discard: "Descartar esta importação",
				discardConfirm:
					"Descartar esta importação? O arquivo e todas as correções feitas aqui serão perdidos.",
			},
			herdMapping: {
				title: "Para onde vão estes animais?",
				noLotColumn:
					"Seu arquivo não tem coluna de lote, então escolha uma vez para a importação inteira.",
				hasLotColumn_one:
					"Seu arquivo tem uma coluna de lote com {{count}} nome. Combine esse nome ou coloque todos os animais em um único lote.",
				hasLotColumn_other:
					"Seu arquivo tem uma coluna de lote com {{count}} nomes. Combine cada um ou coloque todos os animais em um único lote.",
				mode: {
					existing: "Um lote existente",
					new: "Um lote novo",
					none: "Sem lote",
				},
				existingLabel: "Lote",
				newNamePlaceholder: "ex.: Bezerros 2026",
				noneHint:
					"Todos os animais entram sem lote. Você pode agrupá-los depois pela lista do rebanho.",
				sourceName: "Nome no arquivo",
				decision: "O que fazer",
				animalsUsing_one: "{{count}} animal",
				animalsUsing_other: "{{count}} animais",
				kind: {
					existing: "Usar um lote existente",
					new: "Criar um lote novo",
					unmapped: "Importar sem lote",
				},
				existingPlaceholder: "Selecione o lote",
				newNameLabel: "Nome do novo lote",
				newPurposeLabel: "Finalidade do novo lote",
				newPurposePlaceholder: "Selecione a finalidade",
				unmappedHint:
					"Os animais entram sem lote. Você pode colocá-los em um lote depois.",
				assignAllLabel: "Colocar todos os animais em um único lote",
				assignAllHelper:
					"Use quando o arquivo todo é um só lote — isso substitui a combinação acima.",
				noHerdsOnFarm:
					"Esta fazenda ainda não tem lotes. Crie um aqui mesmo ou importe sem lote.",
				unresolved: "Diga o que fazer com este lote antes de seguir.",
				newNameRequired: "Dê um nome ao novo lote.",
				newPurposeRequired: "Escolha a finalidade do novo lote.",
				duplicateNewName: "Dois lotes novos não podem ter o mesmo nome.",
			},
			diagnostics: {
				title: "O que precisa de correção",
				rowProblems_one: "{{count}} problema",
				rowProblems_other: "{{count}} problemas",
				codes: {
					MISSING_TAG_ID:
						"Sem número de brinco. Todo animal precisa de um — digite o número ou deixe este animal de fora.",
					MISSING_SEX:
						"Sexo não informado. Escolha macho ou fêmea — o sistema precisa disso em todo animal.",
					MISSING_BIRTH_DATE:
						"Data de nascimento não informada. Todo animal precisa de uma — digite a data ou deixe este animal de fora.",
					INVALID_ENUM_VALUE:
						"Este valor não é uma das opções que o RuralOps aceita. Escolha uma da lista.",
					INVALID_DATE:
						"Não deu para entender esta data. Escreva no formato dia/mês/ano.",
					DATE_OUT_OF_RANGE:
						"Esta data está fora do que faz sentido — está no futuro ou muito antiga. Confira o ano.",
					WEIGHT_OUT_OF_RANGE:
						"Este peso está fora do que faz sentido para um animal. Veja se a unidade ou a vírgula do decimal escorregou.",
					COST_OUT_OF_RANGE:
						"Este valor de compra está fora do que o RuralOps consegue registrar. Veja se um CPF/CNPJ ou um número de cadastro caiu na coluna de valor.",
					DUPLICATE_TAG_IN_PAYLOAD:
						"Este brinco aparece mais de uma vez no arquivo. Mantenha uma linha e deixe a outra de fora.",
					TAG_ALREADY_EXISTS:
						"Já existe um animal com este brinco nesta fazenda. Deixe esta linha de fora para não ficar com dois.",
					HERD_REF_UNRESOLVED:
						"O lote deste animal ainda não foi definido. Resolva na lista de lotes acima.",
					HERD_NOT_ON_ESTABLISHMENT:
						"O lote escolhido não é um lote ativo desta fazenda. Escolha um lote ativo desta fazenda ou crie um novo.",
					NON_ACTIVE_STATUS:
						"Este animal está marcado como vendido, morto ou já fora do rebanho. A importação só cria animais ativos, então ele fica de fora por padrão.",
					MISSING_WEIGHING_DATE:
						"Um peso precisa da data em que foi tomado (no peso da compra, a data da compra). Preencha a data ou apague o peso.",
					REPRODUCTION_ON_MALE:
						"Prenhez, cobertura e parto só valem para fêmeas. Corrija o sexo ou apague os campos de reprodução.",
				},
			},
			success: {
				title: "Importação concluída",
				summary:
					"{{animals}} animais, {{herds}} lotes e {{records}} registros criados.",
				animalsCreated_one: "{{count}} animal criado",
				animalsCreated_other: "{{count}} animais criados",
				herdsCreated_one: "{{count}} lote criado",
				herdsCreated_other: "{{count}} lotes criados",
				noHerdsCreated: "Nenhum lote novo foi criado.",
				alreadyImported:
					"Este arquivo já havia sido importado, então nada foi criado de novo.",
				viewAnimals: "Ver os animais",
			},
			done: {
				title_one: "{{count}} animal está no seu rebanho",
				title_other: "{{count}} animais estão no seu rebanho",
				alreadyImportedTitle: "Esta lista já tinha sido importada",
				withLots_one:
					"Eles foram colocados em {{count}} lote. Pesagens e movimentações podem ser registradas pelo app.",
				withLots_other:
					"Eles foram colocados em {{count}} lotes. Pesagens e movimentações podem ser registradas pelo app.",
				withoutLot:
					"Eles entraram sem lote. Você pode agrupá-los pela lista do rebanho quando quiser.",
				seeHerd: "Ver o rebanho",
				importAnother: "Importar outra lista",
			},
			/**
			 * Estado da importação para o produtor. As chaves são os valores de wire da
			 * união `AnimalImportStatus`, para o render montar um
			 * `Record<AnimalImportStatus, …>` total.
			 */
			status: {
				EXTRACTING: {
					label: "Lendo o arquivo",
					description:
						"A IA ainda está lendo sua lista. Esta página atualiza sozinha.",
				},
				READY_FOR_REVIEW: {
					label: "Pronta para revisão",
					description:
						"A leitura terminou. Confira os animais antes de qualquer coisa ser salva.",
				},
				NEEDS_ATTENTION: {
					label: "Precisa de atenção",
					description: "Algo deu errado na leitura deste arquivo.",
				},
				IMPORTED: {
					label: "Importada",
					description: "Os animais deste arquivo já estão na fazenda.",
				},
				CANCELLED: {
					label: "Cancelada",
					description: "Você cancelou esta importação. Nada dela foi salvo.",
				},
			},
			landing: {
				title: "Já tem uma importação em andamento",
				helper:
					"Continue de onde você parou ou cancele para enviar outro arquivo.",
				fileLabel: "Arquivo",
				uploadedBy: "Enviado por {{name}}",
				uploadedAt: "Enviado em {{date}}",
				unknownUploader: "alguém desta fazenda",
				extractedRows_one: "{{count}} animal lido até agora",
				extractedRows_other: "{{count}} animais lidos até agora",
				declaredRows_one: "{{count}} linha no arquivo",
				declaredRows_other: "{{count}} linhas no arquivo",
				failureCodesLabel: "O que deu errado",
				continue: "Continuar esta importação",
				cancel: "Cancelar esta importação",
				newImportWithheld:
					"Você pode enviar outro arquivo assim que esta importação terminar ou for cancelada.",
			},
			/** Os textos mudam conforme o estado — são os três estados canceláveis. */
			cancelDialog: {
				title: "Cancelar esta importação?",
				body: {
					EXTRACTING:
						"A leitura para onde está e nada é salvo. O que a IA já leu não volta para o seu saldo de IA do mês.",
					READY_FOR_REVIEW:
						"Tudo o que você corrigiu, deixou de fora e mapeou na revisão é descartado e não tem como recuperar. Nada é salvo na fazenda, e o que a IA já leu não volta para o seu saldo de IA do mês.",
					NEEDS_ATTENTION:
						"A importação que falhou sai do seu caminho e nada é salvo. O que a IA já tentou ler não volta para o seu saldo de IA do mês.",
				},
				confirm: "Cancelar importação",
				keep: "Manter",
				pending: "Cancelando...",
				success: "Importação cancelada",
				error: "Não foi possível cancelar a importação. Tente de novo.",
				notCancellable:
					"Esta importação já foi salva na fazenda, então não dá para cancelar.",
			},
			cancelledNotice: {
				title: "Esta importação foi cancelada",
				helper:
					"Nada dela foi salvo. Envie outro arquivo para começar de novo.",
			},
			unknownImport: {
				title: "Importação não encontrada",
				helper:
					"O endereço pode estar velho ou a importação é de outra fazenda. Envie um arquivo para começar uma nova.",
			},
			/** Recusas na admissão do envio — uma para cada erro que o servidor levanta. */
			admission: {
				alreadyActive: {
					title: "Já tem uma importação em andamento nesta fazenda",
					helper:
						'"{{name}}" — {{state}}. Termine ou cancele antes de enviar outro arquivo.',
					action: "Ir para essa importação",
				},
				uploadInProgress: {
					title: "Outro arquivo ainda está sendo enviado",
					helper:
						"Espere um instante e envie o seu de novo. Se aquele envio não terminar, a fazenda libera sozinha em pouco tempo.",
					blockingFile:
						'"{{name}}" ainda está sendo enviado. Enviar e extrair ficará disponível quando esse envio terminar ou a reserva expirar.',
				},
				slotsExhausted: {
					title: "Seu plano não tem espaço para essa quantidade de animais",
					helper:
						"Este arquivo pede mais animais do que as vagas que sobram no seu plano. Nada foi enviado. Tire algumas linhas do arquivo, ou passe para um plano maior, e envie de novo.",
				},
			},
		},
		batch: {
			errors: {
				animalNotFound: "Animal não encontrado",
				listedInOffer:
					"Anunciado em uma oferta ativa do marketplace. Cancele a oferta primeiro.",
				differentFarm: "O animal pertence a outra fazenda",
				notActive: "Só animais ativos podem mudar de lote",
				animalNotActive:
					"Este animal não está mais ativo (vendido, morto ou transferido)",
				invalidValue: "O valor deve ser maior que 0",
				femaleOnly: "Permitido apenas para fêmeas",
				maleOnly: "Permitido apenas para machos",
				unknown: "Erro desconhecido",
			},
		},
		weighing: {
			title: "Pesagem em lote",
			startSession: "Pesar lote",
			startSessionShort: "Pesar",
			captureHint:
				"Fluxo de curral: brinco → peso → Enter, um animal após o outro",
			scopeHerd: "Lote: {{name}}",
			scopeSelection_one: "{{count}} animal selecionado",
			scopeSelection_other: "{{count}} animais selecionados",
			scopeFarm: "Todos os animais da fazenda",
			tagLabel: "Brinco",
			tagPlaceholder: "ex.: 042",
			weightLabel: "Peso (kg)",
			weightPlaceholder: "0,0",
			weightBelowMin: "Peso abaixo de {{min}} kg — confira a leitura",
			weightAboveMax: "Peso acima de {{max}} kg — confira a leitura",
			add: "Adicionar",
			lastAdded: "Adicionado {{tag}} · {{weight}} kg",
			suggestionCount_one: "{{count}} brinco correspondente",
			suggestionCount_other: "{{count}} brincos correspondentes",
			unknownTag: "Brinco não encontrado no plantel.",
			unknownTagOffline:
				"Brinco não encontrado nos dados offline. Cadastre agora e pese depois de sincronizar.",
			createAnimal: 'Criar animal "{{tag}}"',
			empty: "Nenhuma pesagem nesta sessão ainda",
			emptyHint:
				"Digite o brinco e o peso — Enter adiciona a linha e volta ao brinco.",
			date: "Data da pesagem",
			dateToday: "Hoje",
			save_one: "Salvar {{count}} pesagem",
			save_other: "Salvar {{count}} pesagens",
			confirmSaveTitle_one: "Salvar {{count}} pesagem?",
			confirmSaveTitle_other: "Salvar {{count}} pesagens?",
			confirmSaveDescription: "Revise os pesos capturados antes de salvar.",
			totalWeight: "Total {{total}} kg",
			autosaved: "salvo automaticamente",
			saveSuccess_one: "{{count}} pesagem registrada",
			saveSuccess_other: "{{count}} pesagens registradas",
			savePartial:
				"{{success}} salvas, {{failed}} falharam. As linhas com falha permanecem na sessão.",
			saveAllFailed:
				"Nenhuma pesagem foi salva. Verifique os erros e tente novamente.",
			replayPartial:
				"Pesagens sincronizadas: {{success}} salvas, {{failed}} recusadas pelo servidor.",
			discard: "Descartar sessão",
			discardConfirm_one: "Descartar {{count}} pesagem não salva?",
			discardConfirm_other: "Descartar {{count}} pesagens não salvas?",
			removeEntry: "Remover pesagem",
			entryRemoved: "{{tag}} removido",
			undo: "Desfazer",
			rosterTitle: "Animais na sessão",
			rosterProgress: "{{done}} de {{total}} pesados",
			rosterToWeigh: "A pesar",
			rosterWeighed: "Pesados",
			rosterSearchPlaceholder: "Filtrar por brinco…",
			rosterEmpty: "Nenhum animal no escopo desta sessão",
			rosterNoMatch: "Nenhum animal corresponde ao filtro",
			rosterLastWeight: "Último: {{weight}} kg",
			rosterSelect: "Selecionar brinco {{tag}} para pesar",
			rosterFilterHint_one: "{{count}} animal — digite para filtrar",
			rosterFilterHint_other: "{{count}} animais — digite para filtrar",
			rosterToggle: "Mostrar/ocultar animais da sessão",
		},
		record: {
			target: {
				appliesTo: "Aplica-se a",
				animalCount_one: "{{count}} animal",
				animalCount_other: "{{count}} animais",
			},
		},
		operations: {
			create: {
				title: "Registrar manejo",
				titleForHerd: "Registrar manejo no lote {{herdName}}",
				titleForType: "Registrar {{type}}",
				cohortDescription_one:
					"O registro será aplicado ao animal selecionado.",
				cohortDescription_other:
					"O mesmo registro será aplicado a cada um dos {{count}} animais selecionados.",
				cohortSuccess_one: "Registrado para {{count}} animal",
				cohortSuccess_other: "Registrado para {{count}} animais",
				ctaForCount_one: "Registrar para {{count}} animal",
				ctaForCount_other: "Registrar para {{count}} animais",
				ctaForTarget: "Registrar para {{target}}",
			},
			validation: {
				gestationDaysEstimate: "Informe de 1 a 320 dias de gestação.",
				grazingRotationNeedsHerd:
					"Este animal não está em um lote. A rotação de pastejo só pode ser registrada para um lote.",
			},
			list: {
				empty: "Nenhum manejo registrado ainda",
				addFirst:
					"Registre o primeiro manejo para começar a montar o histórico deste animal.",
				addOperation: "Adicionar manejo",
				viaHerd: "Registrado pelo lote: {{herdName}}",
				appliedToAnimals_one: "Aplicado a {{count}} animal",
				appliedToAnimals_other: "Aplicado a {{count}} animais",
			},
			page: {
				title: "Manejos",
				empty: "Nenhum manejo registrado ainda",
			},
			fields: {
				target: "Destino",
				type: "Tipo de manejo",
				operationDate: "Data",
				endDate: "Data Final",
				isActive: "Ativo",
				description: "Descrição",
				cost: "Custo",
				performedBy: "Responsável",
				paddock: "Piquete",
				notes: "Observações",
				medication: "Medicação",
				vaccine: "Vacina",
				vaccinePlaceholder: "Selecione uma vacina",
				vaccineHelp: "Se a vacina que você quer incluir não aparece, você pode",
				vaccineRegisterLink: "cadastrar uma nova",
				dosage: "Dosagem",
				batchNumber: "Lote do medicamento",
				nextDoseDate: "Próxima Dose",
				nextDoseDateHelpRecurring:
					"Pelo calendário sanitário (a cada {{days}} dias).",
				nextDoseDateHelpSingleDose:
					"Esta entrada do calendário é dose única, então não há próxima data.",
				diagnosis: "Diagnóstico",
				durationDays: "Duração (dias)",
				withdrawalDays: "Carência (dias)",
				withdrawalDaysHelp:
					"Período de carência para abate, contado a partir da última dose.",
				severity: "Gravidade",
				quarantined: "Em quarentena",
				cause: "Causa",
				disposalMethod: "Método de Descarte",
				planName: "Nome do Plano",
				feedType: "Alimento",
				dailyAmountKg: "Quantidade por dia (kg)",
				costPerKg: "Custo por kg",
				supplementType: "Tipo de Suplemento",
				amountKg: "Quantidade (kg)",
				frequency: "Frequência",
				plannedDays: "Permanência planejada (dias)",
				stockingRate: "Taxa de Lotação (UA/ha)",
				weaningWeightKg: "Peso de Desmame (kg)",
				weaningMethod: "Método de Desmame",
				method: "Método",
				tagType: "Tipo de Brinco",
				tagNumber: "Número do Brinco",
				cleaningType: "Tipo de Limpeza",
				area: "Área",
				pestType: "Tipo de Praga",
				product: "Produto",
				applicationMethod: "Método de Aplicação",
				semenBullId: "ID do Touro (Sêmen)",
				semenBatchNumber: "Lote do Sêmen",
				technique: "Técnica",
				observedSigns: "Sinais Observados",
				bullTagId: "Brinco do Touro",
				result: "Resultado",
				technician: "Técnico",
				gestationDaysEstimate: "Idade gestacional estimada (opcional)",
				gestationDaysEstimateHelp:
					"Use quando não houver uma IATF ou monta registrada; ajuda a calcular o parto previsto.",
				daysUnit: "dias",
				operationType: "Tipo de manejo",
				severityPlaceholder: "Selecione a gravidade",
				feedTypePlaceholder: "Selecione o tipo de ração",
				paddockPlaceholder: "Selecione o piquete",
			},
			placeholders: {
				medication: "ex., Ivermectina",
				vaccine: "ex., Febre Aftosa",
				dosage: "ex., 5ml",
				batchNumber: "ex., LOT-2026-001",
				cause: "ex., Desconhecida, Doença, Acidente",
				disposalMethod: "ex., Enterro, Compostagem",
				planName: "ex., Plano de Alimentação de Inverno",
				supplementType: "ex., Sal mineral, Proteína",
				method: "ex., Burdizzo, Cirúrgico",
				tagType: "ex., Brinco, RFID",
				tagNumber: "ex., BR-001",
				technique: "ex., Convencional, IATF",
				semenBullId: "ex., TOURO-2026-001",
				performedBy: "ex., Dr. Silva",
				description: "Descreva o que foi feito...",
				notes: "Observações adicionais...",
				cost: "0,00",
				cleaningType: "ex., Cocho, Galpão",
				area: "ex., Galpão A, Piquete 3",
				pestType: "ex., Carrapato, Mosca-do-chifre",
				product: "ex., Fipronil, Ivermectina",
				weaningWeight: "ex., 180",
				weaningMethod: "ex., Gradual, Abrupto",
				stockingRate: "ex., 2,5",
				plannedDays: "ex., 30",
				dailyAmountKg: "ex., 2,5",
				frequency: "ex., Diário, Duas vezes por semana",
				applicationMethod: "ex., Pour-on, Pulverização",
				observedSigns: "ex., Monta, inquietação",
				bullTagId: "ex., TOURO-07",
				result: "Selecione o resultado",
				pregnancyMethod: "Selecione o método",
				technician: "ex., Dr. Silva",
			},
			helpers: {
				cost: "Valor em R$",
				stockingRate: "Unidades animal por hectare",
				dailyAmountKg: "Por animal, por dia",
			},
			sections: {
				details: "Detalhes",
				additionalInfo: "Outras informações",
			},
			addNotes: "Adicionar Observações",
			saveAndAddAnother: "Salvar e adicionar outra",
			batchAdded_one: "{{count}} operação registrada nesta sessão",
			batchAdded_other: "{{count}} operações registradas nesta sessão",
			categories: {
				health: "Saúde",
				nutrition: "Nutrição",
				pasture: "Pastagem",
				reproduction: "Reprodução",
				management: "Manejo",
				hygiene: "Higiene",
				other: "Outro",
			},
			operationTypes: {
				VACCINATION: "Vacinação",
				TREATMENT: "Tratamento",
				DISEASE: "Doença",
				MORTALITY: "Mortalidade",
				FEEDING_PLAN: "Plano alimentar",
				SUPPLEMENTATION: "Suplementação",
				GRAZING_ROTATION: "Mudança de piquete",
				WEANING: "Desmame",
				CASTRATION: "Castração",
				DEHORNING: "Descorna",
				IDENTIFICATION: "Identificação",
				HOOF_TRIMMING: "Casqueamento",
				CLEANING: "Limpeza",
				PEST_CONTROL: "Controle de Pragas",
				ARTIFICIAL_INSEMINATION: "Inseminação Artificial",
				SALE: "Venda",
				OTHER: "Outro",
				HEAT_DETECTION: "Detecção de Cio",
				NATURAL_BREEDING: "Monta Natural",
				PREGNANCY_DIAGNOSIS: "Diagnóstico de Gestação",
				ABORTION: "Aborto",
				CALVING: "Parto",
			},
			pregnancyResults: {
				PREGNANT: "Prenhe",
				EMPTY: "Vazia",
				DOUBTFUL: "Duvidosa",
			},
			pregnancyMethods: {
				PALPATION: "Palpação retal",
				ULTRASOUND: "Ultrassom",
				BLOOD_TEST: "Exame de sangue",
			},
			feedTypes: {
				HAY: "Feno",
				SILAGE: "Silagem",
				GRAIN: "Grão",
				CONCENTRATE: "Concentrado",
				MINERAL: "Mineral",
				PASTURE: "Pasto",
				OTHER: "Outro",
			},
			severities: {
				mild: "Leve",
				moderate: "Moderada",
				severe: "Grave",
				critical: "Crítica",
			},
			createSuccess: "Manejo registrado com sucesso",
			createError: "Não foi possível registrar o manejo",
			updateSuccess: "Manejo atualizado com sucesso",
			updateError: "Não foi possível atualizar o manejo",
			deleteSuccess: "Manejo excluído com sucesso",
			deleteError: "Não foi possível excluir o manejo",
			filters: {
				fromDate: "De",
				toDate: "Até",
				animal: "Animal",
				type: "Tipo",
				clear: "Limpar Filtros",
				allAnimals: "Todos os Animais",
				allTypes: "Todos os Tipos",
			},
			view: {
				timeline: "Linha do Tempo",
				table: "Tabela",
			},
			table: {
				animalOrHerd: "Animal / Lote",
				type: "Tipo",
				date: "Data",
				description: "Descrição",
				performedBy: "Responsável",
				paddock: "Piquete",
				cost: "Custo",
			},
			details: {
				edit: "Editar manejo",
				delete: "Excluir manejo",
				confirmDelete: "Tem certeza de que deseja excluir este manejo?",
			},
		},
		measurements: {
			page: {
				title: "Medições",
				empty: "Nenhuma medição registrada ainda",
			},
			list: {
				empty: "Nenhuma medição registrada ainda",
			},
			create: {
				title: "Registrar Medição",
			},
			types: {
				WEIGHT: "Peso",
				BODY_CONDITION_SCORE: "Escore de Condição Corporal",
				HIP_HEIGHT: "Altura de Garupa",
				SCROTAL_CIRCUMFERENCE: "Circunferência Escrotal",
				BODY_TEMPERATURE: "Temperatura Corporal",
				PREGNANCY_CHECK: "Diagnóstico de Gestação",
				CALVING: "Parto",
				BLOOD_EXAM: "Exame de Sangue",
				GENERAL_EXAMINATION: "Exame Geral",
			},
			fields: {
				target: "Alvo",
				type: "Tipo de Medição",
				date: "Data",
				value: "Valor",
				weightKg: "Peso (kg)",
				bcsScore: "Escore (1-9)",
				heightCm: "Altura (cm)",
				circumferenceCm: "Circunferência (cm)",
				temperatureC: "Temperatura (°C)",
				daysPregnant: "Dias de Gestação",
				calfBirthWeightKg: "Peso do Bezerro ao Nascer (kg)",
				examType: "Tipo de Exame",
				description: "Descrição",
				expectedCalvingDate: "Data Prevista do Parto",
			},
			helpers: {
				bcsScale: "1 = Emaciado, 5 = Moderado, 9 = Obeso",
			},
			placeholders: {
				weightKg: "ex.: 450",
				bcsScore: "ex.: 5",
				heightCm: "ex.: 140",
				circumferenceCm: "ex.: 35",
				temperatureC: "ex.: 38,5",
				daysPregnant: "ex.: 90",
				calfBirthWeightKg: "ex.: 30",
				examType: "ex. Hemograma, Bioquímica",
				description: "Descreva o exame ou resultados...",
				expectedCalvingDate: "Selecione a data prevista do parto",
			},
			saveAndAddAnother: "Salvar e Adicionar Outro",
			batchAdded_one: "{{count}} medição registrada nesta sessão",
			batchAdded_other: "{{count}} medições registradas nesta sessão",
			table: {
				animalOrHerd: "Animal / Lote",
				type: "Tipo",
				value: "Valor",
				date: "Data",
				description: "Descrição",
			},
			stats: {
				totalMeasurements: "Total de Medições",
				avgWeight: "Peso Médio",
				typesRecorded: "Tipos Registrados",
			},
			filters: {
				fromDate: "De",
				toDate: "Até",
				animal: "Animal",
				type: "Tipo",
				clear: "Limpar Filtros",
				allAnimals: "Todos os Animais",
				allTypes: "Todos os Tipos",
			},
			view: {
				timeline: "Linha do Tempo",
				table: "Tabela",
			},
			details: {
				title: "Detalhes da Medição",
				edit: "Editar Medição",
				delete: "Excluir Medição",
				confirmDelete: "Tem certeza que deseja excluir esta medição?",
			},
			createSuccess: "Medição registrada com sucesso",
			createError: "Falha ao registrar medição",
			updateSuccess: "Medição atualizada com sucesso",
			deleteSuccess: "Medição excluída com sucesso",
			addNotes: "Adicionar Observações",
		},
		timeline: {
			animals: "Animais",
			performedBy: "Realizado por",
			paddock: "Piquete",
			cost: "Custo",
			expectedCalvingDate: "Parto previsto",
			fromHerd: "De",
			toHerd: "Para",
		},
		movements: {
			types: {
				HERD_TRANSFER: "Transferência de lote",
			},
			herdTransferFromTo: "Movido de {{from}} para {{to}}",
			herdTransferTo: "Movido para {{to}}",
			herdTransferFrom: "Removido de {{from}}",
		},
		calving: {
			title: "Registrar Parto",
			submit: "Registrar Parto",
			createSuccess: "Parto registrado com sucesso",
			calfSection: "Bezerro(a)",
			calfSectionHint:
				"O bezerro é criado como novo animal nascido na fazenda, com mãe e pai preenchidos automaticamente.",
			fields: {
				dam: "Matriz (vaca)",
				calvingDate: "Data do Parto",
				stillborn: "Natimorto",
				complications: "Complicações",
				calfSex: "Sexo do Bezerro",
				birthWeight: "Peso ao Nascer (kg)",
				calfTag: "Brinco do Bezerro (opcional)",
			},
			placeholders: {
				calfSex: "Selecione o sexo",
				calfTag: "ex., BR-1024",
				complications: "ex., Distocia, parto assistido",
			},
			helpers: {
				calfTag:
					"Sem brinco agora? Um brinco provisório PEND-… é gerado e o bezerro fica marcado como pendente de brinco.",
			},
		},
		registries: {
			tab: "Registros",
			tabWithCount: "Registros ({{count}})",
			empty: "Nenhum registro ainda",
			// Linha derivada (não é um registro): abre a linha do tempo de um
			// animal recém-cadastrado no seu próprio começo, em vez de um vazio.
			registered: {
				badge: "Cadastro",
				title: "Animal cadastrado",
			},
			firstUse: {
				title: "Nenhum registro ainda",
				body: "Pesagens, vacinas, tratamentos e mudanças de lote deste animal ficam aqui.",
				primary: "Registrar primeira pesagem",
				secondary: "Registrar outra coisa",
			},
			loadMore: "Carregar mais",
			page: {
				title: "Registros",
				empty: "Nenhum registro ainda",
			},
			view: {
				timeline: "Linha do tempo",
				table: "Tabela",
			},
			table: {
				date: "Data",
				kind: "Tipo",
				animalOrHerd: "Animal / Lote",
				type: "Registro",
				detail: "Detalhe",
			},
			kind: {
				all: "Tudo",
				operation: "Operações",
				measurement: "Medições",
				movement: "Movimentação",
			},
			filters: {
				clear: "Limpar",
				period: "Período",
				presets: {
					last12: "Últimos 12 meses",
					last24: "Últimos 24 meses",
					all: "Todo o período",
					last12Short: "12 m",
					last24Short: "24 m",
					allShort: "Tudo",
				},
			},
			export: {
				button: "Exportar CSV",
				empty: "Nenhum registro no período",
				error: "Falha ao exportar registros",
			},
			batch: {
				mean: "Média",
			},
			register: {
				button: "Registro",
				title: "Novo registro",
				search: "Buscar tipo…",
				recents: "Recentes",
				empty: "Nenhum tipo encontrado",
			},
			capture: {
				recordAnotherPrompt: "Registro salvo. Registrar outro?",
				recordAnother: "Registrar outro",
			},
		},
		weight: {
			title: "Peso",
			averageWeight: "Peso Médio",
			kgUnit: "kg",
			measurementCount: "Medições",
		},
	},
	financial: {
		nav: {
			title: "Financeiro",
			hubTitle: "Gestão financeira",
			overview: "Visão financeira",
			transactions: "Movimentações",
			vendors: "Fornecedores",
			reports: "Relatórios",
			loans: "Financiamentos",
			recurring: "Lançamentos recorrentes",
			receivables: "Contas a receber",
			payables: "Contas a pagar",
			payroll: "Folha de pagamento",
		},
		vendors: {
			title: "Fornecedores",
			placeholder: "Selecionar fornecedor",
			searchPlaceholder: "Buscar por nome ou documento",
			noResults: "Nenhum fornecedor encontrado",
			createNew: "+ Criar fornecedor",
			createNamed: '+ Criar "{{name}}"',
			clear: "Limpar seleção",
			nameLabel: "Nome",
			namePlaceholder: "Nome do fornecedor",
			documentLabel: "CNPJ/CPF",
			documentPlaceholder: "Documento (opcional)",
			phoneLabel: "Telefone",
			emailLabel: "E-mail",
			defaultCategoryLabel: "Categoria padrão",
			noDefaultCategory: "Sem categoria padrão",
			notesLabel: "Observações",
			createSubmit: "Criar",
			createTitle: "Novo fornecedor",
			editTitle: "Editar fornecedor",
			formSubtitle: "Fornecedores são compartilhados entre todas as fazendas.",
			confirmDelete: "Confirmar remoção?",
			createSuccess: "Fornecedor criado",
			updateSuccess: "Fornecedor atualizado",
			deleteSuccess: "Fornecedor removido",
			newVendor: "Novo fornecedor",
			newVendorShort: "Fornecedor",
			removedBadge: "Removido",
			summary: {
				totalSpend: "Gasto total no período",
				supplierCount: "Fornecedores com gasto",
			},
			empty: {
				title: "Nenhum fornecedor ainda",
				description:
					"Cadastre fornecedores ou vincule-os aos lançamentos para ver o gasto por fornecedor.",
			},
			columns: {
				vendor: "Fornecedor",
				defaultCategory: "Categoria padrão",
				transactions: "Lançamentos",
				spend: "Gasto",
			},
		},
		kinds: {
			REVENUE: "Receita",
			DIRECT_COST: "Custo direto",
			OVERHEAD: "Despesa fixa",
			CAPITAL: "Capital",
			FINANCING: "Financiamento",
		},
		directions: {
			IN: "Entrada",
			OUT: "Saída",
		},
		reviewStates: {
			UNREVIEWED: "A revisar",
			REVIEWED: "Revisado",
		},
		entryOrigins: {
			AUTO: "Automático",
			MANUAL: "Manual",
		},
		sourceModules: {
			livestock: "Rebanho",
			grass: "Pastagem",
			equipment: "Equipamentos",
			manual: "Lançamento manual",
		},
		periods: {
			thisMonth: "Este mês",
			lastMonth: "Mês passado",
			last3Months: "Últimos 3 meses",
			last6Months: "Últimos 6 meses",
			last12Months: "Últimos 12 meses",
			thisYear: "Este ano",
			safraCurrent: "Safra atual",
			safraPrevious: "Safra anterior",
		},
		overview: {
			title: "Visão financeira",
			subtitle: "Acompanhe entradas, saídas e resultado por período",
			moneyIn: "Entradas",
			moneyOut: "Saídas",
			net: "Resultado",
			monthlyChart: {
				title: "Entradas e saídas por mês",
				in: "Entradas",
				out: "Saídas",
			},
			categoryBreakdown: {
				title: "Despesas por categoria",
				empty: "Nenhuma despesa no período",
				totalOut: "total de saídas",
				other: "Outras",
			},
			reviewCta: {
				title: "Registros a revisar",
				description_one: "{{count}} registro automático aguardando revisão",
				description_other: "{{count}} registros automáticos aguardando revisão",
				cta: "Revisar agora",
			},
			kpi: {
				new: "novo",
				vsPreviousPeriod: "vs. período anterior",
				incomeSub_one: "{{count}} categoria de entrada",
				incomeSub_other: "{{count}} categorias de entrada",
				expenseSub_one: "{{count}} categoria de saída",
				expenseSub_other: "{{count}} categorias de saída",
			},
			attention: {
				title_one: "{{count}} item precisa da sua atenção",
				title_other: "{{count}} itens precisam da sua atenção",
				reviewMeta: "Importados de lançamentos de campo",
				pricesTitle: "Preços de referência desatualizados",
				pricesMeta: "O resultado de produção pode ficar impreciso",
				pricesCta: "Atualizar",
				openingBalanceTitle: "Saldo inicial não definido",
				openingBalanceMeta: "Necessário para o saldo acumulado",
			},
			receivables: {
				open: "Em aberto",
				overdue_one: "Vencido · {{count}}",
				overdue_other: "Vencidos · {{count}}",
			},
			quickLinks: {
				view: "Ver",
			},
			recent: {
				title: "Movimentações recentes",
				viewAll: "Ver todas",
				seeAll: "Ver todas →",
				toReview: "A revisar",
				empty: "Nenhuma movimentação no período",
			},
			orgLevelFootnote_one:
				"+ {{count}} registro geral da organização (visível em Todas as fazendas)",
			orgLevelFootnote_other:
				"+ {{count}} registros gerais da organização (visíveis em Todas as fazendas)",
			setup: {
				openingBalance:
					"Saldo inicial não definido — defina para ver o saldo acumulado e o fluxo projetado.",
				openingBalanceCta: "Definir saldo inicial",
				referencePrices:
					"Preços de referência do rebanho ausentes ou desatualizados — o resultado de produção pode ficar impreciso.",
				referencePricesCta: "Atualizar preços de referência",
			},
		},
		receiptImport: {
			pageTitle: "Escanear comprovante",
			eyebrow: "Financeiro",
			pageSubtitle:
				"Envie a nota do jeito que ela chegou. Nada é lançado até você confirmar.",
			action: "Escanear nota",
			actionShort: "Nota",
			steps: {
				upload: "Enviar",
				extract: "Extrair",
				review: "Revisar",
			},
			upload: {
				title: "Envie a nota ou comprovante",
				helper:
					"Tire uma foto ou selecione um PDF. Vamos ler o valor, a data e o fornecedor automaticamente.",
				dropTitle: "Solte a nota aqui",
				dropTypes: "PDF · JPEG · PNG · WebP",
				chooseFile: "Escolher arquivo",
				takePhoto: "Tirar foto",
				removeFile: "Remover",
				fileMetaPhoto: "{{size}} · foto",
				fileMetaPdf: "{{size}} · PDF",
				submit: "Enviar e ler",
				unsupportedType: "Formato não suportado. Use PDF, JPG, PNG ou WebP.",
				limitsLine: "Um documento por lançamento, até {{max}}.",
			},
			extracting: {
				title: "Lendo a nota…",
				helper: "Isso costuma levar alguns segundos.",
				failedTitle: "Não foi possível ler a nota",
				failedHelper:
					"Tente novamente ou preencha o lançamento manualmente — o documento continua anexado.",
				retry: "Tentar de novo",
				enterManually: "Preencher manualmente",
			},
			review: {
				title: "Confira os dados",
				helper:
					"Revise e corrija o que for preciso antes de confirmar. O lançamento entra como não revisado.",
				matchingVendor: "Procurando fornecedor pelo CNPJ/CPF…",
				vendorMatched: "Fornecedor encontrado: {{name}}",
				categoryHint: "Sugestão da IA: {{label}}",
			},
		},
		transactions: {
			title: "Movimentações",
			new: "Novo lançamento",
			newShort: "Lançar",
			empty: {
				title: "Nenhuma movimentação",
				description:
					"Lançamentos automáticos aparecem aqui conforme você registra operações, ou adicione um lançamento manual.",
			},
			columns: {
				date: "Data",
				description: "Descrição",
				category: "Categoria",
				amount: "Valor",
				source: "Origem",
				review: "Revisão",
				status: "Status",
			},
			filters: {
				search: "Buscar movimentações...",
				button: "Filtros",
				title: "Filtrar movimentações",
				kind: "Tipo",
				category: "Categoria",
				sourceModule: "Origem",
				reviewState: "Revisão",
				all: "Todos",
				includeVoided: "Incluir estornados",
				clear: "Limpar filtros",
			},
			detail: {
				title: "Detalhe da movimentação",
				source: "Origem",
				sourceLink: "Ver registro de origem",
				notes: "Observações",
				party: "Cliente ou fornecedor",
				dimensions: "Vínculos",
				noSource: "Lançamento manual (sem registro de origem)",
				readOnlyNotice:
					"Valor e data de registros automáticos são definidos pela origem e não podem ser editados aqui.",
			},
			manualEntry: {
				title: "Novo lançamento manual",
				quickTitle: "Novo lançamento",
				quickSubtitle: "Registre uma saída ou entrada rápida",
				editTitle: "Editar lançamento",
				direction: "Tipo",
				income: "Entrada (receita)",
				expense: "Saída (despesa)",
				amount: "Valor",
				eventDate: "Data",
				category: "Categoria",
				categoryKind: "Grupo da categoria",
				establishment: "Fazenda",
				allFarms: "Organização (todas as fazendas)",
				party: "Cliente ou fornecedor",
				partyPlaceholder: "Nome do cliente ou fornecedor",
				notes: "Observações",
				dimensionsToggle: "Vínculos (opcional)",
				duplicateLast: "Duplicar último lançamento",
			},
			attachments: {
				title: "Comprovantes",
				empty: "Nenhum comprovante anexado.",
				attach: "Anexar comprovante",
				uploadTitle: "Anexar comprovante",
				indicator: "Tem comprovante anexado",
				fieldLabel: "Comprovante (opcional)",
				fieldHelper: "Anexe a nota ou o comprovante. Foto ou PDF, até 10 MB.",
				chooseFile: "Anexar foto ou PDF",
				uploadFailed:
					"Lançamento salvo, mas o comprovante não foi enviado. Anexe pelo detalhe.",
			},
			dimensions: {
				herd: "Lote",
				animal: "Animal",
				paddock: "Pasto",
				equipment: "Equipamento",
				task: "Tarefa",
			},
			review: {
				markReviewed: "Marcar como revisado",
				changeCategory: "Alterar categoria",
				bulkReview: "Revisar selecionados",
				bulkCategorize: "Categorizar e revisar",
				bulkCategoryPlaceholder: "Escolher categoria",
				selected_one: "{{count}} selecionado",
				selected_other: "{{count}} selecionados",
				reviewSuccess: "Revisão salva",
				needsReview: "A revisar",
			},
			delete: {
				title: "Excluir lançamento",
				confirm: "Excluir este lançamento manual?",
			},
		},
		loans: {
			title: "Financiamentos",
			new: "Novo financiamento",
			newShort: "Financiamento",
			editTerms: "Editar condições",
			empty: {
				title: "Nenhum financiamento",
				description:
					"Cadastre um financiamento para acompanhar parcelas, juros e saldo devedor.",
			},
			filters: {
				status: "Status",
				all: "Todos",
			},
			columns: {
				lender: "Credor",
				principal: "Principal",
				amortization: "Amortização",
				installments: "Parcelas",
				firstPayment: "Primeira parcela",
				status: "Status",
			},
			statuses: {
				ACTIVE: "Ativo",
				SETTLED: "Quitado",
				CANCELED: "Cancelado",
			},
			amortizations: {
				SAC: "SAC",
				PRICE: "PRICE",
				MANUAL: "Manual",
			},
			frequencies: {
				MONTHLY: "Mensal",
				ANNUAL: "Anual",
				CUSTOM: "Personalizada",
			},
			installmentStatuses: {
				SCHEDULED: "A pagar",
				PAID: "Paga",
			},
			form: {
				newTitle: "Novo financiamento",
				lender: "Credor",
				lenderPlaceholder: "Banco, cooperativa...",
				description: "Descrição",
				principal: "Valor principal",
				ratePrecision:
					"Informe um percentual de 0 a 99999,99 com até duas casas decimais.",
				graceInvalid:
					"A carência deve ser um número inteiro de zero até menos que o número de parcelas.",
				paymentBeforeDisbursement:
					"O vencimento deve ser igual ou posterior à data de liberação.",
				interestRateAnnual: "Juros ao ano (%)",
				amortization: "Sistema de amortização",
				frequency: "Frequência",
				customIntervalMonths: "Intervalo (meses)",
				disbursementDate: "Data de liberação",
				firstPaymentDate: "Data da 1ª parcela",
				installmentsCount: "Número de parcelas",
				graceMonths: "Carência (meses)",
				establishment: "Fazenda",
				allFarms: "Organização (todas as fazendas)",
				notes: "Observações",
				equipment: "Equipamento (opcional)",
				equipmentNone: "Nenhum",
				manualSchedule: {
					title: "Cronograma manual",
					hint: "Cole as parcelas: a soma do principal deve igualar o valor principal.",
					addRow: "Adicionar parcela",
					removeRow: "Remover parcela",
					dueDate: "Vencimento",
					principal: "Principal",
					interest: "Juros",
					sumLabel: "Soma do principal",
					empty: "Adicione ao menos uma parcela ao cronograma manual.",
					incomplete: "Preencha vencimento, principal e juros de cada parcela.",
					ascending:
						"As datas de vencimento devem estar em ordem crescente — ajuste a parcela {{n}}.",
					ascendingRow:
						"O vencimento deve ser posterior ao da parcela anterior.",
					sumMismatch:
						"A soma do principal das parcelas ({{sum}}) precisa ser igual ao valor principal do financiamento ({{principal}}).",
					sumInvalid:
						"A soma do principal das parcelas precisa ser igual ao valor principal do financiamento.",
				},
			},
			schedule: {
				title: "Cronograma de parcelas",
				dueDate: "Vencimento",
				principal: "Principal",
				interest: "Juros",
				total: "Total",
				remainingBalance: "Saldo devedor",
			},
			pay: {
				action: "Pagar",
				title: "Pagar parcela {{seq}}",
				description:
					"Registre o pagamento desta parcela. Principal e juros podem ser ajustados.",
				paidDate: "Data do pagamento",
				paidPrincipal: "Principal pago",
				paidInterest: "Juros pagos",
				confirm: "Confirmar pagamento",
				success: "Parcela paga",
			},
			unpay: {
				action: "Desfazer",
				title: "Desfazer pagamento",
				confirm:
					"Reverter o pagamento desta parcela? Os lançamentos financeiros serão estornados.",
				success: "Pagamento revertido",
			},
			settle: {
				action: "Quitar",
				title: "Quitar financiamento",
				confirm:
					"Quitar antecipadamente? As parcelas em aberto serão encerradas.",
				success: "Financiamento quitado",
			},
			cancel: {
				action: "Cancelar",
				title: "Cancelar financiamento",
				confirm:
					"Cancelar este financiamento? A liberação será estornada. Só é possível quando nenhuma parcela foi paga.",
				success: "Financiamento cancelado",
			},
		},
		receivables: {
			title: "Contas a receber",
			subtitle: "Vendas a prazo e recebimentos de compradores",
			viewSale: "Ver venda",
			buyerDocument: "Documento",
			saleDate: "Data da venda",
			dueDate: "Vencimento",
			expected: "Valor esperado",
			received: "Recebido",
			outstanding: "Em aberto",
			notes: "Observações",
			empty: {
				title: "Nenhuma conta a receber",
				description:
					"Marque uma venda como a prazo para acompanhar recebimentos e vencimentos.",
			},
			summary: {
				totalOutstanding: "Total a receber",
				overdueCount: "Vencidas",
				overdueAmount: "Valor vencido",
			},
			columns: {
				buyer: "Comprador",
				saleDate: "Data da venda",
				dueDate: "Vencimento",
				expected: "Esperado",
				received: "Recebido",
				outstanding: "Em aberto",
				status: "Status",
			},
			displayStatuses: {
				OPEN: "Em aberto",
				PARTIAL: "Parcial",
				SETTLED: "Quitado",
				OVERDUE: "Em atraso",
				VOID: "Anulado",
			},
			overview: {
				summary: "{{outstanding}} em aberto · {{overdue}} em atraso",
			},
			void: {
				title: "Venda estornada",
				description:
					"A venda associada foi revertida. Esta conta a receber está anulada.",
			},
			flag: {
				action: "Marcar como a prazo",
				title: "Marcar venda como a prazo",
				description:
					"Registre esta venda como conta a receber. Ajuste o valor esperado e defina um vencimento, se quiser.",
				expectedAmount: "Valor esperado",
				dueDate: "Vencimento (opcional)",
				confirm: "Marcar como a prazo",
				success: "Venda marcada como a prazo",
			},
			delete: {
				action: "Remover marcação a prazo",
				title: "Remover conta a receber",
				confirm:
					"Remover a marcação a prazo desta venda? Os recebimentos registrados serão estornados.",
				success: "Marcação a prazo removida",
			},
			saleBlock: {
				title: "A receber",
				viewReceivable: "Ver conta a receber",
				notFlagged: "Esta venda ainda não foi marcada como a prazo.",
				canceled:
					"Esta venda foi cancelada e não pode ser marcada como a prazo.",
			},
			receipts: {
				empty: "Nenhum recebimento registrado",
				columns: {
					date: "Data",
					amount: "Valor",
					notes: "Observações",
				},
				add: {
					action: "Registrar recebimento",
					title: "Registrar recebimento",
					description: "Registre um valor recebido do comprador.",
					amount: "Valor",
					receivedDate: "Data do recebimento",
					notes: "Observações",
					confirm: "Registrar",
					success: "Recebimento registrado",
				},
				delete: {
					action: "Excluir",
					title: "Excluir recebimento",
					confirm:
						"Excluir este recebimento? O lançamento financeiro será estornado.",
					success: "Recebimento excluído",
				},
			},
		},
		payables: {
			title: "Contas a pagar",
			issueDate: "Data de emissão",
			total: "Valor total",
			paid: "Pago",
			outstanding: "Em aberto",
			notes: "Observações",
			empty: {
				title: "Nenhuma conta a pagar",
				description:
					"Registre uma conta de fornecedor para acompanhar parcelas e vencimentos.",
			},
			summary: {
				totalOutstanding: "Total a pagar",
				overdueCount: "Vencidas",
				overdueAmount: "Valor vencido",
			},
			columns: {
				vendor: "Fornecedor",
				issueDate: "Emissão",
				nextDueDate: "Próx. vencimento",
				total: "Total",
				paid: "Pago",
				outstanding: "Em aberto",
				status: "Status",
			},
			displayStatuses: {
				OPEN: "Em aberto",
				PARTIAL: "Parcial",
				SETTLED: "Quitado",
				OVERDUE: "Em atraso",
				VOID: "Anulado",
			},
			overview: {
				summary: "{{outstanding}} em aberto · {{overdue}} em atraso",
			},
			void: {
				action: "Anular conta",
				title: "Anular conta a pagar",
				description:
					"Esta conta foi anulada. O lançamento financeiro foi estornado e as parcelas removidas.",
				confirm:
					"Anular esta conta? O lançamento financeiro será estornado e as parcelas removidas.",
				success: "Conta anulada",
			},
			form: {
				newAction: "Nova conta",
				newActionShort: "Conta",
				newTitle: "Nova conta a pagar",
				vendor: "Fornecedor",
				issueDate: "Data de emissão",
				description: "Descrição",
				descriptionPlaceholder: "Ex.: Ração 3x boleto",
				installments: "Parcelas",
				addInstallment: "Adicionar parcela",
				dueDate: "Vencimento",
				amount: "Valor",
				total: "Total",
				notes: "Observações",
				submit: "Registrar conta",
				success: "Conta registrada",
			},
			installments: {
				columns: {
					seq: "Parcela",
					dueDate: "Vencimento",
					amount: "Valor",
					outstanding: "Em aberto",
					status: "Status",
				},
				statuses: {
					OPEN: "Em aberto",
					PARTIAL: "Parcial",
					SETTLED: "Quitada",
					OVERDUE: "Em atraso",
				},
			},
			payments: {
				empty: "Nenhum pagamento registrado",
				columns: {
					date: "Data",
					installment: "Parcela",
					amount: "Valor",
					notes: "Observações",
				},
				add: {
					action: "Registrar pagamento",
					title: "Registrar pagamento",
					description: "Registre um valor pago ao fornecedor.",
					amount: "Valor",
					paidDate: "Data do pagamento",
					notes: "Observações",
					confirm: "Registrar",
					success: "Pagamento registrado",
				},
				delete: {
					action: "Excluir",
					title: "Excluir pagamento",
					confirm: "Excluir este pagamento?",
					success: "Pagamento excluído",
				},
			},
		},
		recurring: {
			title: "Lançamentos recorrentes",
			new: "Novo modelo",
			newShort: "Modelo",
			variableAmount: "Variável",
			filters: {
				all: "Todos",
				activeOnly: "Somente ativos",
			},
			empty: {
				title: "Nenhum modelo recorrente",
				description:
					"Crie um modelo para projetar contas fixas, assinaturas e recebimentos recorrentes.",
			},
			templates: {
				title: "Modelos",
			},
			columns: {
				description: "Descrição",
				direction: "Tipo",
				frequency: "Frequência",
				amountDefault: "Valor padrão",
				status: "Status",
			},
			frequencies: {
				MONTHLY: "Mensal",
				QUARTERLY: "Trimestral",
				SEMIANNUAL: "Semestral",
				ANNUAL: "Anual",
				CUSTOM: "Personalizada",
			},
			form: {
				newTitle: "Novo modelo recorrente",
				description: "Descrição",
				descriptionPlaceholder: "Aluguel, energia, mensalidade...",
				direction: "Tipo",
				income: "Entrada (receita)",
				expense: "Saída (despesa)",
				category: "Categoria",
				amountDefault: "Valor padrão",
				amountDefaultHint:
					"Opcional. Deixe em branco para valores variáveis (informados na confirmação).",
				party: "Contraparte",
				partyPlaceholder: "Cliente, fornecedor...",
				establishment: "Fazenda",
				allFarms: "Organização (todas as fazendas)",
				frequency: "Frequência",
				dueDayOfMonth: "Dia de vencimento",
				customIntervalMonths: "Intervalo (meses)",
				startDate: "Início",
				endBeforeStart:
					"A data final deve ser igual ou posterior à data inicial.",
				endDate: "Fim",
				autoPost: "Lançar automaticamente",
				autoPostHint: "Cria o lançamento no vencimento sem confirmação manual.",
				autoPostDisabledHint:
					"Defina um valor padrão para habilitar o lançamento automático.",
				isActive: "Ativo",
				isActiveHint: "Modelos inativos não projetam novas ocorrências.",
			},
			delete: {
				action: "Excluir modelo",
				title: "Excluir modelo recorrente",
				confirm:
					"Excluir este modelo? As ocorrências já confirmadas são mantidas; nenhuma nova será projetada.",
			},
			occurrences: {
				title: "Ocorrências do mês",
				subtitle:
					"Confirme, pule ou desfaça os lançamentos previstos para este mês.",
				empty: "Nenhuma ocorrência prevista para este mês.",
				acted: "Ocorrência atualizada",
				undone: "Ocorrência desfeita",
				columns: {
					dueDate: "Vencimento",
					description: "Descrição",
					amount: "Valor",
					status: "Status",
				},
				statuses: {
					PROJECTED: "Prevista",
					CONFIRMED: "Confirmada",
					SKIPPED: "Pulada",
				},
				confirm: {
					action: "Confirmar",
					title: "Confirmar ocorrência",
					description:
						"Registre esta ocorrência no fluxo financeiro. O valor pode ser ajustado.",
					amount: "Valor",
				},
				skip: {
					action: "Pular",
				},
				undo: {
					action: "Desfazer",
				},
			},
		},
		timeline: {
			title: "Fluxo projetado",
			subtitle: "Entradas e saídas reais e previstas dos próximos meses",
			empty: "Sem dados para projetar",
			noAnchorHint: "Defina o saldo inicial para ver o saldo acumulado.",
			noAnchorCta: "Definir saldo inicial",
			legend: {
				actualIn: "Entradas realizadas",
				projectedIn: "Entradas previstas",
				actualOut: "Saídas realizadas",
				projectedOut: "Saídas previstas",
				runningBalance: "Saldo acumulado",
			},
		},
		openingBalance: {
			title: "Saldo inicial",
			description:
				"Ponto de partida do saldo de caixa. Ancora a linha de saldo acumulado no fluxo projetado.",
			asOfDate: "Data de referência",
			amount: "Valor",
			amountHint: "Pode ser negativo (saldo devedor).",
			notes: "Observações",
		},
		productionResult: {
			title: "Resultado com variação de rebanho",
			operatingResult: "Resultado operacional",
			deltaHerdValue: "Variação do valor do rebanho",
			productionResult: "Resultado com variação de rebanho",
			openHerdValue: "Valor do rebanho (início)",
			closeHerdValue: "Valor do rebanho (fim)",
			deathWriteOffs: "Baixas por morte",
			births: "Nascimentos",
			birthsValue: "{{count}} cabeça — {{value}}",
			birthsValue_other: "{{count}} cabeças — {{value}}",
			contextCaption:
				"Contexto da variação do rebanho — já refletidos no valor de início/fim, não somados de novo ao total.",
			byCategoryTitle: "Rebanho por categoria",
			openCount: "Cabeças (início)",
			closeCount: "Cabeças (fim)",
			openValue: "Valor (início)",
			closeValue: "Valor (fim)",
			pricePerHead: "Preço por cabeça",
			stale: "desatualizado",
			staleNudge:
				"Há preços de referência desatualizados (mais de 120 dias). Atualize-os para uma valoração mais fiel.",
			staleNudgeCta: "Atualizar preços de referência",
			unvaluedUnknown_one:
				"{{count}} animal sem data de nascimento não pôde ser categorizado nem valorado.",
			unvaluedUnknown_other:
				"{{count}} animais sem data de nascimento não puderam ser categorizados nem valorados.",
			unpriced:
				"Sem preço de referência para: {{categories}}. Defina um preço para incluir estas categorias na valoração.",
			label: "preços de referência (automáticos ou informados por você)",
			empty: "Nenhum dado no período",
			basis: {
				reference: "Referência",
				market: "Mercado",
			},
			marketQuote: "Cotação de mercado: {{value}}/@",
			marketNoQuote:
				"Nenhuma cotação de mercado registrada — o rebanho não pode ser valorado a mercado.",
			marketNoQuoteCta: "Registrar cotação de mercado",
			arrobasPerHead: "@/cab (padrão)",
		},
		referencePrice: {
			title: "Preço por cabeça",
			category: "Categoria",
			standardArrobas: "@ padrão",
			pricePerHead: "Preço por cabeça",
			validFrom: "Vigente desde",
			notSet: "Não definido",
			stale: "desatualizado",
			edit: "Editar",
			set: "Definir preço",
			save: "Salvar",
			cancel: "Cancelar",
			positiveAmount: "Informe um valor positivo.",
		},
		marketQuote: {
			title: "Cotação do boi gordo (R$/@)",
			perArroba: "por @",
			since: "desde {{date}}",
			stale: "desatualizada",
			empty: "Nenhuma cotação ainda. Informe uma abaixo.",
			edit: "Informar minha cotação",
			cancel: "Cancelar",
			price: "Preço por @ (R$)",
			validFrom: "Vigente desde",
			notes: "Observação",
			notesPlaceholder: "ex.: CEPEA/B3, boi gordo",
			historyTitle: "Histórico da cotação",
		},
		priceOrigin: {
			automatic: "Automático",
			user: "Seu valor",
			sourceLink: "{{label}} — abrir a fonte",
		},
		automaticPrices: {
			hint: {
				PINNED:
					"Quando disponível, estimado a partir da cotação publicada para {{state}} (estado fixado por você): preço por @ × arrobas-padrão de cada categoria. Sua cotação manual por @ não gera preços por cabeça; informe-os por categoria.",
				RESOLVED:
					"Quando disponível, estimado a partir da cotação publicada para {{state}}: preço por @ × arrobas-padrão de cada categoria. Sua cotação manual por @ não gera preços por cabeça; informe-os por categoria.",
				DISABLED:
					"Preços automáticos desligados. Valem apenas os valores que você informar.",
				UNAVAILABLE:
					"Sem cotação publicada para o estado configurado. Valem apenas os valores que você informar.",
			},
			takeover:
				"Seu valor substitui o preço automático até você voltar ao automático.",
			resume: "Voltar ao automático",
			resumeAria: "Voltar ao automático: {{series}}",
			returnsOn: "seu valor volta em {{date}}",
		},
		cattlePrices: {
			title: "Preços do gado",
			description:
				"A cotação publicada do boi gordo para o estado das suas fazendas e o preço por cabeça que ela implica. O que você digitar vale sobre o automático até você devolver.",
		},
		priceBasis: {
			effective: {
				PINNED: "Preço de {{state}}, fixado por você.",
				RESOLVED: "Preço de {{state}}, escolhido pelas suas fazendas.",
				DISABLED:
					"Preços automáticos desligados. Valem apenas os valores que você informar.",
				UNAVAILABLE:
					"Nenhuma origem em vigor. Escolha um estado ou volte ao automático.",
			},
			none: "Ainda sem cotação publicada. Cadastre a localização das suas fazendas para receber uma.",
			since: "desde {{date}}",
			resolvedHint: "Suas fazendas indicam {{state}}.",
			resolvedNone: "Nenhuma fazenda com estado cadastrado.",
			change: "Alterar origem",
			done: "Concluir",
			enabled: "Usar preços automáticos",
			stateLabel: "Estado da cotação",
			statePlaceholder: "Escolha o estado",
			stateAuto: "Pelas suas fazendas",
			groupFarms: "Suas fazendas",
			groupQuoted: "Outros estados com cotação publicada",
			pinnedElsewhere: "Nenhuma fazenda sua fica em {{state}}.",
			scheduled: "{{series}}: seu valor volta em {{date}}",
			marketQuoteSeries: "Cotação do boi gordo",
			historyTitle: "Histórico da origem",
			history: {
				PINNED: "{{state}} · fixado",
				RESOLVED: "{{state}} · pelas fazendas",
				DISABLED: "Desligado",
				UNAVAILABLE: "Indisponível",
			},
		},
		animalCategory: {
			BEZERRO: "Bezerro",
			BEZERRA: "Bezerra",
			GARROTE: "Garrote",
			NOVILHA: "Novilha",
			BOI_MAGRO: "Boi magro",
			BOI_GORDO: "Boi gordo",
			VACA: "Vaca",
			TOURO: "Touro",
		},
		settings: {
			title: "Configurações financeiras",
			categories: {
				title: "Plano de contas",
				description:
					"Renomeie, desative ou adicione categorias. Categorias do sistema não podem ser excluídas.",
				add: "Adicionar categoria",
				label: "Nome",
				kind: "Tipo",
				system: "Sistema",
				newLabelPlaceholder: "Nome da categoria",
				deactivate: "Desativar",
				activate: "Ativar",
				rename: "Renomear",
			},
			mappings: {
				title: "Mapeamento de categorias",
				description:
					"Defina a categoria padrão para cada tipo de registro automático. Afeta apenas registros futuros.",
				sourceModule: "Origem",
				sourceType: "Tipo de registro",
				category: "Categoria",
				empty: "Nenhum mapeamento configurado",
			},
			backfill: {
				title: "Importar histórico",
				description:
					"Gere os lançamentos financeiros que faltam a partir dos registros já cadastrados (compras de animais, operações, vendas, equipamentos e consumo de peças). É idempotente: rodar de novo não duplica nada.",
				analyze: "Analisar histórico",
				import_one: "Importar {{count}} registro",
				import_other: "Importar {{count}} registros",
				importConfirmTitle: "Importar registros históricos?",
				importConfirmBody_one:
					"{{count}} lançamento será criado a partir dos seus registros. Você pode revisar as categorias depois.",
				importConfirmBody_other:
					"{{count}} lançamentos serão criados a partir dos seus registros. Você pode revisar as categorias depois.",
				importConfirmCta: "Importar",
				applied_one: "{{count}} lançamento importado.",
				applied_other: "{{count}} lançamentos importados.",
				upToDate: "Tudo em dia — nenhum registro histórico faltando.",
				done: "Análise concluída",
				source: "Origem",
				scanned: "Encontrados",
				wouldPost: "A importar",
				posted: "Importados",
				sources: {
					livestockAnimals: "Compras de animais",
					livestockOperations: "Operações pecuárias",
					livestockSales: "Vendas de gado",
					grassOperations: "Operações de pastagem",
					equipmentAssets: "Equipamentos",
					partConsumptions: "Consumo de peças",
				},
			},
			verifier: {
				title: "Verificar integridade",
				description:
					"Reconstrói cada lançamento automático a partir da origem e aponta divergências ou vínculos órfãos. Somente leitura — não altera nenhum lançamento.",
				run: "Verificar agora",
				checked_one: "{{count}} registro automático verificado.",
				checked_other: "{{count}} registros automáticos verificados.",
				clean: "Nenhuma divergência encontrada.",
				manualSource: "Manual",
				columns: {
					kind: "Tipo",
					source: "Origem",
					detail: "Detalhe",
				},
				kinds: {
					DRIFT: "Divergência",
					SHOULD_BE_VOID: "Deveria estar anulado",
					MISSING_SOURCE: "Origem removida",
					ORPHANED_DIMENSION: "Vínculo órfão",
				},
			},
		},
		reports: {
			title: "Relatórios",
			tabs: {
				pnl: "Resultado (DRE)",
				cashFlow: "Fluxo de caixa",
				timeline: "Fluxo projetado",
				costCenters: "Centros de custo",
				kpis: "Indicadores (@)",
				productionResult: "Resultado de produção",
			},
			period: {
				start: "Início",
				end: "Fim",
			},
			export: {
				button: "Exportar CSV",
				buttonShort: "Exportar",
				filename: "movimentacoes-financeiras",
			},
			pnl: {
				title: "Demonstração de resultado",
				revenue: "Receita",
				directCost: "Custos diretos",
				grossMargin: "Margem bruta",
				overhead: "Despesas fixas",
				operatingResult: "Resultado operacional",
				capital: "Capital (fora do resultado)",
				financing: "Financiamento (fora do resultado)",
				category: "Categoria",
				amount: "Valor",
				unreviewedHint_one:
					"{{count}} registro a revisar pode alterar estes números",
				unreviewedHint_other:
					"{{count}} registros a revisar podem alterar estes números",
				empty: "Nenhum dado no período",
				current: "Atual",
				comparison: "Comparação",
				delta: "Variação",
			},
			comparison: {
				label: "Comparar com",
				none: "Sem comparação",
				previousPeriod: "Período anterior",
				sameSeasonLastYear: "Mesma safra do ano anterior",
			},
			cashFlow: {
				title: "Fluxo de caixa",
				period: "Período",
				moneyIn: "Entradas",
				moneyOut: "Saídas",
				net: "Líquido",
				empty: "Nenhum movimento de caixa no período",
				basis: {
					event: "Regime de competência",
					cash: "Regime de caixa",
					cashCaveat:
						"Regime de caixa: aplica-se apenas a recebimentos registrados; despesas por data do evento",
				},
			},
			costCenters: {
				title: "Centros de custo",
				subtitle: "Receita, custo direto e margem por dimensão",
				lens: "Agrupar por",
				lensFarm: "Fazenda",
				lensHerd: "Lote",
				lensPaddock: "Pasto",
				lensEquipment: "Equipamento",
				key: "Centro de custo",
				revenue: "Receita",
				directCost: "Custo direto",
				margin: "Margem",
				unattributed: "Não atribuído",
				total: "Total",
				removed: "(removido)",
				empty: "Nenhum dado no período",
				honestyProrated: "custos de lote rateados por cabeça",
				honestyPasture: "custos de pasto não incluídos",
			},
			kpis: {
				empty: "Nenhum dado no período",
				insufficient: "Dados insuficientes",
				recordHint: "Registre {{inputs}} para liberar este indicador",
				carcassYieldNote:
					"@ produzida calculada com rendimento de carcaça de {{percent}}% (15 kg por @).",
				marketQuote: "Mercado: {{value}}/@",
				marketStale: "cotação desatualizada",
				vsMarket: "vs mercado ({{value}}/@)",
				labels: {
					costPerKgGain: "Custo por kg de ganho",
					costPerArroba: "Custo da @ produzida",
					costPerHead: "Custo por cabeça",
					resultPerHectare: "Resultado por hectare",
					marginPerBreedingCow: "Margem por matriz",
					costPerWeanedCalf: "Custo por bezerro desmamado",
					realizedPricePerKg: "Preço realizado por kg",
					realizedPricePerArroba: "Preço realizado por @",
					realizedPricePerHead: "Preço realizado por cabeça",
					breakEvenPricePerKg: "Preço de equilíbrio por kg",
					breakEvenPricePerArroba: "Preço de equilíbrio por @",
				},
				inputs: {
					operatingCost: "Custo operacional",
					operatingResult: "Resultado operacional",
					revenue: "Receita",
					weightGainKg: "Ganho de peso (kg)",
					arrobasProduced: "@ produzidas",
					arrobasSold: "@ vendidas",
					carcassYield: "Rendimento de carcaça",
					averageHeadCount: "Cabeças (média)",
					weanedCalfCount: "Bezerros desmamados",
					breedingFemaleCount: "Matrizes",
					pastureHectares: "Hectares de pasto",
					soldWeightKg: "Peso vendido (kg)",
					soldHeadCount: "Cabeças vendidas",
					basis: "Base",
					"livestock.measurements.weight": "pesagens (mín. 2 por animal)",
					"livestock.operations.weaning": "desmames",
					"livestock.animals": "animais",
					"livestock.animals.breedingFemale": "matrizes",
					"livestock.sales": "vendas",
					"livestock.sales.weight": "pesos de venda",
					"grass.paddocks.area": "áreas de pasto",
				},
			},
		},
		payroll: {
			title: "Folha de pagamento",
			manage: "Gerenciar",
			view: "Ver",
			notAuthorized: {
				title: "Acesso restrito",
				description:
					"Você não tem permissão para acessar a folha de pagamento.",
			},
			employmentTypes: {
				MONTHLY: "Mensalista",
				DAILY: "Diarista",
				CONTRACTOR: "Prestador",
			},
			workers: {
				title: "Funcionários",
				new: "Novo funcionário",
				newShort: "Funcionário",
				newTitle: "Novo funcionário",
				editTitle: "Editar funcionário",
				perDay: "dia",
				active: "Ativo",
				inactive: "Inativo",
				empty: {
					title: "Nenhum funcionário",
					description: "Cadastre funcionários para montar folhas de pagamento.",
				},
				columns: {
					name: "Nome",
					role: "Função",
					employmentType: "Vínculo",
					rate: "Remuneração",
					status: "Situação",
				},
				form: {
					name: "Nome",
					cpf: "CPF",
					role: "Função",
					employmentType: "Tipo de vínculo",
					baseSalary: "Salário base",
					dayRate: "Valor da diária",
					defaultEstablishment: "Fazenda padrão",
					noEstablishment: "Nenhuma (organização)",
					isActive: "Ativo",
					isActiveHint: "Funcionários inativos não aparecem em novas folhas.",
				},
			},
			runs: {
				new: "Nova folha",
				newShort: "Folha",
				newTitle: "Nova folha de pagamento",
				addWorker: "Adicionar funcionário",
				confirmedAt: "Confirmada em",
				empty: {
					title: "Nenhuma folha de pagamento",
					description:
						"Crie uma folha para registrar os pagamentos de uma competência.",
				},
				columns: {
					competency: "Competência",
					label: "Descrição",
					paymentDate: "Data de pagamento",
					status: "Status",
				},
				status: {
					DRAFT: "Rascunho",
					CONFIRMED: "Confirmada",
				},
				form: {
					competency: "Competência",
					paymentDate: "Data de pagamento",
					label: "Descrição",
					labelPlaceholder: "Ex.: Folha de janeiro",
					defaultDaysWorked: "Dias trabalhados padrão (diaristas)",
				},
				grid: {
					worker: "Funcionário",
					daysWorked: "Dias",
					gross: "Bruto",
					encargos: "Encargos",
					net: "Líquido",
					notes: "Observações",
					empty: "Nenhum item. Adicione funcionários a esta folha.",
					total: "Total",
					auto: "Automático",
					save: "Salvar itens",
					grossRequired: "Informe o valor bruto de cada funcionário.",
				},
				confirm: {
					action: "Confirmar",
					title: "Confirmar folha de pagamento",
					description:
						"Ao confirmar, os lançamentos financeiros serão gerados e a folha não poderá mais ser editada. Deseja continuar?",
					success: "Folha confirmada",
				},
				revert: {
					action: "Reverter",
					title: "Reverter folha de pagamento",
					description:
						"Ao reverter, os lançamentos gerados serão estornados e a folha voltará para rascunho. Deseja continuar?",
					success: "Folha revertida",
				},
			},
			labor: {
				title: "Relatório de mão de obra",
				from: "De",
				to: "Até",
				empty: "Nenhum dado de mão de obra no período.",
				byWorker: "Por funcionário",
				byFarm: "Por fazenda",
				farm: "Fazenda",
				orgLevel: "Organização",
			},
		},
	},
	equipment: {
		nav: {
			title: "Equipamentos",
		},
		tabs: {
			dashboard: "Painel",
			fleet: "Frota",
			parts: "Peças",
			schedule: "Cronograma",
			inspections: "Inspeções",
			details: "Detalhes",
		},
		status: {
			ACTIVE: "Ativo",
			UNDER_REPAIR: "Em manutenção",
			IDLE: "Parado",
			RETIRED: "Desativado",
		},
		categories: {
			POWER_UNIT: "Trator e máquina motriz",
			HARVESTER: "Colheitadeira",
			PLANTER: "Plantadeira",
			SPRAYER: "Pulverizador",
			TILLAGE: "Implemento de preparo do solo",
			TRAILER: "Reboque / Carreta",
			LOADER: "Carregadeira",
			UTILITY_VEHICLE: "Veículo Utilitário",
			IRRIGATION: "Irrigação",
			OTHER: "Outro",
		},
		fuelTypes: {
			DIESEL: "Diesel",
			GASOLINE: "Gasolina",
			ELECTRIC: "Elétrico",
			HYBRID: "Híbrido",
			OTHER: "Outro",
		},
		ownershipTypes: {
			OWNED: "Próprio",
			LEASED: "Arrendado",
			RENTED: "Alugado",
			SHARED: "Compartilhado",
		},
		dashboard: {
			addEquipment: "Cadastrar equipamento",
			addPart: "Cadastrar peça",
			reportBreakdown: "Informar quebra ou defeito",
			totalActiveAssets: "Equipamentos em operação",
			fleetUptime: "Disponibilidade das máquinas",
			pmCompliance: "Preventivas em dia",
			openTasks: "Serviços em aberto",
			maintenanceDue: "Manutenção programada",
			noMaintenanceDue: "Nenhuma manutenção programada para hoje",
			activeTasks: "Serviços em andamento",
			noActiveTasks: "Nenhum serviço em andamento",
			unassigned: "Não atribuído",
			emptyTitle: "Nenhum equipamento cadastrado",
			emptyDescription:
				"Cadastre a primeira máquina ou equipamento da fazenda.",
		},
		fleet: {
			assetId: "Código do Ativo",
			name: "Nome",
			category: "Categoria",
			makeModel: "Marca/Modelo",
			make: "Marca",
			model: "Modelo",
			year: "Ano",
			hours: "Horas",
			location: "Localização",
			nextPm: "Próxima preventiva",
			create: {
				title: "Cadastrar equipamento",
			},
			edit: {
				title: "Editar equipamento",
			},
			notFound: "Equipamento não encontrado",
			confirmDelete: "Tem certeza que deseja excluir este equipamento?",
			list: {
				empty: {
					title: "Nenhum equipamento encontrado",
					description: "Adicione seu primeiro equipamento para começar.",
				},
			},
		},
		form: {
			subCategory: "Subcategoria",
			serialNumber: "Número de série",
			fuelType: "Combustível",
			horsepower: "Potência (CV)",
			initialHours: "Horímetro inicial",
			ownershipType: "Propriedade",
			purchaseDate: "Data da compra",
			purchasePrice: "Valor da compra",
			warrantyExpiry: "Fim da garantia",
			dealer: "Concessionária",
			pmIntervalHours: "Preventiva a cada (horas)",
			pmIntervalDays: "Preventiva a cada (dias)",
			pmTemplateName: "Plano de manutenção preventiva",
			noEstablishments: "Nenhuma fazenda cadastrada",
			placeholders: {
				name: "ex. Trator Principal",
				subCategory: "ex. Cultivo em Linha",
				serialNumber: "ex. 1LV6120MKRR000001",
				dealer: "ex. Concessionária Regional",
				pmTemplateName: "Ex.: Revisão de 250 horas",
				notes: "Observações sobre o equipamento...",
			},
			sections: {
				identification: {
					title: "Identificação",
					description: "Informações básicas para identificar o equipamento",
				},
				specifications: {
					title: "Especificações",
					description: "Especificações técnicas e capacidades",
				},
				ownership: {
					title: "Propriedade e Localização",
					description: "Detalhes de propriedade e localização atual",
				},
				maintenance: {
					title: "Manutenção preventiva",
					description: "Periodicidade e plano das revisões preventivas",
				},
			},
		},
		detail: {
			totalTasks: "Total de Tarefas",
			inspections: "Inspeções",
			lastInspection: "Última Inspeção",
			totalMaintenanceCost: "Custo Total de Manutenção",
		},
		parts: {
			partNumber: "Código da Peça",
			name: "Nome",
			category: "Categoria",
			quantity: "Quantidade",
			minimumStock: "Estoque Mín.",
			unitCost: "Custo Unitário",
			unitOfMeasure: "Unidade",
			location: "Local de Armazenamento",
			establishment: "Fazenda",
			central: "Estoque central",
			oemPartNumbers: "Números OEM",
			adjustStock: "Ajustar Estoque",
			adjustQuantity: "Alteração de Quantidade",
			adjustQuantityPlaceholder: "ex. 5 ou -3",
			adjustQuantityHelp:
				"Use números positivos para adicionar, negativos para remover.",
			adjustReason: "Motivo",
			adjustReasonPlaceholder: "ex. Reposição do fornecedor",
			stockMovements: "Movimentações de Estoque",
			noMovements: "Nenhuma movimentação de estoque registrada.",
			lowStockAlert: "Estoque baixo! Atual: {{current}}, Mínimo: {{minimum}}",
			notFound: "Peça não encontrada",
			confirmDelete: "Tem certeza que deseja excluir esta peça?",
			create: {
				title: "Adicionar Peça",
			},
			edit: {
				title: "Editar Peça",
			},
			list: {
				empty: {
					title: "Nenhuma peça encontrada",
					description: "Adicione sua primeira peça para controlar o estoque.",
				},
			},
			summary: {
				totalParts: "Total de Peças",
				lowStock: "Estoque Baixo",
				inventoryValue: "Valor do Estoque",
			},
			form: {
				placeholders: {
					name: "ex. Filtro de Óleo",
					category: "ex. Filtros",
					oemPartNumbers: "ex. RE504836, P550779",
					unitOfMeasure: "ex. unidade, litro, kg",
					location: "ex. Galpão A, Prateleira 3",
				},
				sections: {
					identification: {
						title: "Identificação",
						description: "Identificação e informações de catálogo",
					},
					stock: {
						title: "Gestão de Estoque",
						description: "Níveis de estoque e preços",
					},
					compatibility: {
						title: "Compatibilidade e Armazenamento",
						description:
							"Compatibilidade com equipamentos e local de armazenamento",
					},
				},
			},
		},
		inspection: {
			title: "Inspeção antes do uso",
			startInspection: "Iniciar inspeção",
			hourMeter: "Leitura do Horímetro",
			result: "Resultado",
			submittedBy: "Enviado Por",
			submit: "Enviar Inspeção",
			pass: "Aprovado",
			defects: "Defeitos: {{count}}",
			criticalDefects: "Defeitos críticos: {{count}}",
			defectsFound: "defeitos encontrados",
			unsafeToOperate: "INSEGURO PARA OPERAR — Defeito crítico detectado",
			defectNotesPlaceholder: "Descreva o defeito...",
			severity: {
				LOW: "Baixa",
				MEDIUM: "Média",
				HIGH: "Alta",
				CRITICAL: "Crítica",
			},
			list: {
				empty: "Nenhuma inspeção registrada.",
			},
		},
		breakdown: {
			title: "Informar quebra ou defeito",
			reportBreakdown: "Informar problema",
			reportDetail: "Detalhes do problema",
			selectEquipment: "Equipamento",
			selectEquipmentPlaceholder: "Selecione o equipamento...",
			severity: "Severidade",
			description: "Descrição",
			descriptionPlaceholder: "Descreva o que aconteceu...",
			locationOnMachine: "Local na Máquina",
			submit: "Registrar problema",
			equipment: "Equipamento",
			linkedTask: "Tarefa Vinculada",
			reportedBy: "Reportado Por",
			notFound: "Relatório não encontrado",
			severityOptions: {
				CRITICAL: "Crítica",
				HIGH: "Alta",
				MEDIUM: "Média",
				LOW: "Baixa",
			},
			locations: {
				ENGINE: "Motor",
				TRANSMISSION: "Transmissão",
				HYDRAULICS: "Hidráulica",
				ELECTRICAL: "Elétrica",
				TIRES_WHEELS: "Pneus/Rodas",
				BODY_FRAME: "Carroceria/Chassi",
				IMPLEMENT: "Implemento",
				OTHER: "Outro",
			},
		},
		schedule: {
			equipment: "Equipamento",
			type: "Tipo",
			dueDate: "Data Prevista",
			noPmScheduled: "Sem preventiva programada",
			overdue: "Atrasada",
			dueToday: "Vence hoje",
			dueSoon: "Vence em {{days}} dias",
			dueThisWeek: "vence esta semana",
			upcoming: "próximas",
			statuses: {
				OVERDUE: "Atrasada",
				DUE: "Pendente",
				UPCOMING: "Próxima",
			},
			empty: {
				title: "Nenhuma manutenção programada",
				description:
					"As próximas manutenções aparecerão aqui quando a periodicidade da preventiva for informada nos equipamentos.",
			},
		},
	},
	marketplace: {
		nav: {
			title: "Compra e venda",
		},
		browse: {
			title: "Compra e venda de animais",
			myOffers: "Minhas ofertas",
			incomingRequests: "Solicitações recebidas",
			myRequests: "Minhas solicitações",
			loading: "Carregando ofertas…",
			empty:
				"Nenhuma oferta publicada no momento. Volte mais tarde ou publique a sua.",
			subtitle: "Compre e venda animais em toda a rede",
			search: "Buscar ofertas, raças, vendedores…",
			resultsCount: "{{count}} oferta encontrada",
			resultsCount_other: "{{count}} ofertas encontradas",
			filters: "Filtros",
			category: "Tipo de oferta",
			allKinds: "Todos os tipos",
			productionCategory: "Categoria",
			allCategories: "Todas as categorias",
			state: "Estado",
			allStates: "Todos os estados",
			sex: "Sexo",
			allSexes: "Qualquer sexo",
			priceRange: "Faixa de preço",
			animalCount: "Número de animais",
			weightRange: "Peso médio (kg)",
			ageRange: "Idade (meses)",
			health: "Certificações",
			allHealth: "Qualquer certificação",
			healthSelected: "{{count}} certificação",
			healthSelected_other: "{{count}} certificações",
			breed: "Raça",
			allBreeds: "Todas as raças",
			breedsSelected: "{{count}} raça selecionada",
			breedsSelected_other: "{{count}} raças selecionadas",
			min: "Mín",
			max: "Máx",
			sort: "Ordenar por",
			sortRelevant: "Mais relevantes",
			sortRecent: "Mais recentes",
			sortPriceAsc: "Menor preço",
			sortPriceDesc: "Maior preço",
			viewGrid: "Visualização em grade",
			viewList: "Visualização em lista",
			contact: "Falar",
			save: "Salvar",
			clearFilters: "Limpar filtros",
			noResults: "Nenhuma oferta corresponde aos filtros.",
			newBadge: "Novo",
		},
		offerCategory: {
			FEEDER: "Recria/engorda",
			BREEDING_FEMALE: "Matriz",
			BREEDING_BULL: "Reprodutor",
			SLAUGHTER: "Abate",
			CALF_WEANER: "Bezerro/desmama",
			CULL: "Descarte",
			DAIRY: "Leiteiro",
			OTHER: "Outro",
		},
		healthFlag: {
			FMD_VACCINATED: "Vacinado contra febre aftosa",
			BRUCELLOSIS_VACCINATED: "Vacinado contra brucelose",
			BRUCELLOSIS_TESTED: "Testado para brucelose",
			TUBERCULOSIS_TESTED: "Testado para tuberculose",
			GTA_READY: "GTA disponível",
		},
		sex: {
			MALE: "Macho",
			FEMALE: "Fêmea",
			MIXED: "Misto",
		},
		kind: {
			WHOLE_HERD: "Rebanho",
			ANIMALS: "Animais",
		},
		headCount: "{{n}} cabeças",
		offer: {
			notFound: "Oferta não encontrada.",
			back: "Compra e venda",
			requestToBuy: "Solicitar compra",
			close: "Fechar",
			animals: "Animais ({{n}})",
		},
		detail: {
			about: "Sobre a oferta",
			details: "Detalhes",
			attrType: "Tipo de oferta",
			attrHeadCount: "Cabeças",
			attrPricing: "Modelo de preço",
			attrTotalWeight: "Peso total",
			attrUnitPrice: "Preço unitário",
			attrPublished: "Publicado em",
			attrExpires: "Disponível até",
			noDescription: "O vendedor não adicionou uma descrição para esta oferta.",
			seller: "Vendedor",
			verifiedSeller: "Vendedor cadastrado",
			memberInfo: "Anunciado na RuralOps",
			whyTitle: "Sobre comprar aqui",
			whyTracked: "Animais identificados individualmente pelo brinco",
			whySnapshot:
				"A composição do lote fica registrada no momento da publicação",
			whyTransfer: "Transferência feita dentro da plataforma",
			safetyTitle: "Dicas de segurança",
			safetyBody:
				"Inspecione os animais e confira a documentação antes de enviar qualquer pagamento.",
			share: "Compartilhar",
			weightUnit: "{{n}} kg",
			contactSeller: "Falar com o vendedor",
			contactHint:
				"Os dados de contato do vendedor estão na descrição da oferta.",
		},
		request: {
			title: "Solicitar compra",
			destinationFarm: "Fazenda de destino",
			selectFarm: "Selecione uma fazenda…",
			destinationHerd: "Lote de destino (opcional)",
			noSpecificHerd: "Deixar sem lote",
			message: "Mensagem (opcional)",
			send: "Enviar solicitação",
		},
		myOffers: {
			title: "Minhas ofertas",
			back: "Voltar à compra e venda",
			create: "Criar anúncio de animais",
			empty:
				"Você ainda não tem anúncios. Crie um anúncio para começar a vender seus animais.",
			publish: "Publicar",
			resync: "Ressincronizar",
			requests: "Solicitações",
			subtitle:
				"Gerencie seus anúncios e acompanhe o interesse dos compradores",
			allStatuses: "Todas",
			expiresIn: "Expira em {{n}}d",
			expired: "Expirada",
			emptyTitle: "Nenhuma oferta ainda",
			emptyHint:
				"Crie um anúncio para oferecer seus animais aos compradores da rede.",
			emptyCta: "Criar primeira oferta",
			edit: "Editar",
		},
		createOffer: {
			title: "Novo anúncio de animais",
			herd: "Lote",
			selectHerd: "Selecione um lote…",
			titleLabel: "Título",
			titlePlaceholder: "ex. 40 garrotes Nelore",
			pricingModel: "Modelo de preço",
			unitPrice: "Preço unitário",
			category: "Categoria",
			selectCategory: "Selecione uma categoria…",
			state: "Estado",
			selectState: "Selecione um estado…",
			healthFlags: "Certificações",
			submit: "Criar rascunho",
			step1: "Detalhes",
			step2: "Fotos",
			photos: "Fotos",
			photosHelper:
				"Adicione fotos para os compradores verem os animais. JPEG, PNG ou WebP, até 10 MB cada.",
			addPhoto: "Adicionar foto",
			noPhotos: "Nenhuma foto adicionada ainda.",
			draftSaved: "Rascunho salvo. Adicione fotos e publique sua oferta.",
			publishNow: "Publicar oferta",
			saveDraft: "Salvar como rascunho",
			removePhoto: "Remover foto",
			subtitle: "Anuncie seus animais para compradores da rede",
			sectionBasics: "Lote e título",
			sectionPricing: "Preço",
			sectionClassification: "Classificação",
			continue: "Continuar para fotos",
			previewTitle: "Pré-visualização",
			previewHint: "É assim que os compradores verão seu anúncio",
			previewEmptyTitle: "Título da sua oferta",
			cover: "Capa",
			dropzoneTitle: "Arraste fotos aqui ou clique para enviar",
			dropzoneHint: "JPEG, PNG ou WebP · até 10 MB · máx. {{max}} fotos",
			photoCount: "{{n}}/{{max}} fotos",
			stepHintDetails: "Conte aos compradores o que você vende",
			stepHintPhotos: "Fotos vendem — adicione boas imagens",
			editTitle: "Editar oferta",
			editSubtitle: "Atualize os detalhes do seu anúncio",
			description: "Descrição",
			descriptionPlaceholder:
				"Adicione detalhes que os compradores devem saber…",
			descriptionHint:
				"Inclua seus dados de contato (telefone, WhatsApp, e-mail) para os compradores falarem diretamente com você.",
			save: "Salvar alterações",
			herdLocked:
				"O lote e os animais não podem ser alterados aqui. Use Ressincronizar para atualizar o anúncio.",
			herdInOffer: "já anunciado",
			viewOffer: "Ver oferta",
			notFound: "Oferta não encontrada.",
		},
		incoming: {
			title: "Solicitações recebidas",
			offer: "Oferta",
			selectOffer: "Selecione uma das suas ofertas…",
			loading: "Carregando solicitações…",
			empty: "Nenhuma solicitação nesta oferta ainda.",
			accept: "Aceitar…",
			reject: "Recusar",
			confirmIntro:
				"Isto transfere os animais ({{n}}) para {{buyer}}. A transferência não pode ser desfeita.",
			confirmHint: "Digite o nome da organização compradora para confirmar.",
			confirmTransfer: "Confirmar transferência",
			subtitle: "Aceite ou recuse as solicitações de compra dos seus animais",
			pickTitle: "Selecione uma oferta para começar",
			pickHint:
				"Escolha uma das suas ofertas acima para ver os compradores interessados.",
			emptyTitle: "Nenhuma solicitação ainda",
			emptyHint:
				"Quando um comprador solicitar esta oferta, ela aparecerá aqui para você aceitar ou recusar.",
			noOffersTitle: "Você ainda não tem ofertas",
			noOffersHint:
				"Publique uma oferta e as solicitações de compra aparecerão aqui.",
			noOffersCta: "Ir para minhas ofertas",
			all: "Todas",
			pending: "Pendentes: {{n}}",
			requested: "Solicitado em {{date}}",
			expiresIn: "Expira em {{n}}d",
		},
		myRequests: {
			title: "Minhas solicitações de compra",
			empty: "Você ainda não solicitou a compra de nenhuma oferta.",
			requestLabel: "Solicitação {{id}}",
		},
		status: "Status: {{status}}",
		offerStatus: {
			DRAFT: "Rascunho",
			PUBLISHED: "Publicada",
			RESERVED: "Reservada",
			SOLD: "Vendida",
			CANCELLED: "Cancelada",
			EXPIRED: "Expirada",
		},
		requestStatus: {
			PENDING: "Pendente",
			ACCEPTED: "Aceita",
			REJECTED: "Recusada",
			CANCELLED: "Cancelada",
			EXPIRED: "Expirada",
		},
	},
	media: {
		upload: {
			button: "Enviar imagem",
			title: "Enviar imagem",
			helper: "JPEG, PNG ou WebP. Máximo de 10 MB.",
			chooseFile: "Escolher arquivo",
			noFileChosen: "Nenhum arquivo selecionado",
			submit: "Enviar",
			uploading: "Enviando...",
			preparing: "Preparando envio...",
			// Neutral wording: this toast is fired by the shared upload hook, which
			// also serves PDF-capable surfaces (e.g. the soil lab-report import).
			success: "Arquivo enviado com sucesso",
			failed: "Falha no envio. Tente novamente.",
			helperWithPdf: "JPEG, PNG, WebP ou PDF. Máximo de 10 MB.",
			unsupportedTypeWithPdf:
				"Tipo de arquivo não suportado. Use JPEG, PNG, WebP ou PDF.",
			tooLarge: "Arquivo muito grande. Tamanho máximo: 10 MB.",
			unsupportedType: "Tipo de arquivo não suportado. Use JPEG, PNG ou WebP.",
			validation: {
				fileRequired: "Selecione um arquivo para enviar.",
			},
			analysisReasons: {
				title: "Análise por IA (opcional)",
				empty:
					"Nenhuma análise selecionada — o arquivo será apenas armazenado.",
				counter: "{{count}}/{{max}} selecionadas",
				capReached: "Máximo de {{max}} análises por envio",
				labels: {
					ANIMAL_BODY_CONDITION_SCORE: "Escore de condição corporal",
					ANIMAL_LAMENESS_CHECK: "Verificação de claudicação",
					ANIMAL_HEALTH_INDICATORS: "Indicadores de saúde",
					ANIMAL_BREED_IDENTIFICATION: "Identificação de raça",
					PADDOCK_PASTURE_QUALITY: "Qualidade da pastagem",
					PADDOCK_WEED_DETECTION: "Detecção de plantas daninhas",
					PADDOCK_FENCE_CONDITION: "Condição da cerca",
					PADDOCK_COVERAGE_ESTIMATION: "Estimativa de cobertura",
					EQUIPMENT_WEAR_CHECK: "Verificação de desgaste",
					EQUIPMENT_DAMAGE_DETECTION: "Detecção de danos",
					EQUIPMENT_MAINTENANCE_INDICATORS: "Indicadores de manutenção",
					SOIL_LAB_REPORT_EXTRACTION: "Extração de laudo de solo",
					TRANSACTION_RECEIPT_EXTRACTION: "Extração de nota/comprovante",
					ANIMAL_LIST_IMPORT_EXTRACTION: "Importação de lista de animais",
				},
				descriptions: {
					ANIMAL_BODY_CONDITION_SCORE:
						"Estima o escore de condição corporal do animal a partir da imagem.",
					ANIMAL_LAMENESS_CHECK:
						"Aponta sinais visíveis de claudicação ou problemas de locomoção.",
					ANIMAL_HEALTH_INDICATORS:
						"Identifica indicadores visíveis de saúde (pelagem, olhos, postura).",
					ANIMAL_BREED_IDENTIFICATION:
						"Identifica a raça ou o cruzamento mais provável.",
					PADDOCK_PASTURE_QUALITY:
						"Avalia a qualidade, a densidade e a coloração da pastagem.",
					PADDOCK_WEED_DETECTION:
						"Detecta a presença de plantas daninhas visíveis no piquete.",
					PADDOCK_FENCE_CONDITION:
						"Avalia a condição visível das cercas na imagem.",
					PADDOCK_COVERAGE_ESTIMATION:
						"Estima o percentual de cobertura do solo.",
					EQUIPMENT_WEAR_CHECK: "Detecta desgaste visível no equipamento.",
					EQUIPMENT_DAMAGE_DETECTION: "Detecta danos visíveis no equipamento.",
					EQUIPMENT_MAINTENANCE_INDICATORS:
						"Aponta indícios visíveis de que a manutenção é necessária.",
					SOIL_LAB_REPORT_EXTRACTION:
						"Extrai os resultados da análise de solo de um laudo laboratorial (PDF ou foto), um registro por amostra.",
					TRANSACTION_RECEIPT_EXTRACTION:
						"Extrai valor, data, emitente e categoria sugerida de uma nota ou comprovante (PDF ou foto) para preencher o lançamento.",
					ANIMAL_LIST_IMPORT_EXTRACTION:
						"Transcreve um bloco da lista do rebanho (planilha, PDF ou foto) em fichas de animais para você revisar antes de importar.",
				},
			},
		},
		gallery: {
			title: "Imagens",
			empty: "Nenhuma imagem ainda.",
			emptyWithHint:
				"Nenhuma imagem ainda. Fotos ajudam a identificar o animal e a acompanhar o escore corporal.",
			loadError: "Falha ao carregar imagens.",
			uploadedBy: "por {{name}}",
			unknownUploader: "Desconhecido",
		},
		viewer: {
			openImage: "Abrir {{name}}",
			viewLabel: "Visualizar",
			imageIdLabel: "ID da imagem",
			copyId: "Copiar ID da imagem",
			idCopied: "ID da imagem copiado",
			idCopyFailed: "Não foi possível copiar o ID",
			analysesTitle: "Análises por IA",
			analysesSubtitle_one: "{{count}} análise vinculada",
			analysesSubtitle_other: "{{count}} análises vinculadas",
			analysesSubtitle: "{{count}} análises vinculadas",
			noAnalyses: "Esta imagem ainda não tem análises",
			noAnalysesHelper:
				"Adicione uma análise por IA para obter informações desta foto.",
		},
		analyses: {
			statuses: {
				PENDING: "Na fila",
				IN_PROGRESS: "Analisando",
				COMPLETED: "Concluída",
				FAILED: "Falhou",
			},
			modal: {
				pendingTitle: "Na fila para análise",
				pendingBody: "Esta análise ainda não começou.",
				inProgressTitle: "Análise em andamento",
				inProgressBody: "O resultado aparecerá aqui assim que estiver pronto.",
				errorTitle: "Análise falhou",
				emptyResult: "Nenhum resultado retornado.",
				attemptCount: "Tentativa {{count}}",
				close: "Fechar",
			},
			add: {
				button: "Adicionar análise",
				title: "Adicionar análise por IA",
				helper:
					"Selecione uma ou mais análises para executar nesta imagem. As execuções acontecem em segundo plano.",
				pickerTitle: "Análises adicionais",
				submit: "Executar análises",
				submitting: "Iniciando…",
				successToast: "Análises enfileiradas",
				errorToast: "Falha ao enfileirar análises",
				capReached: "Todas as análises já foram anexadas a esta imagem.",
				validation: {
					selectReason: "Selecione ao menos uma análise.",
				},
			},
			retry: {
				button: "Tentar novamente",
				submitting: "Tentando novamente…",
				successToast: "Análise reenfileirada",
				errorToast: "Falha ao tentar novamente",
				notRetriable: "Esta análise não pode ser reexecutada agora.",
				availableIn: "Reenvio disponível em {{minutes}} min",
			},
		},
	},
	theme: {
		select: "Selecionar tema",
		light: "Claro",
		dark: "Escuro",
	},
	planning: {
		tasks: {
			status: {
				pending: "Pendente",
				approved: "Aprovada",
				scheduled: "Agendada",
				in_progress: "Em Andamento",
				completed: "Concluída",
				cancelled: "Cancelada",
			},
			priority: {
				critical: "Crítica",
				high: "Alta",
				medium: "Média",
				low: "Baixa",
			},
			voice: {
				play: "Ouvir tarefa",
				stop: "Parar áudio",
				error: "Áudio indisponível",
				// DEVE corresponder à frase do servidor (voiceTemplates) para que o
				// texto do fallback Web Speech seja idêntico ao texto sintetizado.
				scheduleClause: "Agendado para {{date}}",
			},
			kanbanView: "Visualização Kanban",
			kanbanDescription: "Organize tarefas por status com arrastar e soltar",
			listView: "Visualização Lista",
			calendarView: "Visualização Calendário",
			selectEstablishment: "Selecionar Fazenda",
			selectEstablishmentPrompt:
				"Selecione uma fazenda para visualizar tarefas",
			markComplete: "Marcar como Concluída",
			completeQueued:
				"Conclusão salva — será sincronizada quando você voltar a ficar online.",
			recordPrompt:
				"Tarefa concluída. Registrar {{type}} nos registros do rebanho?",
			recordPromptAction: "Registrar",
			count: "{{count}} tarefa",
			count_other: "{{count}} tarefas",
			create: "Criar Tarefa",
			quickAdd: "Adição Rápida de Tarefa",
			quickAddDescription: "Adicione uma nova tarefa rapidamente",
			emptyInScope: "Nenhuma tarefa aqui ainda",
			form: {
				title: "Título",
				titlePlaceholder: "Digite o título da tarefa...",
				description: "Descrição",
				descriptionPlaceholder: "Descreva o que precisa ser feito...",
				scheduledDate: "Data Agendada",
				estimatedDuration: "Duração Estimada (min)",
				priority: "Prioridade",
			},
			detail: {
				scheduledDate: "Data Prevista",
				dueDate: "Prazo",
				priority: "Prioridade",
				duration: "Duração",
				establishment: "Fazenda",
				assignedTo: "Responsável",
				createdBy: "Criada por",
				approvedBy: "Aprovada por",
				domain: "Módulo",
				objective: "Objetivo",
				completedAt: "Concluída em {{date}}",
				completedBy: "por {{name}}",
			},
		},
		assignee: {
			unassigned: "Sem responsável",
		},
		comments: {
			title: "Comentários",
			empty: "Nenhum comentário ainda",
			placeholder: "Escreva um comentário...",
			post: "Comentar",
			added: "Comentário adicionado",
		},
		panel: {
			details: "Detalhes",
			addDescription: "Adicione uma descrição…",
			subObjective: "Subobjetivo",
			breadcrumb: {
				objective: "Objetivo",
				subObjective: "Subobjetivo",
				task: "Tarefa",
			},
		},
		subObjectives: {
			label: "Subobjetivo (opcional)",
			none: "Nenhum — vincular diretamente ao objetivo",
			title: "Subobjetivos",
			create: "Criar subobjetivo",
			editTitle: "Editar subobjetivo",
			empty: "Nenhum subobjetivo ainda",
		},
		createMenu: {
			title: "Criar",
			description: "O que você quer criar?",
			objective: "Objetivo",
			subObjective: "Subobjetivo",
			task: "Tarefa",
			needsObjective: "Crie um objetivo primeiro",
			parentTitle: "Selecione o objetivo",
			parentDescription: "Um subobjetivo pertence a um objetivo",
		},
		hierarchy: {
			title: "Objetivos",
			allTasks: "Todas as tarefas",
			showAll: "Mostrar tudo",
			newObjective: "Novo objetivo",
			addSubObjective: "Adicionar subobjetivo",
			addTask: "Adicionar tarefa aqui",
			empty: "Nenhum objetivo ainda",
			emptyDescription:
				"Objetivos agrupam seus subobjetivos e tarefas. Crie um para começar.",
			browse: "Navegar objetivos",
			deleteObjectiveTitle: "Excluir objetivo?",
			deleteObjectiveDescription:
				'Excluir "{{name}}"? Seus subobjetivos e tarefas também podem ser removidos. Isso não pode ser desfeito.',
			deleteSubObjectiveTitle: "Excluir subobjetivo?",
			deleteSubObjectiveDescription:
				'Excluir "{{name}}"? Suas tarefas também podem ser removidas. Isso não pode ser desfeito.',
		},
		objectives: {
			createSuccess: "Objetivo criado com sucesso",
			tacticalCount: "{{count}} objetivo tático",
			tacticalCount_other: "{{count}} objetivos táticos",
			annual: {
				createSuccess: "Objetivo anual criado com sucesso",
				createError: "Falha ao criar objetivo anual",
				updateSuccess: "Objetivo anual atualizado com sucesso",
				updateError: "Falha ao atualizar objetivo anual",
				deleteSuccess: "Objetivo anual excluído com sucesso",
				deleteError: "Falha ao excluir objetivo anual",
			},
			tactical: {
				createSuccess: "Objetivo tático criado com sucesso",
				createError: "Falha ao criar objetivo tático",
				updateSuccess: "Objetivo tático atualizado com sucesso",
				updateError: "Falha ao atualizar objetivo tático",
				deleteSuccess: "Objetivo tático excluído com sucesso",
				deleteError: "Falha ao excluir objetivo tático",
			},
		},
	},
	mcp: {
		nav: {
			title: "MCP",
		},
		page: {
			eyebrow: "Configurações",
			title: "MCP",
			subtitle:
				"Conecte qualquer agente de IA — como Claude, ChatGPT ou Cursor — aos dados e à operação da sua fazenda.",
			intro:
				"O MCP é um endereço que você conecta ao assistente de IA que já utiliza. Depois do login, ele pode consultar seus animais e lotes, contar o rebanho e registrar manejos, sempre respeitando as mesmas permissões de acesso da sua conta RuralOps.",
		},
		url: {
			label: "Endereço para colar no assistente",
			copy: "Copiar",
			copied: "Copiado",
			copyFailed: "Não foi possível copiar",
			addToCursor: "Adicionar no Cursor",
		},
		connect: {
			title: "Como conectar",
			after:
				"Depois do login, cada usuário continua com as mesmas permissões de acesso da sua conta. O assistente respeita essas permissões e só acessa as informações que aquele usuário já está autorizado a visualizar.",
			copyConfig: "Configuração do Cursor",
			claude: {
				name: "Claude",
				pathSettings: "Configurações",
				pathConnectors: "Conectores",
				pathAddConnector: "Adicionar conector personalizado",
				step1: {
					title: "Copie o endereço do RuralOps",
					description:
						"Você vai colar este endereço no Claude no próximo passo.",
				},
				step2: {
					title: "Adicione como conector personalizado",
					description: "No Claude Desktop ou no claude.ai, abra:",
				},
				step3: {
					title: "Conecte e faça login",
					description:
						"Clique em Conectar, entre no RuralOps e aprove o que o assistente pode ver.",
				},
			},
			cursor: {
				name: "Cursor",
				pathSettings: "Configurações",
				pathTools: "Tools & MCP",
				pathNewServer: "New MCP Server",
				step1: {
					title: "Copie o endereço do RuralOps",
					description: "Você vai colar este endereço no Cursor.",
				},
				step2: {
					title: "Adicione um novo servidor MCP",
					description: "No Cursor, abra as configurações e cole o endereço:",
				},
				step3: {
					title: "Faça login e comece",
					description:
						"O Cursor abre a tela de login do RuralOps. Aprove o acesso e pronto.",
				},
			},
			chatgpt: {
				name: "ChatGPT",
				step1: {
					title: "Copie o endereço do RuralOps",
					description: "Você vai colar este endereço no ChatGPT.",
				},
				step2: {
					title: "Adicione em Conectores",
					description:
						"Nas configurações do ChatGPT, abra Conectores (modo de desenvolvedor) e adicione o endereço como servidor MCP remoto.",
				},
				step3: {
					title: "Faça login e comece",
					description:
						"Entre no RuralOps quando o ChatGPT abrir a tela de login.",
				},
			},
			claudeCode: {
				name: "Claude Code",
				step1: {
					title: "Copie o comando",
					description: "Você vai rodar este comando no terminal.",
				},
				step2: {
					title: "Rode no terminal",
					description:
						"Ele adiciona o RuralOps como servidor MCP HTTP no Claude Code.",
				},
				step3: {
					title: "Faça login",
					description:
						"Rode /mcp, escolha ruralops e conclua o login no navegador.",
				},
			},
			grok: {
				name: "Grok Bot",
				step1: {
					title: "Copie o endereço do RuralOps",
					description: "Você vai colar este endereço no Grok Bot.",
				},
				step2: {
					title: "Adicione como servidor MCP",
					description:
						"No Grok Bot, abra as configurações de MCP e adicione o endereço como servidor remoto.",
				},
				step3: {
					title: "Faça login e comece",
					description:
						"Entre no RuralOps quando o Grok Bot abrir a tela de login.",
				},
			},
		},
		features: {
			title: "O que um agente conectado pode fazer",
			farms:
				"Listar as organizações e fazendas das quais você faz parte (nomes e ids).",
			counts:
				"Contar animais por fazenda — totais, status, sexo do rebanho vivo e quantos estão fora de lote.",
			animals:
				"Listar lotes e animais, inclusive os que ainda não estão em lote, e abrir o detalhe de um animal.",
			records:
				"Ler os registros de manejo (vacinação, tratamento, desmama, troca de pasto e os outros tipos que você já lança no app).",
			write:
				"Registrar um manejo em um lote ou animal, depois que o assistente pedir a sua confirmação. As mesmas regras de permissão de quem toca o botão no app.",
		},
		limits: {
			title: "O que ele não faz",
			otherDomains:
				"Não lê nem altera financeiro, equipe, cobrança ou o marketplace.",
			noCost:
				"Não coloca custo em um registro de manejo. Custo lança no livro-caixa, e isso continua sendo feito no app.",
			noDelete: "Não apaga nada, nunca.",
			noSignup:
				"Não cria uma conta RuralOps. Você precisa já ter entrado no app pelo menos uma vez.",
			noPush:
				"Não envia atualizações sozinho. O assistente pergunta; o RuralOps responde.",
		},
	},
	proposals: {
		nav: {
			title: "Ações Pendentes",
		},
		page: {
			title: "Ações Pendentes",
			subtitle: "Revise e aprove as alterações sugeridas pelo assistente",
			noAccess: "Você não tem permissão para revisar propostas da IA.",
			emptyTitle: "Nada para revisar",
			emptyDescription: "Nenhuma proposta corresponde a este filtro.",
			// A caixa vazia no filtro padrão é uma conquista, não um beco sem saída.
			emptyInboxTitle: "Tudo revisado",
			emptyInboxDescription:
				"Quando o assistente sugerir uma alteração, ela aparece aqui.",
			reassurance:
				"Nada foi gravado ainda. O assistente só sugere. A alteração entra na sua fazenda quando você aprovar.",
			pendingCount_one: "{{count}} aguardando revisão",
			pendingCount_other: "{{count}} aguardando revisão",
			emptyOtherPending_one:
				"Ainda há {{count}} proposta aguardando revisão em outro filtro.",
			emptyOtherPending_other:
				"Ainda há {{count}} propostas aguardando revisão em outro filtro.",
		},
		pager: {
			label: "Páginas de propostas",
			previous: "Anteriores",
			next: "Próximas",
			position: "Página {{page}} de {{total}}",
		},
		explainer: {
			title: "Como funcionam as propostas",
			reversibility:
				"Descartar é reversível: você pode restaurar a alteração quando quiser. Aprovar não é.",
			grouped:
				"Alterações marcadas como “Aplicadas juntas” entram ou saem sempre em conjunto.",
		},
		filter: {
			label: "Filtrar por status",
			all: "Todos os status",
			more: "Mais status",
			less: "Menos status",
		},
		status: {
			PENDING: "Pendente",
			EXECUTED: "Aprovada",
			REJECTED: "Rejeitada",
			EXPIRED: "Expirada",
		},
		origin: {
			CHAT: "Chat",
			ROUTINE: "Rotina",
			ANALYSIS: "Análise",
		},
		actions: {
			livestockMeasurementCreate: "Registrar medição de rebanho",
			livestockMeasurementUpdate: "Atualizar medição de rebanho",
			livestockAnimalCreate: "Cadastrar animal",
			livestockAnimalUpdate: "Atualizar animal",
			planningTaskCreate: "Criar tarefa",
			planningTaskUpdate: "Atualizar tarefa",
			planningTaskComplete: "Concluir tarefa",
			grassPaddockCreate: "Cadastrar piquete",
			grassPaddockUpdate: "Atualizar piquete",
			grassOperationCreate: "Registrar operação de pastagem",
			grassOperationUpdate: "Atualizar operação de pastagem",
			grassMeasurementCreate: "Registrar medição de pastagem",
			grassMeasurementUpdate: "Atualizar medição de pastagem",
			equipmentCreate: "Cadastrar equipamento",
			equipmentUpdate: "Atualizar equipamento",
			equipmentPartCreate: "Cadastrar peça no estoque",
			equipmentPartUpdate: "Atualizar peça",
			soilAnalysisCreate: "Registrar análise de solo",
			soilAnalysisUpdate: "Atualizar análise de solo",
		},
		// Rótulos de campo do payload, indexados pelo NOME do campo (não pelo
		// caminho completo): `notes` significa o mesmo em uma medição e em uma
		// tarefa. Uma chave ausente cai no próprio nome do campo.
		fields: {
			targetId: "Registro",
			changes: "Alterações",
			establishmentId: "Fazenda",
			herdId: "Lote",
			animalId: "Animal",
			tagId: "Brinco",
			electronicId: "Identificação eletrônica",
			registrationNumber: "Número de registro",
			sex: "Sexo",
			birthDate: "Data de nascimento",
			birthWeight: "Peso ao nascer",
			breed: "Raça",
			coatColor: "Pelagem",
			originType: "Origem",
			acquisitionDate: "Data de aquisição",
			acquisitionCost: "Custo de aquisição",
			supplier: "Fornecedor",
			sireId: "Pai",
			damId: "Mãe",
			sireTagId: "Brinco do pai",
			damTagId: "Brinco da mãe",
			hornStatus: "Aspa",
			isCastrated: "Castrado",
			tags: "Etiquetas",
			measurementType: "Tipo de medição",
			measurementDate: "Data da medição",
			numericValue: "Valor",
			unit: "Unidade",
			description: "Descrição",
			expectedCalvingDate: "Data prevista de parto",
			notes: "Observações",
			objectiveId: "Objetivo",
			subObjectiveId: "Subobjetivo",
			title: "Título",
			priority: "Prioridade",
			scheduledDate: "Data programada",
			dueDate: "Prazo",
			// A unidade vive no VALOR (`45 min`), não no rótulo — ver
			// `VALUE_SUFFIX` em payloadFormatting.ts.
			estimatedDurationMin: "Duração estimada",
			actualDurationMin: "Duração real",
			assignedToId: "Responsável",
			domain: "Domínio",
			operationType: "Tipo de operação",
			domainData: "Dados do domínio",
			executionNotes: "Observações de execução",
			paddockId: "Piquete",
			name: "Nome",
			code: "Código",
			areaHa: "Área (ha)",
			boundaryGeoJson: "Limite",
			slope: "Declividade (%)",
			drainage: "Drenagem",
			soilType: "Tipo de solo",
			useType: "Tipo de uso",
			status: "Situação",
			yieldTargetTDMHaYear: "Meta de produção (t MS/ha/ano)",
			cpMinPercent: "Proteína bruta mínima (%)",
			ndfMaxPercent: "FDN máximo (%)",
			utilizationTarget: "Meta de utilização (%)",
			cultivarIds: "Cultivares",
			performedAt: "Realizada em",
			costTotal: "Custo total",
			operationData: "Detalhes da operação",
			animalUnits: "Unidades animais",
			grazingDays: "Dias de pastejo",
			preGrazingHeightCm: "Altura pré-pastejo (cm)",
			postGrazingHeightCm: "Altura pós-pastejo (cm)",
			taskId: "Tarefa",
			measuredAt: "Medida em",
			swardHeightCm: "Altura do pasto (cm)",
			groundCoverPct: "Cobertura do solo (%)",
			biomassKgHa: "Biomassa (kg MS/ha)",
			regrowthDays: "Rebrota (dias)",
			biomassMethod: "Método de biomassa",
			biomassUncertaintyPct: "Incerteza da biomassa (%)",
			crudeProteinPct: "Proteína bruta (%)",
			ndfPct: "FDN (%)",
			adfPct: "FDA (%)",
			digestibilityPct: "Digestibilidade (%)",
			photoUrls: "Fotos",
			gpsLatitude: "Latitude",
			gpsLongitude: "Longitude",
			// Equipamentos (frota)
			locationId: "Fazenda",
			assetId: "Código do bem",
			subCategory: "Subcategoria",
			make: "Fabricante",
			model: "Modelo",
			year: "Ano",
			serialNumber: "Número de série",
			initialHours: "Horímetro inicial",
			fuelType: "Combustível",
			horsepower: "Potência",
			ownershipType: "Posse",
			purchaseDate: "Data da compra",
			purchasePrice: "Valor da compra",
			warrantyExpiry: "Fim da garantia",
			dealer: "Revenda",
			pmIntervalHours: "Intervalo de manutenção (horas)",
			pmIntervalDays: "Intervalo de manutenção (dias)",
			pmTemplateName: "Plano de manutenção",
			assignedOperatorId: "Operador designado",
			// Estoque de peças
			partNumber: "Código da peça",
			oemPartNumbers: "Códigos do fabricante",
			currentQuantity: "Quantidade em estoque",
			minimumStock: "Estoque mínimo",
			unitCost: "Custo unitário",
			location: "Localização no almoxarifado",
			unitOfMeasure: "Unidade de medida",
			// Análise de solo
			sampledAt: "Data da coleta",
			// As duas profundidades são UMA faixa; o par vira a linha `depth`.
			depth: "Profundidade",
			depthTopCm: "Profundidade de",
			depthBottomCm: "Profundidade até",
			labEntradaAt: "Entrada no laboratório",
			labSaidaAt: "Saída do laboratório",
			labName: "Laboratório",
			labReportNumber: "Número do laudo",
			results: "Resultados",
			availableWaterCapacityMm: "Capacidade de água disponível",
			methods: "Métodos de extração",
			context: "Contexto de interpretação",
			interpretationSystem: "Sistema de interpretação",
			labUnitPreset: "Formato de unidades do laboratório",
			soilTypeCode: "Tipo de solo",
			clayActivity: "Atividade da argila",
			raw: "Campos específicos do laboratório",
			phWater: "pH (água)",
			phCaCl2: "pH (CaCl₂)",
			phKCl: "pH (KCl)",
			organicMatter: "Matéria orgânica",
			organicCarbon: "Carbono orgânico",
			phosphorusMehlich: "P (Mehlich)",
			phosphorusResin: "P (resina)",
			phosphorusMehlich3: "P (Mehlich-3)",
			phosphorusRemaining: "P remanescente",
			phosphorusTotal: "P total",
			potassium: "Potássio",
			sodium: "Sódio",
			calcium: "Cálcio",
			magnesium: "Magnésio",
			aluminum: "Alumínio",
			hydrogenAluminum: "H + Al",
			sulfur: "Enxofre",
			boron: "Boro",
			copper: "Cobre",
			iron: "Ferro",
			manganese: "Manganês",
			zinc: "Zinco",
			clay: "Argila",
			silt: "Silte",
			sand: "Areia",
		},
		// Valores de código do payload, indexados pelo NOME do campo e depois pelo
		// código — o mesmo endereçamento de `proposals.fields.*`, para que um novo
		// Action Type que reuse o campo herde as palavras. Um código sem chave cai
		// no valor bruto (o comportamento de hoje), então cobertura parcial é
		// segura. `common` guarda os códigos que significam o mesmo em qualquer
		// campo.
		values: {
			common: {
				ns: "Não solicitado",
			},
			measurementType: {
				WEIGHT: "Peso",
				BODY_CONDITION_SCORE: "Escore de condição corporal",
				HIP_HEIGHT: "Altura de garupa",
				SCROTAL_CIRCUMFERENCE: "Circunferência escrotal",
				BODY_TEMPERATURE: "Temperatura corporal",
				PREGNANCY_CHECK: "Diagnóstico de gestação",
				CALVING: "Parto",
				BLOOD_EXAM: "Exame de sangue",
				GENERAL_EXAMINATION: "Exame geral",
			},
			domain: {
				livestock: "Pecuária",
				grass: "Pastagem",
				general: "Geral",
			},
			// 1 é a MAIS alta (ver PRIORITY_OPTIONS em planning/-components).
			priority: {
				"1": "Crítica",
				"2": "Alta",
				"3": "Média",
				"4": "Baixa",
			},
			status: {
				PENDING: "Pendente",
				APPROVED: "Aprovada",
				SCHEDULED: "Agendada",
				IN_PROGRESS: "Em andamento",
				COMPLETED: "Concluída",
				CANCELLED: "Cancelada",
				ACTIVE: "Ativo",
				SOLD: "Vendido",
				DECEASED: "Morto",
				TRANSFERRED: "Transferido",
				ESTABLISHED: "Estabelecido",
				RENOVATION: "Em renovação",
				DEGRADED: "Degradado",
				REST: "Em descanso",
				DEFERRED: "Diferido",
				UNDER_RECOVERY: "Em recuperação",
				UNDER_REPAIR: "Em reparo",
				IDLE: "Parado",
				RETIRED: "Desativado",
			},
			sex: {
				MALE: "Macho",
				FEMALE: "Fêmea",
			},
			originType: {
				born_on_farm: "Nascido na fazenda",
				purchased: "Comprado",
			},
			hornStatus: {
				HORNED: "Chifrudo",
				POLLED: "Mocho",
				DEHORNED: "Descornado",
				SCURRED: "Chifretes",
			},
			useType: {
				ROTATIONAL_GRAZING: "Pastejo rotacionado",
				CONTINUOUS_GRAZING: "Pastejo contínuo",
				CUT_AND_CARRY: "Corte e transporte",
				HAY: "Produção de feno",
				SILAGE: "Produção de silagem",
				DEFERRED_STOCKPILING: "Diferido/estocagem",
				MIXED: "Uso misto",
			},
			operationType: {
				GRAZING: "Pastejo",
				CUTTING: "Corte",
				MOWING: "Roçada",
				FERTILIZATION: "Adubação",
				LIMING: "Calagem",
				IRRIGATION: "Irrigação",
				WEED_CONTROL: "Controle de plantas daninhas",
				PEST_CONTROL: "Controle de pragas",
				RENOVATION: "Renovação",
				SOIL_PREPARATION: "Preparo do solo",
				VACCINATION: "Vacinação",
				TREATMENT: "Tratamento",
				DISEASE: "Doença",
				MORTALITY: "Morte",
				FEEDING_PLAN: "Plano alimentar",
				SUPPLEMENTATION: "Suplementação",
				GRAZING_ROTATION: "Rotação de pastejo",
				WEANING: "Desmama",
				CASTRATION: "Castração",
				DEHORNING: "Descorna",
				IDENTIFICATION: "Identificação",
				HOOF_TRIMMING: "Casqueamento",
				CLEANING: "Limpeza",
				ARTIFICIAL_INSEMINATION: "Inseminação artificial",
				SALE: "Venda",
				HEAT_DETECTION: "Detecção de cio",
				NATURAL_BREEDING: "Monta natural",
				PREGNANCY_DIAGNOSIS: "Diagnóstico de gestação",
				ABORTION: "Aborto",
				CALVING: "Parto",
				OTHER: "Outro",
			},
			biomassMethod: {
				HEIGHT_DENSITY_EQUATION: "Equação altura-densidade",
				RISING_PLATE_METER: "Prato ascendente",
				VISUAL_ESTIMATE: "Estimativa visual",
				CUT_AND_WEIGH: "Corte e pesagem",
				NIRS_SENSOR: "Sensor NIRS",
				SATELLITE_NDVI: "NDVI por satélite",
			},
			category: {
				POWER_UNIT: "Trator / unidade motriz",
				HARVESTER: "Colheitadeira",
				PLANTER: "Plantadeira",
				SPRAYER: "Pulverizador",
				TILLAGE: "Implemento de preparo",
				TRAILER: "Reboque / carreta",
				LOADER: "Carregadeira",
				UTILITY_VEHICLE: "Veículo utilitário",
				IRRIGATION: "Irrigação",
				OTHER: "Outro",
			},
			fuelType: {
				DIESEL: "Diesel",
				GASOLINE: "Gasolina",
				ELECTRIC: "Elétrico",
				HYBRID: "Híbrido",
				LPG: "GLP",
				NONE: "Sem motor",
			},
			ownershipType: {
				OWNED: "Próprio",
				LEASED: "Arrendado",
				RENTED: "Alugado",
				SHARED: "Compartilhado",
			},
			interpretationSystem: {
				IAC: "IAC (São Paulo)",
				CFSEMG: "CFSEMG (Minas Gerais)",
				EMBRAPA_CERRADO: "Embrapa Cerrado",
			},
		},
		editor: {
			clear: "Limpar",
			undoClear: "Desfazer limpeza",
			cleared: "Será limpo",
			addItem: "Adicionar",
			removeItem: "Remover",
			noneOption: "Nenhum",
			immutable: "Fixo",
			previewOnly: "Somente leitura",
		},
		conflicts: {
			staleVersion:
				"Este cartão mudou desde que você o abriu. Ele foi recarregado — revise novamente antes de aprovar.",
			targetChanged:
				"O registro que esta alteração edita foi modificado por outra pessoa. Confira os valores atuais antes de aprovar.",
			actionDisabled:
				"Este tipo de alteração está desativado no momento. Não é possível aprovar até que um administrador reative.",
			limitExceeded:
				"Seu plano permite {{limit}} para {{feature}}, mas esta ação levaria o total a {{requested}}. Remova uma alteração ou escolha um plano com mais capacidade.",
			executionFailed:
				"Uma alteração não pôde ser aplicada, então nada foi gravado. A alteração com falha está destacada abaixo.",
			groupIndivisible:
				"Estas alterações são aplicadas juntas — descarte o grupo inteiro.",
			lastItem:
				"Esta é a única alteração restante. Rejeite o cartão em vez de descartá-la.",
			expired: "Esta proposta expirou e não pode mais ser aprovada.",
			generic: "Não foi possível concluir. Tente novamente.",
		},
		card: {
			homeTitle: "Propostas da IA",
			homePending_one: "{{count}} proposta aguardando sua revisão",
			homePending_other: "{{count}} propostas aguardando sua revisão",
			summary_one: "{{count}} alteração",
			summary_other: "{{count}} alterações",
			// A frase que abre o cartão: o que aprovar vai fazer, em palavras.
			summarySentence: "O assistente quer {{actions}} em {{farm}}.",
			summarySentenceNoFarm: "O assistente quer {{actions}}.",
			summaryItemSubject: "{{action}} para {{subject}}",
			summaryRepeat: "{{action}} (×{{count}})",
			summaryMore_one: "mais {{count}} alteração",
			summaryMore_other: "mais {{count}} alterações",
			showDetails: "Ver detalhes",
			hideDetails: "Ocultar detalhes",
			statusAnnouncement: "{{status}} · {{summary}}",
			edited: "Editada",
			excluded: "Descartada",
			exclude: "Descartar",
			unexclude: "Restaurar",
			excludeGroup: "Descartar grupo",
			unexcludeGroup: "Restaurar grupo",
			groupTitle: "Aplicadas juntas",
			groupExplanation: "aprovadas ou descartadas em conjunto",
			lastItemHint: "Rejeite o cartão: esta é a única alteração que resta.",
			actionDisabled: "Desativada",
			actionDisabledExplanation:
				"Um administrador desativou este tipo de alteração. É possível descartá-la ou rejeitar o cartão, mas não aprovar.",
			disabledBlocksApproval:
				"Este cartão não pode ser aprovado enquanto contiver uma alteração desativada.",
			missingTargetRevision:
				"Não foi possível ler os valores atuais de um registro que este cartão edita, então ele não pode ser aprovado com segurança. Recarregue a página.",
			// O id em si não diz nada a quem aprova; fingir que diz é pior do que
			// admitir que o registro não pôde ser identificado.
			unresolvedReference: "Registro não identificado",
			currentRecord: "Registro atual",
			originalProposal: "Proposta original",
			reasoning: "Justificativa do assistente",
			executionError: "Não foi possível aplicar: {{error}}",
			rejectionReason: "Motivo: {{reason}}",
			viewRecord: "Ver registro",
			// O rótulo do botão É o contrato: o dedo pousa em um controle que diz o
			// que vai fazer, não em um verbo solto. Vale para os DOIS toques — o
			// último, o que grava, é o que alguém dá sem ler.
			approveWithSummary_one: "Aprovar {{count}} alteração · {{farm}}",
			approveWithSummary_other: "Aprovar {{count}} alterações · {{farm}}",
			approveWithSummaryNoFarm_one: "Aprovar {{count}} alteração",
			approveWithSummaryNoFarm_other: "Aprovar {{count}} alterações",
			approveConfirmTitle: "Aprovar e gravar na fazenda?",
			approveConfirmBody:
				"Estas alterações serão gravadas em {{farm}} agora, nesta ordem. Isso não pode ser desfeito.",
			approveConfirmBodyNoFarm:
				"Estas alterações serão gravadas agora, nesta ordem. Isso não pode ser desfeito.",
			reject: "Rejeitar",
			editTitle: "Editar alteração",
			editDescription:
				"Ajuste os valores antes de aprovar. A proposta original do assistente fica registrada.",
			rejectTitle: "Rejeitar proposta",
			rejectDescription:
				"Opcionalmente, adicione um motivo. Isso não pode ser desfeito.",
			rejectReasonPlaceholder: "Motivo (opcional)",
			rejectReasonLabel: "Motivo",
		},
		toasts: {
			approving: "Aprovando…",
			approveSuccess: "Proposta aprovada e aplicada",
			rejecting: "Rejeitando…",
			rejectSuccess: "Proposta rejeitada",
			excludeSuccess: "Alteração descartada deste cartão",
			unexcludeSuccess: "Alteração restaurada",
		},
	},
	validation: {
		required: "O campo {{field}} é obrigatório",
	},
	help: {
		home: {
			backToApp: "Voltar ao RuralOps",
			searchHint: "Busque nos passos e nas dúvidas desta página.",
			allGuides: "Explorar todos os guias",
		},
		// Shell / navegação
		title: "Ajuda",
		description: "Guias e suporte do RuralOps",
		welcome: "Bem-vindo ao RuralOps",
		welcomeDescription:
			"Tudo o que você precisa para tocar a sua fazenda em um só lugar. Siga os passos abaixo para começar, ou abra o guia do usuário para conhecer cada recurso em detalhe.",
		gettingStarted: "Primeiros Passos",
		gettingStartedDescription: "Configure sua fazenda e aprenda o básico",
		userGuide: "Guia do Usuário",
		userGuideDescription: "Guias detalhados de cada recurso",
		support: "Suporte",
		supportDescription: "Fale com a nossa equipe",
		learnHowToUse: "Aprenda a usar o RuralOps",
		getHelp: "Fale com a nossa equipe",
		gettingStartedSteps: "Comece em 6 passos",

		// Primeiros Passos — tour pelos recursos
		step1Title: "Configure sua fazenda",
		step1Description:
			"Crie seu primeiro estabelecimento (fazenda) em Configurações e informe sua localização e área. Você pode gerenciar várias fazendas em uma única organização.",
		step2Title: "Cadastre seu rebanho",
		step2Description:
			"Registre seus lotes e animais individuais e comece a acompanhar saúde, reprodução e linhagem.",
		step3Title: "Mapeie seus pastos",
		step3Description:
			"Configure a produção de pasto: crie piquetes, registre medições e lance pastejo e outras operações.",
		step4Title: "Acompanhe máquinas e finanças",
		step4Description:
			"Adicione suas máquinas ao cadastro de equipamentos e registre receitas e despesas no Centro Financeiro para acompanhar lucro e fluxo de caixa.",
		step5Title: "Planeje sua operação",
		step5Description:
			"Use o Planejamento para definir objetivos anuais e táticos, divida-os em tarefas no quadro ou no calendário e atribua-as à sua equipe.",
		step6Title: "Consulte análises da fazenda",
		step6Description:
			"Faça uma análise de viabilidade para uma operação de cria e peça recomendações ao assistente de IA sobre toda a sua fazenda.",

		// Visão geral do Guia do Usuário
		userGuideOverview: "Guia do Usuário",
		userGuideOverviewDescription:
			"Explore os guias de cada parte do RuralOps. Escolha um tópico para entender o que ele faz e as principais ações disponíveis.",
		overviewLabel: "Visão geral",
		whatYouCanDo: "O que você pode fazer",

		// Guia — Fazendas
		guideEstablishmentsTitle: "Fazendas",
		guideEstablishmentsDescription:
			"Selecione, crie e gerencie as fazendas da sua organização",
		farmGuide: {
			intro:
				"As fazendas organizam seus animais, piquetes, equipamentos e registros financeiros. Use o seletor para escolher quais fazendas deseja visualizar e a gestão de fazendas para manter os dados cadastrais de cada uma.",
			contents: "Neste guia",
			screenshotsNote:
				"As capturas de tela mostram dados de exemplo da aplicação local.",
			enlargeImage: "Abrir captura de tela em tamanho original",
			selectorTitle: "Escolha uma fazenda na barra superior",
			selectorIntro:
				"O seletor de fazendas define quais dados aparecem nas páginas operacionais da organização. Alterar a seleção não modifica os dados cadastrais da fazenda.",
			selectorStep1:
				"Em uma página operacional, abra o seletor de fazendas na barra de navegação superior.",
			selectorStep2:
				"Escolha uma fazenda para visualizar seus registros. A lista mostra apenas as fazendas às quais você tem acesso.",
			selectorStep3:
				"Escolha Todas as Fazendas para visualizar os registros das fazendas às quais você tem acesso.",
			selectorNote:
				"O seletor fica desativado nas configurações da organização, onde você gerencia a organização em vez de uma única fazenda.",
			selectorCaption:
				"O seletor na barra superior permite escolher uma fazenda ou Todas as Fazendas, com atalhos para criar e editar fazendas quando você tem permissão.",
			managementTitle: "Encontre e gerencie suas fazendas",
			managementIntro:
				"Abra Configurações → Fazendas para consultar as fazendas da organização e manter seus dados atualizados.",
			managementStep1:
				"Use o campo de busca para encontrar uma fazenda pelo nome.",
			managementStep2:
				"Confira o nome, a descrição, o endereço e o telefone da fazenda. Use os controles de paginação para ver mais fazendas.",
			managementStep3:
				"Selecione a linha da fazenda ou o ícone de lápis para editá-la. No celular, selecione o cartão da fazenda.",
			managementCaption:
				"A página Fazendas nas configurações reúne a lista de fazendas, a busca, a paginação e a ação Criar Novo.",
			createTitle: "Crie uma fazenda",
			createIntro:
				"Comece pela opção Criar fazenda no seletor da barra superior ou escolha Criar Novo na página Fazendas das configurações.",
			createStep1: "Informe um nome que facilite a identificação da fazenda.",
			createStep2:
				"Em Cidade, digite pelo menos dois caracteres e selecione uma cidade nos resultados. Confira o estado para escolher a localização correta.",
			createStep3:
				"Preencha endereço, telefone, e-mail e descrição, se necessário. Esses campos são opcionais.",
			createStep4:
				"Escolha Salvar fazenda. O botão fica disponível após informar um nome e selecionar uma cidade.",
			createNote:
				"Digitar um endereço não seleciona uma cidade. Escolha uma cidade nos resultados da busca para que os recursos de localização, incluindo a previsão do tempo, possam usá-la. Uma fazenda criada pelo seletor passa a ser a fazenda selecionada; uma fazenda criada nas configurações aparece na lista.",
			createCaption:
				"O formulário de criação pede um nome e uma cidade selecionada nos resultados da busca; os dados de contato e a descrição são opcionais.",
			editTitle: "Edite uma fazenda",
			editIntro:
				"Abra uma fazenda na lista das configurações ou use o lápis ao lado do nome dela no seletor da barra superior.",
			editStep1:
				"Confira o formulário, que abre preenchido com os dados atuais da fazenda.",
			editStep2:
				"Altere os dados necessários. Se uma fazenda antiga não tiver uma cidade selecionada, busque e selecione uma antes de salvar.",
			editStep3:
				"Escolha Atualizar fazenda para salvar ou Cancelar para fechar o formulário sem salvar as alterações.",
			editNote:
				"A edição atualiza os dados cadastrais da fazenda. Para mudar quais registros você está visualizando, use o seletor da barra superior.",
			editCaption:
				"O formulário de edição mostra os dados atuais da fazenda e as ações Atualizar fazenda e Cancelar.",
			permissionsTitle: "Não encontra a opção de criar ou editar?",
			permissionsBody:
				"Criar e editar fazendas exige permissão para gerenciar fazendas. Se essas ações não estiverem disponíveis, peça ao proprietário da organização para revisar seu acesso.",
		},

		// Guia — Rebanho
		guideLivestockTitle: "Rebanho",
		guideLivestockDescription:
			"Acompanhe seus lotes, animais, saúde e reprodução",
		livestockGuide: {
			intro:
				"Use o Rebanho para organizar lotes, cadastrar animais e acompanhar registros de peso, saúde e reprodução. Comece escolhendo uma fazenda e abra um lote ou animal para trabalhar com seus detalhes.",
			contents: "Neste guia",
			screenshotsNote:
				"As capturas mostram dados de exemplo da aplicação local.",
			enlargeImage: "Abrir captura em tamanho original",
			overviewTitle: "Escolha a fazenda e explore o Rebanho",
			overviewIntro:
				"A página de Rebanho reúne os lotes e animais das fazendas às quais você tem acesso.",
			overviewStep1: "Abra Rebanho na navegação principal.",
			overviewStep2:
				"Use o seletor da barra superior para escolher uma fazenda ou Todas as Fazendas para consultar os registros das fazendas às quais você tem acesso.",
			overviewStep3:
				"Alterne entre Lotes e Animais. Abra um lote ou animal para consultar seus detalhes e registros.",
			overviewNote:
				"Ao criar um lote, adicionar um animal ou importar com Todas as Fazendas selecionado, escolha a fazenda de destino antes de continuar.",
			overviewCaption:
				"A página de Rebanho mostra a seleção de fazendas, as abas Lotes e Animais e as ações de cadastro disponíveis.",
			herdsTitle: "Crie e gerencie um lote",
			herdsIntro:
				"Os lotes agrupam animais para o manejo do dia a dia. Crie o lote e depois adicione seus animais.",
			herdsStep1:
				"Na aba Lotes, escolha Criar lote e confirme a fazenda de destino, se solicitado.",
			herdsStep2:
				"Informe o nome do lote. Se necessário, adicione finalidade, raça predominante, sistema de manejo ou dados de planejamento e escolha Criar lote.",
			herdsStep3:
				"Abra o lote para consultar seus animais e registros. Use Editar para atualizar os detalhes e os controles da lista de animais para gerenciar seus integrantes.",
			herdsNote:
				"O nome é o único campo obrigatório do lote. A alocação e a rotação de piquetes estão disponíveis nos detalhes do lote, conforme sua permissão.",
			herdsCaption:
				"O formulário do lote começa pelo nome e oferece campos opcionais de finalidade, raça, manejo e planejamento.",
			animalsTitle: "Encontre animais e filtre a lista",
			animalsIntro:
				"Use a aba Animais para encontrar um animal ou um grupo que precisa de atenção.",
			animalsStep1:
				"Busque por brinco ou raça dentro da seleção atual de fazendas.",
			animalsStep2:
				"Use os filtros rápidos para grupos como bezerros ou animais sem pesagem recente. Abra os filtros avançados para refinar a busca.",
			animalsStep3:
				"Abra um animal nos resultados para consultar seus detalhes. Limpe os filtros quando quiser voltar à lista mais ampla.",
			animalsNote:
				"Quando permitido, selecionar animais exibe ações em lote. Para uma lista de animais já existente, use Importar e revise as informações extraídas antes de concluir a importação.",
			animalsCaption:
				"A lista de animais combina busca, filtros rápidos e filtros avançados com acesso aos detalhes de cada animal.",
			createTitle: "Cadastre um animal",
			createIntro:
				"Escolha Adicionar animal na aba Animais. Se Todas as Fazendas estiver selecionado, escolha a fazenda do animal.",
			createStep1:
				"Informe o número do brinco, selecione o sexo e informe a data de nascimento. Resolva qualquer aviso de brinco já utilizado.",
			createStep2:
				"Abra os detalhes opcionais de que precisar, como raça, lote ou origem, e preencha as informações disponíveis.",
			createStep3:
				"Escolha Criar animal para salvar ou Criar e próximo para salvar e começar outro cadastro.",
			createNote:
				"Para registrar um nascimento e vincular o bezerro à mãe, use a opção de parto em Registro na página de detalhes da mãe.",
			createCaption:
				"O cadastro do animal começa pelo número do brinco, sexo e data de nascimento; os demais detalhes são opcionais.",
			detailTitle: "Consulte e edite um animal",
			detailIntro:
				"A página de detalhes reúne a identificação, o histórico de peso, as informações de cuidados e os registros do animal.",
			detailStep1:
				"Abra o animal pela aba Animais ou pela lista de animais do lote e confira o número do brinco.",
			detailStep2:
				"Consulte o gráfico de peso, as informações disponíveis de saúde e reprodução e a linha do tempo de registros.",
			detailStep3:
				"Escolha Editar para corrigir ou completar o cadastro e depois Salvar alterações. Use Cancelar para sair sem salvar.",
			detailNote:
				"Use Registro para uma nova pesagem, vacinação ou outro evento. Use Editar para alterar os dados cadastrais do animal.",
			detailCaption:
				"Os detalhes do animal mostram sua identificação, peso e cuidados, com acesso à edição e aos registros.",
			recordsTitle: "Registre pesagens, saúde e reprodução",
			recordsIntro:
				"Inicie o registro pelo animal ou lote com que está trabalhando para abrir o formulário com esse destino selecionado.",
			recordsStep1:
				"Abra os detalhes do animal ou lote, encontre a seção de registros e escolha Registro.",
			recordsStep2:
				"Busque ou selecione o tipo de registro, como peso, vacinação, tratamento ou um evento reprodutivo.",
			recordsStep3:
				"Confira o animal ou lote e a data, preencha os campos do tipo escolhido e salve. Consulte o novo registro na linha do tempo.",
			recordsNote:
				"Os tipos disponíveis dependem de você ter aberto um animal ou lote e, para animais, do sexo. O fluxo de parto também cadastra o bezerro.",
			recordsCaption:
				"O seletor de registros agrupa as atividades e medições disponíveis e permite buscar por tipo.",
			permissionsTitle:
				"Não encontrou uma ação de cadastro, edição ou registro?",
			permissionsBody:
				"Criar lotes e animais, importar e registrar alterações exige permissão para gerenciar a pecuária. Se essas ações não estiverem disponíveis, peça ao proprietário da organização para revisar seu acesso.",
		},
		guideLivestockOverview:
			"O módulo de rebanho é o seu cadastro de animais. Agrupe animais em lotes, registre detalhes individuais e mantenha um histórico completo de eventos de saúde, reprodução e linhagem de cada animal.",
		guideLivestockTask1: "Crie lotes e registre animais individuais",
		guideLivestockTask2: "Registre eventos de saúde e prontuários",
		guideLivestockTask3: "Acompanhe reprodução e linhagem",
		guideLivestockTask4:
			"Monitore o tamanho do rebanho e a mortalidade ao longo do tempo",
		guideLivestockTip:
			"O rebanho é por fazenda — selecione uma fazenda primeiro para ver e gerenciar seus animais.",

		// Guia — Produção de Pasto
		guideGrassProductionTitle: "Piquetes",
		guideGrassProductionDescription:
			"Encontre, crie e gerencie piquetes e seus registros de campo",
		paddockGuide: {
			intro:
				"Use Piquetes para organizar as áreas de pasto de cada fazenda, manter seus limites e acompanhar cultivares, pastejo, medições e manejos.",
			contents: "Neste guia",
			screenshotsNote:
				"As capturas de tela mostram dados de exemplo da aplicação local.",
			enlargeImage: "Abrir captura de tela em tamanho completo",
			listTitle: "Encontre seus piquetes",
			listIntro:
				"Abra Piquetes na navegação principal para ver as áreas de pasto das fazendas às quais você tem acesso.",
			listStep1:
				"Use o seletor na barra superior para escolher uma fazenda, ou Todas as Fazendas para ver os piquetes das fazendas às quais você tem acesso.",
			listStep2:
				"Use a busca para encontrar um piquete. Confira nome, fazenda, área, status e cultivares na lista.",
			listStep3:
				"Selecione a linha ou o cartão de um piquete para abrir seus detalhes, informações de pastejo e registros.",
			listStep4:
				"Escolha Criar Piquete para adicionar uma área. Ao visualizar Todas as Fazendas, selecione a fazenda de destino antes de continuar.",
			listNote:
				"Capins e forrageiras abre o catálogo de cultivares da organização. Após criar o piquete, associe suas cultivares na página de detalhes.",
			listCaption:
				"A página de Piquetes mostra os indicadores, a lista com busca e a ação Criar Piquete.",
			createTitle: "Crie um piquete",
			createIntro:
				"Escolha Criar Piquete e confirme a fazenda à qual ele pertence.",
			createStep1:
				"Informe um nome fácil de reconhecer. Adicione um código se necessário; você também pode selecionar o código sugerido.",
			createStep2:
				"Informe uma área maior que zero em hectares, ou desenhe o limite no mapa para calculá-la. O limite é opcional.",
			createStep3:
				"Confira o tipo de uso e o status. Informe o tipo de solo se necessário e expanda Mais detalhes para preencher declividade e metas de produção, qualidade da forragem e aproveitamento.",
			createStep4:
				"Escolha Criar Piquete para salvar. Se o formulário indicar um valor ausente ou inválido, corrija-o e envie novamente.",
			createNote:
				"Quando a área vem do mapa, a opção de informar manualmente permite substituí-la. Confira os hectares antes de salvar; a área informada manualmente tem prioridade sobre o cálculo do limite.",
			createCaption:
				"O formulário de criação reúne identificação, área e uso do piquete com um mapa opcional de limites.",
			editTitle: "Edite os dados do piquete",
			editIntro:
				"Abra um piquete pela lista e escolha Editar na página de detalhes.",
			editStep1:
				"Confira nome, código, área, tipo de uso e status já cadastrados.",
			editStep2:
				"Atualize os campos necessários. Ajuste o limite no mapa ou informe a área manualmente, conforme o caso.",
			editStep3:
				"Expanda Mais detalhes para revisar a declividade e as metas de produção ou qualidade, quando necessário.",
			editStep4:
				"Escolha Salvar para aplicar as alterações, ou Cancelar para sair do formulário sem salvar.",
			editNote:
				"Se houver um limite salvo, o formulário de edição recalcula a área pelo mapa ao abrir. Confira os hectares antes de salvar e use informar manualmente se necessário. Cultivares e registros de campo são gerenciados separadamente na página de detalhes.",
			editCaption:
				"O formulário de edição abre com os dados e o limite salvos do piquete, além das ações Salvar e Cancelar.",
			recordsTitle: "Acompanhe cultivares, pastejo e registros",
			recordsIntro:
				"A aba Resumo do piquete reúne seus indicadores, cultivares, pastejo e histórico de campo.",
			recordsStep1:
				"Em Capins e forrageiras, use Gerenciar para selecionar cultivares e informar sua cobertura. Cadastre uma cultivar ausente pelo link do catálogo e salve as associações.",
			recordsStep2:
				"Confira Lotes no piquete e Registros. Use os filtros de registros para focar em colheita ou fertilidade e a opção de mostrar mais antigos para expandir o histórico, quando disponível.",
			recordsStep3:
				"Escolha Registrar no cartão Registros e selecione uma medição do pasto ou um manejo, como pastejo, adubação ou corte. Para uma medição, informe a data e a altura do pasto; adicione biomassa e observações se disponíveis. Para um manejo, confira tipo, data e campos correspondentes e salve.",
			recordsStep4:
				"Abra Solo e Fertilidade para consultar análises de solo e recomendações para o piquete.",
			recordsNote:
				"A soma da cobertura das cultivares não pode ultrapassar 100%. Registre as datas reais e confira as unidades para manter o histórico útil nas decisões do dia a dia.",
			recordsCaption:
				"A página de detalhes do piquete reúne cultivares, pastejo, registros e a aba Solo e Fertilidade.",
			permissionsTitle: "Não encontra uma ação ou um registro?",
			permissionsBody:
				"O acesso depende das fazendas disponíveis para você e das suas permissões. Gerenciar piquetes, visualizar registros e criar medições ou manejos usam permissões separadas. Peça ao proprietário da organização para revisar seu acesso se algo estiver indisponível.",
		},
		guideGrassProductionOverview:
			"A produção de pasto ajuda você a gerenciar suas pastagens. Defina piquetes, meça a forragem disponível e lance operações como pastejo, adubação e corte para manter seu plano de pastejo em dia.",
		guideGrassProductionTask1: "Crie piquetes e informe área e cultivar",
		guideGrassProductionTask2: "Adicione medições de biomassa e altura",
		guideGrassProductionTask3: "Lance operações como pastejo, adubação e corte",
		guideGrassProductionTask4:
			"Acompanhe alertas, análise de solo e previsões de crescimento",
		guideGrassProductionTip:
			"Mantenha as medições atualizadas para que previsões e recomendações fiquem precisas.",

		// Guia — Equipamentos
		guideEquipmentTitle: "Equipamentos",
		guideEquipmentDescription:
			"Mantenha um inventário das suas máquinas e da manutenção",
		guideEquipmentOverview:
			"O módulo de equipamentos é um inventário das máquinas e ativos da sua fazenda. Acompanhe onde está cada unidade, programe e registre manutenções e mantenha sua frota organizada entre as fazendas.",
		guideEquipmentTask1:
			"Cadastre equipamentos e vincule-os a uma fazenda e local",
		guideEquipmentTask2:
			"Registre o histórico de manutenção e as próximas revisões",
		guideEquipmentTask3: "Acompanhe a localização atual de cada unidade",
		guideEquipmentTask4: "Veja sua frota em todas as fazendas",
		guideEquipmentTip:
			"Registrar a manutenção conforme ela acontece mantém um histórico útil de cada máquina.",

		// Guia — Financeiro
		guideFinancialTitle: "Centro Financeiro",
		guideFinancialDescription:
			"Registre lançamentos e acompanhe lucro e fluxo de caixa",
		guideFinancialOverview:
			"O Centro Financeiro é onde você registra receitas e despesas e vê o desempenho da fazenda. Categorize os lançamentos, analise o resultado (lucro e prejuízo) e acompanhe o fluxo de caixa em qualquer período.",
		guideFinancialTask1: "Registre lançamentos de receita e despesa",
		guideFinancialTask2: "Organize os lançamentos por categoria",
		guideFinancialTask3: "Analise relatórios de resultado e fluxo de caixa",
		guideFinancialTask4: "Analise os resultados por período e por fazenda",
		guideFinancialTip:
			"A moeda da sua organização é definida na criação. Escolha um conjunto consistente de categorias desde o início para que seus relatórios sejam comparáveis ao longo do tempo.",

		// Guia — Planejamento
		guidePlanningTitle: "Planejamento e Tarefas",
		guidePlanningDescription:
			"Defina objetivos e organize o trabalho em tarefas",
		guidePlanningOverview:
			"O Planejamento transforma metas em ação. Defina objetivos anuais e táticos, divida-os em tarefas que você acompanha em quadro, lista ou calendário e atribua-as à sua equipe.",
		guidePlanningTask1: "Crie objetivos anuais e táticos",
		guidePlanningTask2: "Adicione tarefas e atribua-as a membros da equipe",
		guidePlanningTask3:
			"Acompanhe o trabalho no quadro Kanban, lista ou calendário",
		guidePlanningTask4:
			"Use o planejador de rotação para programar as trocas de pasto",
		guidePlanningTip:
			"Vincule tarefas a objetivos para acompanhar o progresso em direção às suas metas maiores.",

		// Guia — Viabilidade
		guideFeasibilityTitle: "Análise de Viabilidade",
		guideFeasibilityDescription: "Modele a viabilidade de uma operação de cria",
		guideFeasibilityOverview:
			"A análise de viabilidade ajuda você a decidir se uma operação de cria faz sentido antes de investir. Informe suas premissas de rebanho, forragem, reprodução, nutrição e comerciais e o RuralOps calcula um veredito financeiro.",
		guideFeasibilityTask1: "Defina o tamanho e a estrutura do rebanho",
		guideFeasibilityTask2:
			"Defina premissas de forragem, reprodução e nutrição",
		guideFeasibilityTask3: "Adicione dados comerciais como preços e custos",
		guideFeasibilityTask4:
			"Analise o veredito calculado e os números principais",
		guideFeasibilityTip:
			"Teste alguns cenários com premissas diferentes para entender o que mais influencia o resultado.",

		// Guia — Marketplace
		guideMarketplaceTitle: "Compra e venda",
		guideMarketplaceDescription: "Compre e venda animais com outros produtores",
		guideMarketplaceOverview:
			"A área de compra e venda conecta você a outros produtores para negociar animais. Consulte os anúncios, use os filtros, anuncie seus animais e acompanhe as solicitações recebidas e enviadas.",
		guideMarketplaceTask1:
			"Navegue pelas ofertas e filtre por região, raça, preço e saúde",
		guideMarketplaceTask2: "Crie uma oferta para vender seus animais",
		guideMarketplaceTask3: "Faça uma solicitação de compra em uma oferta",
		guideMarketplaceTask4: "Gerencie suas solicitações recebidas e enviadas",
		guideMarketplaceTip:
			"Preencha os detalhes de saúde e dos animais nas suas ofertas para atrair compradores mais sérios.",

		// Guia — Assistente de IA
		guideAssistantTitle: "Assistente de IA",
		guideAssistantDescription:
			"Faça perguntas e receba recomendações para a fazenda",
		guideAssistantOverview:
			"O assistente de IA responde perguntas sobre a sua operação e sugere próximos passos. Pergunte sobre uma fazenda específica ou sobre todas elas e use as sugestões de perguntas para começar.",
		guideAssistantTask1:
			"Faça perguntas sobre a sua fazenda em linguagem natural",
		guideAssistantTask2: "Direcione a conversa para uma fazenda ou para todas",
		guideAssistantTask3:
			"Use as perguntas sugeridas para obter respostas rápidas",
		guideAssistantTask4: "Aja com base nas recomendações em todos os módulos",
		guideAssistantTip:
			"Quanto mais dados você registra no RuralOps, mais úteis ficam as respostas do assistente.",

		// Suporte — layout / abas
		supportTitle: "Suporte",
		submitTicket: "Abrir Chamado",
		myTickets: "Meus Chamados",

		// Suporte — formulário
		supportFormIntro:
			"Conte como podemos ajudar. Escolha um tipo e descreva seu pedido.",
		supportRequestHint: "Peça ajuda com o RuralOps",
		supportSuggestionHint: "Compartilhe uma ideia de melhoria",
		supportComplaintHint: "Conte o que deu errado",
		supportDescriptionPrompt:
			"O que você estava tentando fazer?\nO que aconteceu e o que você esperava?",
		supportPrivacyHint: "Não inclua senhas ou dados de pagamento.",
		supportRequiredHint: "* Campos obrigatórios",
		supportGuidanceTitle: "Ajude a gente a entender",
		supportGuidanceWhere: "Diga em qual página ou funcionalidade você estava.",
		supportGuidanceSteps: "Descreva os passos e a mensagem de erro, se houver.",
		supportGuidanceExpected: "Explique o que você esperava que acontecesse.",
		supportFollowUpTitle: "Continue a conversa",
		supportFollowUpDescription:
			"Já abriu um chamado sobre isso? Adicione um comentário nele. Acompanhe as respostas e o andamento em Meus chamados.",
		supportSuccessTitle: "Seu chamado foi enviado",
		supportSuccessDescription:
			"Acompanhe o andamento e continue a conversa com nossa equipe em Meus chamados.",
		supportAnotherTicket: "Abrir outro chamado",
		supportFormTitle: "Abrir um chamado de suporte",
		supportFieldTitle: "Título",
		supportFieldType: "Tipo",
		supportFieldDescription: "Descrição",
		supportPlaceholderTitle: "Resuma seu pedido em poucas palavras",
		supportPlaceholderType: "Selecione um tipo",
		supportPlaceholderDescription: "Descreva seu pedido em detalhes",
		supportHintTitle: "Um título curto e claro ajuda a responder mais rápido.",
		supportHintType: "Escolha a opção que melhor descreve o seu chamado.",
		supportHintDescription:
			"Inclua passos, contexto ou qualquer coisa que ajude a entender.",
		supportTypeRequest: "Solicitação",
		supportTypeSuggestion: "Sugestão",
		supportTypeComplaint: "Reclamação",
		supportCharacterCountTitle: "Título",
		supportCharacterCountDescription: "Descrição",
		supportSubmit: "Abrir Chamado",
		supportSubmitting: "Enviando...",

		// Suporte — lista de chamados
		noTickets: "Nenhum chamado ainda",
		noTicketsDescription:
			"Você ainda não abriu nenhum chamado de suporte. Abra um e a nossa equipe vai te responder.",
		statusOpen: "Aberto",
		statusWaitingForUser: "Aguardando Você",
		statusWaitingForStaff: "Aguardando Suporte",
		statusResolved: "Resolvido",
		statusClosed: "Fechado",

		// Suporte — detalhe do chamado
		ticketDetails: "Chamado",
		ticketInformation: "Informações do Chamado",
		comments: "Comentários",
		noComments: "Nenhum comentário ainda",
		addComment: "Adicionar um comentário",
		commentPlaceholder: "Escreva um comentário...",
		commentSubmitting: "Enviando...",
		supportTeam: "Equipe de Suporte",
		staff: "Equipe",
		you: "Você",
	},
	weather: {
		matrix: {
			today: "Hoje",
			moreFarms_one: "mais {{count}} fazenda · ordenado pela chuva prevista",
			moreFarms_other: "mais {{count}} fazendas · ordenado pela chuva prevista",
			sortedByRain: "Ordenado pela chuva prevista",
			showFewer: "Mostrar menos",
			seeAllFarms: "Ver todas as {{count}} fazendas",
			farm: "Fazenda",
			now: "Agora",
			conditions: "Condições",
			nextDays_one: "Próximo dia",
			nextDays_other: "Próximos {{count}} dias",
		},
		title: "Clima",
		details: {
			// Each label names the site it actually opens. The destination depends
			// on what we know about the farm — Climatempo when we have the
			// municipality, Windy by coordinates otherwise — and a link that says
			// one name and opens the other is a small lie.
			climatempo: "Ver no Climatempo",
			windy: "Ver no Windy",
		},
		refresh: "Atualizar clima",
		retry: "Tentar novamente",
		noFarms: "Nenhuma fazenda no filtro atual para mostrar o clima.",
		truncated:
			"Mostrando o clima das primeiras {{shown}} fazendas. Selecione uma fazenda para ver as demais.",
		temperature: "{{value}} °C",
		range: "{{max}}° / {{min}}°",
		percent: "{{value}}%",
		millimetres: "{{value}} mm",
		kph: "{{value}} km/h",
		humidity: "Umidade",
		precipitation: "Chuva",
		wind: "Vento",
		notReported: "Não informado",
		horizonShort_one:
			"Este provedor entregou apenas {{served}} dia dos {{requested}} solicitados.",
		horizonShort_other:
			"Este provedor entregou apenas {{served}} dias dos {{requested}} solicitados.",
		thisFarm: "Esta fazenda",
		locationMissing: {
			message:
				"Esta fazenda ainda não tem localização cadastrada, então não conseguimos buscar o clima.",
			action: "Definir a cidade da fazenda",
		},
		unavailable: {
			message:
				"Não conseguimos falar com nenhum provedor de clima agora. Os dados da fazenda seguem intactos.",
		},
		condition: {
			CLEAR: "Céu limpo",
			PARTLY_CLOUDY: "Parcialmente nublado",
			CLOUDY: "Nublado",
			FOG: "Neblina",
			DRIZZLE: "Garoa",
			RAIN: "Chuva",
			HEAVY_RAIN: "Chuva forte",
			SNOW: "Neve",
			THUNDERSTORM: "Tempestade",
			UNKNOWN: "Condição não informada",
		},
		attribution: {
			open_meteo: "Fonte: Open-Meteo",
			google_weather: "Fonte: inclui dados meteorológicos do Google",
			openweathermap: "Fonte: OpenWeatherMap",
		},
	},
};

export default translations;
